import { makeObservable, observable, computed, action, override } from 'mobx';

import * as JSFUNC from "../../Library/JSFUNC.js";
import * as JSPHP from '../../CaptureExecLocalDatabaseMobx/JSPHP.js';

import DatabaseMobx from '../../CaptureExecLocalDatabaseMobx/DatabaseMobx.js';
import UserMobx from '../../CaptureExecLocalDatabaseMobx/UserMobx.js';

import CaptureExecMobx from '../CaptureExec/CaptureExecMobx.js';
import CapturesMobx from '../Captures/CapturesMobx.js';

class DivexecMobx {
  //========================================================================================
  //observable values
  o_performanceSelectedUserTrueDivisionFalse = undefined;
  o_performanceSelectedUserOrDivisionID = undefined;
  o_performanceSelectedCustomPerformanceOptionID = -1;
  o_performanceMobileScreen = "graphs"; //"graphs" - viewing graphs, "selectUserOrDivision" - selecting User/Division from the tree (takes up whole screen in mobile mode)
  o_performanceGoalsGraphOptionsExpandedTF = false;
  o_performanceSelectedFyrToViewEdit = undefined; //undefined - no floating box open to view/edit fyr quotas, -1 - choosing which year to view/edit, fyr > 0 - view/edit that year
  o_performanceViewFyrSelectedCapturesToViewObjOrUndefined = undefined; //obj set when # Captures is clicked to view the captures table that make up the actual achieved for won/submitted / y/q/m / bin #

  o_finProjSelectedSubTabDbName = "finProjTableAndGraph"; //"finProjTableAndGraph", "finProjCapturesList"
  o_finProjGraphOptionsExpandedTF = false;
  o_finProjGraphEditingGoalFyr = JSFUNC.now_year_int();
  o_finProjMaxNumCaptures = 25;

  o_dailySnapshotSelectedPageID = undefined;
  o_trendAnalyzerSelectedPageID = undefined;
  o_graphsCreatingNewGraphTF = false;
  o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName = "public"; //"public", "system"
  o_graphsEditingGraphID = undefined;

  o_hotBitsSelectedCaptureFieldIDOrUndefned = undefined;

  o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned = undefined;
  o_criticalThresholdsSelectedGraphString = "criticalProgressThreshold"; //"criticalProgressThreshold", "criticalPwinThreshold", "pwinVsProgress"

  o_stageFlowThinTblCLogStagesArrayOfObjs = undefined; //tbl_c_log_stages  [{ci:1,si:1}]  ci=capture_id, si=stage_id  ordered by datetime, (undefined - flag that this table is not yet loaded from the database)
  o_stageFlowSelectedFilterCaptureTypeIDOrUndefined = undefined;
  o_stageFlowSelectedFilterStageTypeString = "closed"; //"closed", "active", "all"

  o_gateReviewApprovalsLogStagesArrayOfObjs = undefined; //every Gate Review action row (action_cs0_grreq1_grapp2_grrej3_grcan4 of 1/2/3/4) from tbl_c_log_stages across all captures, sorted oldest first by id, (undefined - flag that this data is not yet loaded from the database)
  o_gateReviewApprovalsIsLoadingTF = false;
  o_gateReviewApprovalsActionPendingObjOrUndefined = undefined; //obj set when the floating box to Approve/Reject a Gate Review request from this list is open

  constructor() {
    makeObservable(this, {
      o_performanceSelectedUserTrueDivisionFalse: observable,
      o_performanceSelectedUserOrDivisionID: observable,
      o_performanceSelectedCustomPerformanceOptionID: observable,
      o_performanceMobileScreen: observable,
      o_performanceGoalsGraphOptionsExpandedTF: observable,
      o_performanceSelectedFyrToViewEdit: observable,
      o_performanceViewFyrSelectedCapturesToViewObjOrUndefined: observable,
      o_finProjSelectedSubTabDbName: observable,
      o_finProjGraphOptionsExpandedTF: observable,
      o_finProjGraphEditingGoalFyr: observable,
      o_finProjMaxNumCaptures: observable,
      o_dailySnapshotSelectedPageID: observable,
      o_trendAnalyzerSelectedPageID: observable,
      o_graphsCreatingNewGraphTF: observable,
      o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName: observable,
      o_graphsEditingGraphID: observable,
      o_hotBitsSelectedCaptureFieldIDOrUndefned: observable,
      o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned: observable,
      o_criticalThresholdsSelectedGraphString: observable,
      o_stageFlowThinTblCLogStagesArrayOfObjs: observable,
      o_stageFlowSelectedFilterCaptureTypeIDOrUndefined: observable,
      o_stageFlowSelectedFilterStageTypeString: observable,
      o_gateReviewApprovalsLogStagesArrayOfObjs: observable,
      o_gateReviewApprovalsIsLoadingTF: observable,
      o_gateReviewApprovalsActionPendingObjOrUndefined: observable,

      c_divexecFilteredCapturesObj: computed,
      c_performanceSelectedUserOrDivisionString: computed,
      c_performanceSelectedUserOrDivisionName: computed,
      c_performanceDivisionsWithUsersArrayOfObjs: computed,
      c_performanceCustomPerformanceCaptureFieldFieldTypeObj: computed,
      c_performanceGraphSelectedStageIDsArray: computed,
      c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined: computed,
      c_performanceCustomPerformanceCaptureFieldOptionsFieldTypeObj: computed,
      c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined: computed,
      c_performanceUserSelectedMoneyFieldDisplayName: computed,
      c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs: computed,
      c_performanceSelectedUserOrDivisionIDsCommaString: computed,
      c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs: computed,
      c_performanceLowestHighestNumFyrToDisplayInGraphsObj: computed,
      c_performanceQuotaGraphObj: computed,
      c_performanceEditingSingleQuotaFyrYqmDataObj: computed,
      c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined: computed,
      c_performanceGraphsDataArrayOfObjs: computed,
      c_myPerformanceMoneyFieldIDsToNotIncludeArray: computed,
      c_finProjObj: computed,
      c_finProjYearlyGraphObj: computed,
      c_finProjEditingWaterfallGoalSingleFyrYqmObjOrUndefined: computed,
      c_tabDailySnapshotTrueTrendAnalyzerFalse: computed,
      c_dailySnapshotPagesArrayOfObjs: computed,
      c_trendAnalyzerPagesArrayOfObjs: computed,
      c_dailySnapshotGraphsArrayOfObjs: computed,
      c_trendAnalyzerGraphsArrayOfObjs: computed,
      c_graphsSelectedTabName: computed,
      c_graphsSelectedTabPagesTblName: computed,
      c_graphsSelectedTabGraphsTblName: computed,
      c_graphsSelectedTabAllPagesArrayOfObjs: computed,
      c_graphsSelectedTabAllGraphsArrayOfObjs: computed,
      c_graphsSelectedTabUserAllAddedPageIDsArray: computed,
      c_graphsSelectedTabUserAllAddedGraphIDsObjOfArrays: computed,
      c_graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs: computed,
      c_graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs: computed,
      c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj: computed,
      c_graphsSelectedTabAllSystemGraphsDataPerUserCreatorArrayOfObjs: computed,
      c_graphsSelectedPageID: computed,
      c_graphsSelectedPageObj: computed,
      c_graphsSelectedPageIsReplicaOfPublicPageTF: computed,
      c_graphsSelectedPageNumGraphsPerRow: computed,
      c_graphsSelectedPageGraphHeightEm: computed,
      c_graphsSelectedPageGraphsDataArrayOfObjs: computed,
      c_graphsEditingGraphDataObj: computed,
      c_graphsSelectNumGraphsPerRowFieldTypeObj: computed,
      c_graphsSelectGraphHeightsFieldTypeObj: computed,
      c_graphsSelectFilterPresetFieldTypeObj: computed,
      c_selectCategoryCaptureFieldFieldTypeObj: computed,
      c_graphsSelectAllCategoriesTFFieldTypeObj: computed,
      c_graphsEditingGraphSelectMultiCategoriesOptionsFieldTypeObj: computed,
      c_hotBitsObj: computed,
      c_criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs: computed,
      c_criticalProgressThresholdScatterPlotDataArrayOfObjs: computed,
      c_criticalPwinThresholdScatterPlotDataArrayOfObjs: computed,
      c_pwinVsProgressScatterPlotDataArrayOfObjs: computed,
      c_stageFlowCaptureIDsWithinSelectedFilterCaptureTypeArray: computed,
      c_stageFlowStageIDsPerCaptureIDMapOfArrays: computed,
      c_stageFlowDataPerStageArrayOfObjs: computed,
      c_gateReviewApprovalsPendingRequestsArrayOfObjs: computed,
      c_excelReportTemplatesWithinFoldersObj: computed,

      a_performance_set_selected_user_or_division_id: action,
      a_performance_set_selected_custom_performance_option_id: action,
      a_performance_set_mobile_screen: action,
      a_performance_set_goals_graph_options_expanded_tf: action,
      a_performance_set_selected_fyr_to_view_edit: action,
      a_performance_set_view_fyr_selected_captures_to_view_obj_or_undefined: action,
      a_performance_update_or_insert_fyr_quota: action,
      a_performance_generate_all_quotas_csv_arrayOfArrays: action,
      a_finproj_set_selected_subtab: action,
      a_finproj_set_graph_options_expanded_tf: action,
      a_finproj_set_graph_editing_goal_fyr: action,
      a_finproj_set_max_num_captures: action,
      a_graphs_set_selected_page_id: action,
      a_graphs_initialize_selected_page_id_to_first_option: action,
      a_graphs_create_new_page: action,
      a_graphs_delete_page_and_graphs_from_page_id: action,
      a_graphs_add_public_page_as_replica_or_system_page_as_new_page: action,
      a_graphs_copy_page: action,
      a_graphs_create_new_graph: action,
      a_graphs_add_public_graph_as_replica_or_system_graph_as_new: action,
      a_graphs_set_creating_new_graph_tf: action,
      a_graphs_set_creating_page_or_graph_selected_public_system_tab_db_name: action,
      a_graphs_set_editing_graph_id: action,
      a_graphs_update_page_field: action,
      a_graphs_update_graph_field: action,
      a_graphs_copy_graph: action,
      a_graphs_delete_graph: action,
      a_hot_bits_set_selected_capture_field_id: action,
      a_critical_thresholds_set_selected_filter_capture_type_id: action,
      a_critical_thresholds_set_selected_graph_string: action,
      a_stage_flow_load_thin_log_stages: action,
      a_stage_flow_set_thin_tbl_c_log_stages_arrayOfObjs: action,
      a_stage_flow_set_selected_filter_capture_type_id: action,
      a_stage_flow_set_selected_filter_stage_type_string: action,
      a_gate_review_approvals_load_log_stages: action,
      a_gate_review_approvals_set_log_stages_arrayOfObjs: action,
      a_gate_review_approvals_set_is_loading_tf: action,
      a_gate_review_approvals_set_action_pending_obj: action,
      a_gate_review_approvals_approve_or_reject: action
    });
  }


  //========================================================================================
  //computed values
  //divexec capture filtering
  get c_divexecFilteredCapturesObj() {
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;

    //load filter settings from user table fields
    const finProjCustom0Manual1 = UserMobx.c_combinedUserObj.divexec_finproj_custom0_manual1;
    const finProjFilterPresetID = UserMobx.c_combinedUserObj.divexec_finproj_filter_preset_id;
    const finProjDivisionIDsComma = UserMobx.c_combinedUserObj.divexec_finproj_division_ids_comma;
    const finProjStageIDsComma = UserMobx.c_combinedUserObj.divexec_finproj_stage_ids_comma;

    //initialize output
    var filterName = undefined;
    var excelFilterName = undefined; //name displayed in the exported xml excel sheet is more verbose for the manual divisions/stages filter
    var filteredCaptureMapsAndTcvMultipliersArrayOfObjs = [];

    //determine the filter preset being used (manual or custom)
    var finProjExpandedFiltersArrayOfObjs = undefined;
    if(finProjCustom0Manual1 === 0) { //filter from custom filter preset selected
      const expandedFilterPresetObj = CapturesMobx.get_database_or_system_expanded_preset_obj_with_preset_items_arrayOfObjs_from_preset_type_and_preset_id("filter", finProjFilterPresetID);
      if(expandedFilterPresetObj.existsTF) {
        filterName = expandedFilterPresetObj.name;
      }
      else {
        filterName = "All Captures (No Filter Selected)";
      }
      excelFilterName = filterName;

      finProjExpandedFiltersArrayOfObjs = CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(expandedFilterPresetObj.expandedPresetItemsArrayOfObjs, c_tbl_captures_fields);
    }
    else if(finProjCustom0Manual1 === 1) { //manual filter from divisions/stages
      filterName = "Manual Divisions/Stages Filter";

      const filterDivisionsMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(finProjDivisionIDsComma, DatabaseMobx.c_selectMultiDivisionsFieldTypeObj);
      const filterStagesMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(finProjStageIDsComma, DatabaseMobx.c_selectMultiStagesFieldTypeObj);
      excelFilterName = "Division(s): " + filterDivisionsMaskSortIfoObj.valueMaskPlainText + " || Stage(s): " + filterStagesMaskSortIfoObj.valueMaskPlainText;

      const manualFiltersArrayOfObjs = [
        {capture_field_id:DatabaseMobx.c_fieldMapOfDivisionOwners.get("id"), operator:"e", value:finProjDivisionIDsComma},
        {capture_field_id:DatabaseMobx.c_fieldMapOfStage.get("id"), operator:"e", value:finProjStageIDsComma}
      ];
      finProjExpandedFiltersArrayOfObjs = CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(manualFiltersArrayOfObjs, c_tbl_captures_fields);
    }
    else {
      filterName = "--Unknown Filter " + finProjCustom0Manual1 + "--";
      excelFilterName = filterName;
      finProjExpandedFiltersArrayOfObjs = [];
    }

    //filter captures from full set
    for(let captureMap of DatabaseMobx.o_tbl_captures.values()) {
      var partialMultiplier0to1OrFalse = CapturesMobx.capture_matches_all_filters_partialMultiplier0to1_or_false_from_capture_map_and_expanded_filters_arrayOfObjs(captureMap, finProjExpandedFiltersArrayOfObjs);
      if(JSFUNC.is_number_not_nan_gt_0(partialMultiplier0to1OrFalse)) {
        filteredCaptureMapsAndTcvMultipliersArrayOfObjs.push({
          captureMap: captureMap,
          partialMultiplier0to1: partialMultiplier0to1OrFalse
        });
      }
    }

    return({
      filterName: filterName,
      excelFilterName: excelFilterName,
      filteredCaptureMapsAndTcvMultipliersArrayOfObjs: filteredCaptureMapsAndTcvMultipliersArrayOfObjs
    });
  }




  //performance
  get c_performanceSelectedUserOrDivisionString() {
    if(UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF) {
      return("Custom Performance");
    }

    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    
    var userOrDivisionString = "";
    if((o_performanceSelectedUserTrueDivisionFalse !== undefined) && (o_performanceSelectedUserOrDivisionID !== undefined)) {
      if(o_performanceSelectedUserTrueDivisionFalse) { //selected user
        userOrDivisionString = "User";
      }
      else { //selected division
        userOrDivisionString = "Division";
      }
    }
    return(userOrDivisionString);
  }

  get c_performanceSelectedUserOrDivisionName() {
    if(UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF) {
      const selectedCustomPerformanceFieldMap = this.c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined;
      if((selectedCustomPerformanceFieldMap !== undefined) && (this.o_performanceSelectedCustomPerformanceOptionID !== undefined)) {
        if(this.o_performanceSelectedCustomPerformanceOptionID === -1) {
          return("All Values from " + selectedCustomPerformanceFieldMap.get("display_name"));
        }
        const optionName = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(this.o_performanceSelectedCustomPerformanceOptionID, selectedCustomPerformanceFieldMap.get("fieldTypeObj"));
        return(selectedCustomPerformanceFieldMap.get("display_name") + ": " + optionName);
      }
      return("--No Custom Performance Selected--");
    }

    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    const c_selectDivisionFieldTypeObj = DatabaseMobx.c_selectDivisionFieldTypeObj;

    var userOrDivisionName = "--No User/Division Selected--";
    if((o_performanceSelectedUserTrueDivisionFalse !== undefined) && (o_performanceSelectedUserOrDivisionID !== undefined)) {
      if(o_performanceSelectedUserTrueDivisionFalse) { //selected user
        userOrDivisionName = DatabaseMobx.user_name_mask_plaintext_from_user_id(o_performanceSelectedUserOrDivisionID);
      }
      else { //selected division
        userOrDivisionName = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(o_performanceSelectedUserOrDivisionID, c_selectDivisionFieldTypeObj);
      }
    }
    return(userOrDivisionName);
  }

  get c_performanceDivisionsWithUsersArrayOfObjs() {
    //use the logged in user's division treeID to determine which divisions to show and which to hide (divexec user's can only see their division and its subdivisions, nothing below)
    const c_userDivisionID = UserMobx.c_userDivisionID;
    const c_userDivisionTreeID = UserMobx.c_userDivisionTreeID;

    var indentsToSubtract = 0;
    if(JSFUNC.is_string(c_userDivisionTreeID)) {
      indentsToSubtract = ((c_userDivisionTreeID.length / 2) - 1); //for top level treeID "00", remove 0 indents from the normal indent count, for other lower divisions, remove indents to make them the top level with 0 indents
    }

    const divisionsMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name("tbl_a_divisions");
    var divisionsArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(divisionsMapOfMaps, "tree_id", true);
    var performanceDivisionsArrayOfObjs = [];
    for(let divisionObj of divisionsArrayOfObjs) {
      var divisionIsChildOfUserDivision = JSFUNC.tree_id_is_child_of_parent_tree_id_tf(c_userDivisionTreeID, divisionObj.tree_id, false);
      if((divisionObj.id === c_userDivisionID) || divisionIsChildOfUserDivision) { //only include this division if it is the user's division or a child of that division
        var usersArrayOfObjs = [];
        for(let combinedUserMap of DatabaseMobx.c_tbl_a_users.values()) {
          if(!combinedUserMap.get("upeDeactivatedTF") && (combinedUserMap.get("division_id") === divisionObj.id)) {
            usersArrayOfObjs.push(JSFUNC.obj_from_map(combinedUserMap));
          }
        }

        divisionObj.indentsArray = DatabaseMobx.compute_division_indents_array_from_division_obj(divisionObj, indentsToSubtract);
        divisionObj.usersArrayOfObjs = usersArrayOfObjs;

        performanceDivisionsArrayOfObjs.push(divisionObj);
      }
    }
    return(performanceDivisionsArrayOfObjs);
  }


  get c_performanceCustomPerformanceCaptureFieldFieldTypeObj() {
    var customPerformanceFieldsArrayOfObjs = [];
    for(let expandedCaptureFieldMap of DatabaseMobx.c_tbl_captures_fields.values()) {
      if(expandedCaptureFieldMap.get("fieldRequiresSwsDataObjTF")) {
        customPerformanceFieldsArrayOfObjs.push({
          id: expandedCaptureFieldMap.get("id"),
          name: expandedCaptureFieldMap.get("display_name")
        });
      }
    }
    JSFUNC.sort_arrayOfObjs(customPerformanceFieldsArrayOfObjs, "name", true);

    const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Custom Performance Capture Field", customPerformanceFieldsArrayOfObjs, "id", false, "name", swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  get c_performanceGraphSelectedStageIDsArray() {
    const selectedStageIDsCommaOrAll = UserMobx.c_combinedUserObj.divexec_graphs_selected_stage_ids_comma_or_all;
    if(selectedStageIDsCommaOrAll === "all") {
      return(DatabaseMobx.c_selectMultiStagesOrAllFieldTypeObj.selectWithSearchDataObj.valueArray);
    }
    return(JSFUNC.convert_comma_list_to_int_array(selectedStageIDsCommaOrAll));
  }


  get c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined() {
    const selectedFieldMap = DatabaseMobx.c_tbl_captures_fields.get(UserMobx.c_combinedUserObj.divexec_performance_custom_performance_selected_capture_field_id);
    if((selectedFieldMap === undefined) || !selectedFieldMap.get("fieldRequiresSwsDataObjTF")) {
      return(undefined);
    }
    return(selectedFieldMap);
  }


  get c_performanceCustomPerformanceCaptureFieldOptionsFieldTypeObj() {
    const selectedCaptureFieldMap = this.c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined;
    if(selectedCaptureFieldMap === undefined) {
      return(undefined);
    }

    const selectedCaptureFieldTypeObj = selectedCaptureFieldMap.get("fieldTypeObj");
    const selectedCaptureFieldSwsDataObj = selectedCaptureFieldTypeObj.selectWithSearchDataObj;
    if((selectedCaptureFieldSwsDataObj === undefined) || !JSFUNC.is_array(selectedCaptureFieldSwsDataObj.valueArray)) {
      return(undefined);
    }

    const optionsSwsDataObj = Object.assign({}, selectedCaptureFieldSwsDataObj, {
      isMultiSelectTF:true,
      hasSearchTF:true,
      hasClearSelectionTF:true,
      multiSelectHasAllSwitchTF:true
    });
    return(DatabaseMobx.create_field_type_obj("select", optionsSwsDataObj));
  }


  get c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined() {
    const c_combinedUserObj = UserMobx.c_combinedUserObj;
    return(DatabaseMobx.c_tbl_captures_fields.get(c_combinedUserObj.divexec_performance_money_field_id));
  }


  get c_performanceUserSelectedMoneyFieldDisplayName() {
    const c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined = this.c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined;
    if(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined === undefined) {
      return("--No Capture Money Field Selected--");
    }
    return(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined.get("display_name"));
  }


  get c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs() {
    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    const c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined = this.c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined;
    const c_tbl_d_quota = DatabaseMobx.c_tbl_d_quota;

    var selectedUserOrDivisionAllExpandedGoalsArrayOfObjs = [];
    if(UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF && (this.o_performanceSelectedCustomPerformanceOptionID !== undefined)) {
      if(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined !== undefined) {
        const customPerformanceCaptureFieldID = ((this.o_performanceSelectedCustomPerformanceOptionID === -1) ? (-1) : (UserMobx.c_combinedUserObj.divexec_performance_custom_performance_selected_capture_field_id));
        const performanceMoneyFieldID = c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined.get("id");
        selectedUserOrDivisionAllExpandedGoalsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(c_tbl_d_quota, ["user0_division1", "custom_performance_capture_field_id", "userdiv_id", "money_field_id"], [-1, customPerformanceCaptureFieldID, this.o_performanceSelectedCustomPerformanceOptionID, performanceMoneyFieldID], "fyr", true);
      }
    }
    else if((o_performanceSelectedUserTrueDivisionFalse !== undefined) && (o_performanceSelectedUserOrDivisionID !== undefined)) {
      if(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined !== undefined) { //get all set quota records for this user/division (sorted by fiscal year) [none if the selected money capture field cannot be found or is not filled out]
        const quotaUser0Division1 = ((o_performanceSelectedUserTrueDivisionFalse) ? (0) : (1));
        const performanceMoneyFieldID = c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined.get("id");
        selectedUserOrDivisionAllExpandedGoalsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(c_tbl_d_quota, ["user0_division1", "userdiv_id", "money_field_id"], [quotaUser0Division1, o_performanceSelectedUserOrDivisionID, performanceMoneyFieldID], "fyr", true);
      }
    }
    return(selectedUserOrDivisionAllExpandedGoalsArrayOfObjs);
  }


  get c_performanceSelectedUserOrDivisionIDsCommaString() {
    if(UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF) {
      if(this.o_performanceSelectedCustomPerformanceOptionID === undefined) {
        return(undefined);
      }
      if(this.o_performanceSelectedCustomPerformanceOptionID === -1) {
        return("");
      }
      return(String(this.o_performanceSelectedCustomPerformanceOptionID));
    }

    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    const c_performanceDivisionsWithUsersArrayOfObjs = this.c_performanceDivisionsWithUsersArrayOfObjs;

    //either a single selected userID (as a string), or a comma list of all divisionIDs within the selected division's tree
    var selectedUserOrDivisionIDsCommaString = undefined;
    if((o_performanceSelectedUserTrueDivisionFalse !== undefined) && (o_performanceSelectedUserOrDivisionID !== undefined)) {
      if(o_performanceSelectedUserTrueDivisionFalse) { //selected user
        selectedUserOrDivisionIDsCommaString = JSFUNC.num2str(o_performanceSelectedUserOrDivisionID);
      }
      else { //selected division
        const divisionMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_divisions", o_performanceSelectedUserOrDivisionID);
        const selectedDivisionTreeID = divisionMap.get("tree_id");

        var selectedDivisionChildrenDivisionIDsArray = JSFUNC.get_all_children_ids_array_from_parent_tree_id(c_performanceDivisionsWithUsersArrayOfObjs, selectedDivisionTreeID);
        selectedDivisionChildrenDivisionIDsArray.push(o_performanceSelectedUserOrDivisionID);
        selectedUserOrDivisionIDsCommaString = JSFUNC.convert_array_to_comma_list(selectedDivisionChildrenDivisionIDsArray);
      }
    }
    return(selectedUserOrDivisionIDsCommaString);
  }


  get c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs() {
    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const c_performanceSelectedUserOrDivisionIDsCommaString = this.c_performanceSelectedUserOrDivisionIDsCommaString;
    const c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined = this.c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;
    const c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcsTF = DatabaseMobx.c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcsTF;
    const c_submittedStageIDsArray = DatabaseMobx.c_submittedStageIDsArray;
    const c_closedWonStageIDsArray = DatabaseMobx.c_closedWonStageIDsArray;
    const c_fieldMapOfCaptureManagers = DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfStage = DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfProposalDueDateTimeUtc = DatabaseMobx.c_fieldMapOfProposalDueDateTimeUtc;
    const c_fieldMapOfAwardDate = DatabaseMobx.c_fieldMapOfAwardDate;
    const c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF = UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF;

    var selectedUserOrDivisionAllMatchingCapturesArrayOfObjs = [];
    const customPerformanceAllValuesSelectedTF = (c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF && (this.o_performanceSelectedCustomPerformanceOptionID === -1));

    //user/division/custom performance capture field for capture filter
    var ownersCaptureFieldID = ((o_performanceSelectedUserTrueDivisionFalse) ? (c_fieldMapOfCaptureManagers.get("id")) : (c_fieldMapOfDivisionOwners.get("id")));
    if(c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF) {
      const selectedCustomPerformanceFieldMap = this.c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined;
      ownersCaptureFieldID = ((selectedCustomPerformanceFieldMap === undefined) ? (undefined) : (selectedCustomPerformanceFieldMap.get("id")));
    }

    //stage capture field
    const stageFieldID = c_fieldMapOfStage.get("id");
    const allSubmittedOrClosedWonStageIDsArray = JSFUNC.merge_unique(c_submittedStageIDsArray, c_closedWonStageIDsArray);
    const allSubmittedOrClosedWonStageIDsCommaString = JSFUNC.convert_array_to_comma_list(allSubmittedOrClosedWonStageIDsArray, "");

    //no need to fetch/check any captures if there are 0 users/divisions within the tree selection or 0 admin defined submitted/won stages
    if((customPerformanceAllValuesSelectedTF || ((ownersCaptureFieldID !== undefined) && JSFUNC.string_is_filled_out_tf(c_performanceSelectedUserOrDivisionIDsCommaString))) && JSFUNC.string_is_filled_out_tf(allSubmittedOrClosedWonStageIDsCommaString)) {
      //create the capture filter for this single user/division with only submitted/won stageIDs
      var ownersAndStagesFiltersArrayOfObjs = [{capture_field_id:stageFieldID, operator:"e", value:allSubmittedOrClosedWonStageIDsCommaString}];
      if(!customPerformanceAllValuesSelectedTF) {
        ownersAndStagesFiltersArrayOfObjs.unshift({capture_field_id:ownersCaptureFieldID, operator:"e", value:c_performanceSelectedUserOrDivisionIDsCommaString});
      }
      const ownersAndStagesExpandedFiltersArrayOfObjs = CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(ownersAndStagesFiltersArrayOfObjs, c_tbl_captures_fields);

      //loop through every capture in the system to compute their partial TCV multiplier against the owner/stage filter
      for(let captureMap of o_tbl_captures.values()) {
        //determine if the capture is owned by this user/division
        var partialMultiplier0to1OrFalse = CapturesMobx.capture_matches_all_filters_partialMultiplier0to1_or_false_from_capture_map_and_expanded_filters_arrayOfObjs(captureMap, ownersAndStagesExpandedFiltersArrayOfObjs);

        //admin option in 'System' subtab to force all percent ownership calculations to full value for these performance calculations
        if(c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcsTF && (partialMultiplier0to1OrFalse !== false)) {
          partialMultiplier0to1OrFalse = 1;
        }

        if(JSFUNC.is_number_not_nan_gt_0(partialMultiplier0to1OrFalse)) { //capture is within user/division and stage filter with full or partial ownership
          var captureID = captureMap.get("id");

          //determine if stage is submitted or won
          var captureStageID = captureMap.get("stage_id");
          var stageIsSubmittedTF = JSFUNC.in_array(captureStageID, c_submittedStageIDsArray);
          var stageIsClosedWonTF = JSFUNC.in_array(captureStageID, c_closedWonStageIDsArray);
          var isSubmittedTF = (stageIsSubmittedTF || stageIsClosedWonTF); //all captures stageIsSubmittedTF or stageIsClosedWonTF are all counted as submitted (closedWon is a subset of submitted)
          var isWonTF = stageIsClosedWonTF;

          //compute the partial total contract value
          var selectedMoneyFieldValueRaw = 0;
          if(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined !== undefined) {
            selectedMoneyFieldValueRaw = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined);
          }

          var selectedMoneyFieldPartialOwnershipValueRaw = ((partialMultiplier0to1OrFalse === 1) ? (selectedMoneyFieldValueRaw) : (partialMultiplier0to1OrFalse * selectedMoneyFieldValueRaw));

          //submitted captures use proposal due date
          var proposalDueDateFyrObjOrUndefined = undefined;
          var isValidPerformanceSubmittedCaptureTF = false;
          if(isSubmittedTF) {
            var captureProposalDueDateOrDateTimeUtc = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, c_fieldMapOfProposalDueDateTimeUtc);
            var captureProposalDueDateLocal = JSFUNC.convert_mysqldate_or_mysqldatetimeutc_to_mysqldatelocal(captureProposalDueDateOrDateTimeUtc); //handle proposal due date either being a date or dateTimeUtc format
            if(this.performance_date_is_filled_out_and_between_1950_and_3001_tf(captureProposalDueDateLocal)) {
              proposalDueDateFyrObjOrUndefined = DatabaseMobx.convert_date_Ymd_to_fyrYear_fyrMonth0to11_obj(captureProposalDueDateLocal);
              isValidPerformanceSubmittedCaptureTF = true;
            }
          }

          //won captures use award date
          var awardDateFyrObjOrUndefined = undefined;
          var isValidPerformanceWonCaptureTF = false;
          if(isWonTF) {
            var captureAwardDate = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, c_fieldMapOfAwardDate);
            if(this.performance_date_is_filled_out_and_between_1950_and_3001_tf(captureAwardDate)) {
              awardDateFyrObjOrUndefined = DatabaseMobx.convert_date_Ymd_to_fyrYear_fyrMonth0to11_obj(captureAwardDate);
              isValidPerformanceWonCaptureTF = true;
            }
          }

          selectedUserOrDivisionAllMatchingCapturesArrayOfObjs.push({
            captureID: captureID,
            ownershipPartialMultiplier0to1: partialMultiplier0to1OrFalse,
            selectedMoneyFieldPartialOwnershipValueRaw: selectedMoneyFieldPartialOwnershipValueRaw,
            proposalDueDateFyrObjOrUndefined: proposalDueDateFyrObjOrUndefined,
            awardDateFyrObjOrUndefined: awardDateFyrObjOrUndefined,
            isValidPerformanceSubmittedCaptureTF: isValidPerformanceSubmittedCaptureTF,
            isValidPerformanceWonCaptureTF: isValidPerformanceWonCaptureTF
          });
        }
      }
    }

    return(selectedUserOrDivisionAllMatchingCapturesArrayOfObjs);
  }


  get c_performanceLowestHighestNumFyrToDisplayInGraphsObj() {
    const c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs = this.c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs;
    const c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs = this.c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    const maxYearsPossibleToShow = 50;
    const todayYearInt = JSFUNC.now_year_int();

    //find a first and last FYR that spans both the set quota records and all captures owned, initialize undefined
    var highestFyr = undefined;
    var lowestFyr = undefined;
    if(JSFUNC.is_number_not_nan_gt_0(c_combinedUserObj.divexec_goals_latest_year)) { //user has "Specify Years Shown" switch on
      highestFyr = c_combinedUserObj.divexec_goals_latest_year;
      lowestFyr = (c_combinedUserObj.divexec_goals_latest_year - (Math.min(c_combinedUserObj.divexec_goals_num_years, maxYearsPossibleToShow) - 1));
    }
    else { //find the high/low fyr from set quotas and filtered capture dates
      //set the first/last FYR using the set quotas for this user/division
      if(JSFUNC.is_array_not_empty(c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs)) { //these are sorted by fyr ASC, thus the first is the lowest and the last is the highest from set quotas of the user/division/money field
        highestFyr = c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs[(c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs.length - 1)].fyr;
        lowestFyr = c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs[0].fyr;
      }

      //update lowest/highest FYRs from all matching capture proposal due dates and award dates
      for(let matchingCaptureObj of c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs) {
        if((matchingCaptureObj.proposalDueDateFyrObjOrUndefined !== undefined)) {
          if((highestFyr === undefined) || (matchingCaptureObj.proposalDueDateFyrObjOrUndefined.fyrYear > highestFyr)) {
            highestFyr = matchingCaptureObj.proposalDueDateFyrObjOrUndefined.fyrYear;
          }

          if((lowestFyr === undefined) || (matchingCaptureObj.proposalDueDateFyrObjOrUndefined.fyrYear < lowestFyr)) {
            lowestFyr = matchingCaptureObj.proposalDueDateFyrObjOrUndefined.fyrYear;
          }
        }
        
        if((matchingCaptureObj.awardDateFyrObjOrUndefined !== undefined)) {
          if((highestFyr === undefined) || (matchingCaptureObj.awardDateFyrObjOrUndefined.fyrYear > highestFyr)) {
            highestFyr = matchingCaptureObj.awardDateFyrObjOrUndefined.fyrYear;
          }

          if((lowestFyr === undefined) || (matchingCaptureObj.awardDateFyrObjOrUndefined.fyrYear < lowestFyr)) {
            lowestFyr = matchingCaptureObj.awardDateFyrObjOrUndefined.fyrYear;
          }
        }
      }

      //if the highest/lowest fyr is still undefined, set them both to today fyr
      if((highestFyr === undefined) || (lowestFyr === undefined)) {
        highestFyr = todayYearInt;
        lowestFyr = todayYearInt;
      }
    }

    //force of maximum number of years on the high/low fyr found
    if(highestFyr > (todayYearInt + 100)) { //if the highest fyr is more than 100 years in the future, cap it there
      highestFyr = (todayYearInt + 100);
    }

    if((highestFyr - lowestFyr) > maxYearsPossibleToShow) { //if the # years between the highest/lowest fyr is more than the max # years to draw, reduce the gap
      lowestFyr = (highestFyr - maxYearsPossibleToShow);
    }

    if(lowestFyr > highestFyr) { //one last check that highest is higher than lowest to prevent an infinite for loop
      lowestFyr = highestFyr;
    }

    const numYears = ((highestFyr - lowestFyr) + 1);

    return({
      lowestFyr: lowestFyr,
      highestFyr: highestFyr,
      numYears: numYears
    });
  }


  get c_performanceQuotaGraphObj() {
    const c_performanceLowestHighestNumFyrToDisplayInGraphsObj = this.c_performanceLowestHighestNumFyrToDisplayInGraphsObj;
    const c_companyFyrMonthsAndQuartersInfoObj = DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;
    const c_userFontSizePx = UserMobx.c_userFontSizePx;
    const c_userDivexecSelectedPerformanceViewIsYearlyTF = UserMobx.c_userDivexecSelectedPerformanceViewIsYearlyTF;
    const c_userDivexecSelectedPerformanceViewIsQuarterlyTF = UserMobx.c_userDivexecSelectedPerformanceViewIsQuarterlyTF;
    const c_userDivexecSelectedPerformanceViewIsMonthlyTF = UserMobx.c_userDivexecSelectedPerformanceViewIsMonthlyTF;

    const lowestFyr = c_performanceLowestHighestNumFyrToDisplayInGraphsObj.lowestFyr;
    const highestFyr = c_performanceLowestHighestNumFyrToDisplayInGraphsObj.highestFyr;
    const numYears = c_performanceLowestHighestNumFyrToDisplayInGraphsObj.numYears;

    //get a list of FYR to loop over for the performance graph (counts low-to-high or high-to-low based on user divexec_performance_view_dec0inc1 setting)
    var performanceFyrArray = [];
    if(c_combinedUserObj.divexec_performance_view_dec0inc1 === 1) { //increasing FYR low to high
      performanceFyrArray = JSFUNC.array_fill_incrementing_x_to_y(lowestFyr, highestFyr, 1);
    }
    else { //decreasing FYR high to low
      performanceFyrArray = JSFUNC.array_fill_decrementing_y_to_x(highestFyr, lowestFyr, 1);
    }

    //loop through each fyr from highest to lowest (highest fyr on left side of graph) filling in the quotas and actual values
    var graphFyrYqmDataArrayOfObjs = []; //initialize output arrayOfObjs per quota year (each year contains 12 months of matching capture data)
    for(let fyr of performanceFyrArray) {
      var graphFyrYqmDataObj = this.compute_single_fyr_yqm_data_obj_from_fyr_within_selected_user_or_division_and_selected_capture_money_field(fyr);
      graphFyrYqmDataArrayOfObjs.push(graphFyrYqmDataObj);
    }

    //compute max quota/actual values seen for yearly/quarterly/monthly views separately
    const yearlyMaxQuotaOrActualValue = JSFUNC.max_of_arrayOfObjs_column(graphFyrYqmDataArrayOfObjs, "fyrYearlyMaxQuotaOrActualValue", 0);
    const quarterlyMaxQuotaOrActualValue = JSFUNC.max_of_arrayOfObjs_column(graphFyrYqmDataArrayOfObjs, "fyrQuarterlyMaxQuotaOrActualValue", 0);
    const monthlyMaxQuotaOrActualValue = JSFUNC.max_of_arrayOfObjs_column(graphFyrYqmDataArrayOfObjs, "fyrMonthlyMaxQuotaOrActualValue", 0);

    //compute specific data (max value, bar y positions, etc) for only the selected graph view (yearly, quarterly, monthly)
    var selectedYqmQuotasActualsField = "yearQuotasActualsArrayOfObjs";
    var graphMaxQuotaOrActualValue = 1;
    var singleYearWidthEm = 10;
    var subLabelsArray = [];
    var subEdgePercent = 5;
    var subBarWidth = 45;
    if(c_userDivexecSelectedPerformanceViewIsYearlyTF) {
      selectedYqmQuotasActualsField = "yearQuotasActualsArrayOfObjs";
      graphMaxQuotaOrActualValue = yearlyMaxQuotaOrActualValue;
      singleYearWidthEm = 10;
      subLabelsArray = ["Goals", "Actual"];
      subEdgePercent = 5;
      subBarWidth = 45;
    }
    else if(c_userDivexecSelectedPerformanceViewIsQuarterlyTF) {
      selectedYqmQuotasActualsField = "quartersQuotasActualsArrayOfObjs";
      graphMaxQuotaOrActualValue = quarterlyMaxQuotaOrActualValue;
      singleYearWidthEm = 10;
      subLabelsArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_companyFyrMonthsAndQuartersInfoObj.quartersArrayOfObjs, "qName");
      subEdgePercent = 10;
      subBarWidth = 10;
    }
    else if(c_userDivexecSelectedPerformanceViewIsMonthlyTF) {
      selectedYqmQuotasActualsField = "monthsQuotasActualsArrayOfObjs";
      graphMaxQuotaOrActualValue = monthlyMaxQuotaOrActualValue;
      singleYearWidthEm = 20;
      subLabelsArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_companyFyrMonthsAndQuartersInfoObj.monthsArrayOfObjs, "mName");
      subEdgePercent = 8;
      subBarWidth = 3.5;
    }

    const graphHeightPx = (30 * c_userFontSizePx);
    const graphBarsAreaWidthEm = (numYears * singleYearWidthEm);

    //using the highest value of any bar for any fyr, compute a yAxis tick scale
    var yAxisObj = JSFUNC.create_axis_obj_from_max_value_and_height_px(0, graphMaxQuotaOrActualValue, graphHeightPx, true, "moneyShort", false, 1.06, 0); //reverse pos values for y axis ticks

    var computedGraphFyrsArrayOfObjs = [];
    for(let graphFyrYqmDataObj of graphFyrYqmDataArrayOfObjs) { //loop over each computed fyr
      var graphSelectedQuotasActualsArrayOfObjs = graphFyrYqmDataObj[selectedYqmQuotasActualsField];

      var qa = 0;
      var computedGraphQuotasActualsArrayOfObjs = [];
      for(let quotasActualsObj of graphSelectedQuotasActualsArrayOfObjs) {
        var submittedQuotaOver0TF = (quotasActualsObj.submittedQuota > 0);
        var submittedQuotaBarHeightY = 0;
        if(submittedQuotaOver0TF) {
          submittedQuotaBarHeightY = JSFUNC.compute_svg_pos_0to100_from_value_and_axis_obj(quotasActualsObj.submittedQuota, yAxisObj);
        }

        var wonQuotaOver0TF = (quotasActualsObj.wonQuota > 0);
        var wonQuotaBarHeightY = 0;
        if(wonQuotaOver0TF) {
          wonQuotaBarHeightY = JSFUNC.compute_svg_pos_0to100_from_value_and_axis_obj(quotasActualsObj.wonQuota, yAxisObj);
        }

        var submittedActualOver0TF = (quotasActualsObj.submittedActualSumFromCapturesMoneyField > 0);
        var submittedActualBarHeightY = 0;
        if(submittedActualOver0TF) {
          submittedActualBarHeightY = JSFUNC.compute_svg_pos_0to100_from_value_and_axis_obj(quotasActualsObj.submittedActualSumFromCapturesMoneyField, yAxisObj);
        }

        var wonActualOver0TF = (quotasActualsObj.wonActualSumFromCapturesMoneyField > 0);
        var wonActualBarHeightY = 0;
        if(wonActualOver0TF) {
          wonActualBarHeightY = JSFUNC.compute_svg_pos_0to100_from_value_and_axis_obj(quotasActualsObj.wonActualSumFromCapturesMoneyField, yAxisObj);
        }

        var submittedQuotaBarX = "0%";
        var submittedQuotaBarWidth = "0%";
        var wonQuotaBarX = "0%";
        var wondQuotaBarWidth = "0%";
        var submittedActualBarX = "0%";
        var submittedActualBarWidth = "0%";
        var wonActualBarX = "0%";
        var wonActualBarWidth = "0%";
        if(c_userDivexecSelectedPerformanceViewIsYearlyTF) {
          submittedQuotaBarX = "15%";
          submittedQuotaBarWidth = "32.5%";
          wonQuotaBarX = "22.5%";
          wondQuotaBarWidth = "25%";
          submittedActualBarX = "52.5%";
          submittedActualBarWidth = "32.5%";
          wonActualBarX = "60%";
          wonActualBarWidth = "25%";
        }
        else if(c_userDivexecSelectedPerformanceViewIsQuarterlyTF || c_userDivexecSelectedPerformanceViewIsMonthlyTF) {
          submittedQuotaBarX = ((qa * (subBarWidth * 2)) + subEdgePercent) + "%";
          submittedQuotaBarWidth = subBarWidth + "%";
          wonQuotaBarX = submittedQuotaBarX;
          wondQuotaBarWidth = subBarWidth + "%";
          submittedActualBarX = ((qa * (subBarWidth * 2)) + subEdgePercent + subBarWidth) + "%";
          submittedActualBarWidth = subBarWidth + "%";
          wonActualBarX = submittedActualBarX;
          wonActualBarWidth = subBarWidth + "%";
        }

        computedGraphQuotasActualsArrayOfObjs.push({
          submittedQuotaBarDrawTF: submittedQuotaOver0TF,
          submittedQuotaBarX: submittedQuotaBarX,
          submittedQuotaBarWidth: submittedQuotaBarWidth,
          submittedQuotaBarY: submittedQuotaBarHeightY + "%",
          submittedQuotaBarHeight: (100 - submittedQuotaBarHeightY) + "%",
          submittedQuotaBarHashColor: "#cccccc",
          wonQuotaBarDrawTF: wonQuotaOver0TF,
          wonQuotaBarX: wonQuotaBarX,
          wondQuotaBarWidth: wondQuotaBarWidth,
          wonQuotaBarY: wonQuotaBarHeightY + "%",
          wonQuotaBarHeight: (100 - wonQuotaBarHeightY) + "%",
          wonQuotaBarHashColor: "#888888",
          submittedActualBarDrawTF: submittedActualOver0TF,
          submittedActualBarX: submittedActualBarX,
          submittedActualBarWidth: submittedActualBarWidth,
          submittedActualBarY: submittedActualBarHeightY + "%",
          submittedActualBarHeight: (100 - submittedActualBarHeightY) + "%",
          submittedActualBarHashColor: ((submittedQuotaOver0TF && (quotasActualsObj.submittedQuota > quotasActualsObj.submittedActualSumFromCapturesMoneyField)) ? ("#dd8888") : ("#88dd88")),
          wonActualBarDrawTF: wonActualOver0TF,
          wonActualBarX: wonActualBarX,
          wonActualBarWidth: wonActualBarWidth,
          wonActualBarY: wonActualBarHeightY + "%",
          wonActualBarHeight: (100 - wonActualBarHeightY) + "%",
          wonActualBarHashColor: ((wonQuotaOver0TF && (quotasActualsObj.wonQuota > quotasActualsObj.wonActualSumFromCapturesMoneyField)) ? ("#aa4444") : ("#44aa44")),
        });

        qa++;
      }

      //hover text for each graph FYR bars group
      var fyrHoverText = "";
      if(c_userDivexecSelectedPerformanceViewIsYearlyTF || c_userDivexecSelectedPerformanceViewIsQuarterlyTF || c_userDivexecSelectedPerformanceViewIsMonthlyTF) {
        fyrHoverText += "FY" + graphFyrYqmDataObj.fyr + " Submitted";
        fyrHoverText += "\n" + " - Goal: " + JSFUNC.money(graphFyrYqmDataObj.yearQuotasActualsArrayOfObjs[0].submittedQuota, 0, true);
        fyrHoverText += "\n" + " - Actual: " + JSFUNC.money(graphFyrYqmDataObj.yearQuotasActualsArrayOfObjs[0].submittedActualSumFromCapturesMoneyField, 0, true);
        fyrHoverText += "\n";
        fyrHoverText += "\n" + "FY" + graphFyrYqmDataObj.fyr + " Won";
        fyrHoverText += "\n" + " - Goal: " + JSFUNC.money(graphFyrYqmDataObj.yearQuotasActualsArrayOfObjs[0].wonQuota, 0, true);
        fyrHoverText += "\n" + " - Actual: " + JSFUNC.money(graphFyrYqmDataObj.yearQuotasActualsArrayOfObjs[0].wonActualSumFromCapturesMoneyField, 0, true);
      }

      computedGraphFyrsArrayOfObjs.push({
        fyr: graphFyrYqmDataObj.fyr,
        fyrLabel: "FY" + graphFyrYqmDataObj.fyr,
        subLabelsArray: subLabelsArray,
        subEdgeRatioOfBarWidthEm: Math.round(((subEdgePercent / subBarWidth) / 2) * 100),
        computedGraphQuotasActualsArrayOfObjs: computedGraphQuotasActualsArrayOfObjs,
        fyrHoverText: fyrHoverText
      });
    }

    return({
      graphFyrYqmDataArrayOfObjs: graphFyrYqmDataArrayOfObjs,
      graphHeightPx: graphHeightPx,
      graphBarsAreaWidthEm: graphBarsAreaWidthEm,
      yAxisObj: yAxisObj,
      computedGraphFyrsArrayOfObjs: computedGraphFyrsArrayOfObjs
    });
  }


  compute_single_fyr_yqm_data_obj_from_fyr_within_selected_user_or_division_and_selected_capture_money_field(i_fyrInt) {
    const c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs = this.c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs;
    const c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs = this.c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs;
    const c_companyFyrMonthsAndQuartersInfoObj = DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;

    //try to find a tbl_d_quota record for this fyr (may or may not exist whether users have entered this quota user/division/money field/fyr combination yet)
    var fyrSubmittedQuotaYqmObj = undefined;
    var fyrWonQuotaYqmObj = undefined;
    var matchingExpandedGoalObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(c_performanceSelectedUserOrDivisionAllExpandedGoalsArrayOfObjs, "fyr", i_fyrInt);
    if(matchingExpandedGoalObjOrUndefined !== undefined) {
      fyrSubmittedQuotaYqmObj = matchingExpandedGoalObjOrUndefined.salesPerformanceSubmittedGoalYqmObj;
      fyrWonQuotaYqmObj = matchingExpandedGoalObjOrUndefined.salesPerformanceWonGoalYqmObj;
    }
    else { //blank yqmObj for a tbl_d_quota record that does not exist yet
      fyrSubmittedQuotaYqmObj = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("yearly", 0);
      fyrWonQuotaYqmObj = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("yearly", 0);
    }

    //initialize maximum quota/actual value counters for each of the yearly/quarterly/monthly views for this fyr
    var fyrYearlyMaxQuotaOrActualValue = 0;
    var fyrQuarterlyMaxQuotaOrActualValue = 0;
    var fyrMonthlyMaxQuotaOrActualValue = 0;

    //loop through each FYR month (starting at the company FYR start month) and filter the captures for dates that fall within this month
    var monthsQuotasActualsArrayOfObjs = [];
    for(let m = 0; m < 12; m++) { //fyr month index 0-11 loop counter
      var monthObj = c_companyFyrMonthsAndQuartersInfoObj.monthsArrayOfObjs[m];

      //get monthly quota from found tbl_d_quota record
      var fyrMonthSubmittedQuota = fyrSubmittedQuotaYqmObj.monthly12Array[m];
      var fyrMonthWonQuota = fyrWonQuotaYqmObj.monthly12Array[m];

      //compute actual sum of selected capture money field from all partial owned captures only in this fyr month
      var fyrMonthSubmittedActualSumFromCapturesMoneyField = 0;
      var fyrMonthSubmittedActualCaptureIDsArray = [];
      var fyrMonthSubmittedActualPartialNumCaptures = 0;
      var fyrMonthWonActualSumFromCapturesMoneyField = 0;
      var fyrMonthWonActualCaptureIDsArray = [];
      var fyrMonthWonActualPartialNumCaptures = 0
      for(let matchingCaptureObj of c_performanceSelectedUserOrDivisionAllMatchingCapturesArrayOfObjs) {
        //capture is within a submitted stage and is within this fyr/month, add partial ownership selected money field value
        if(matchingCaptureObj.isValidPerformanceSubmittedCaptureTF) {
          if(matchingCaptureObj.proposalDueDateFyrObjOrUndefined.fyrYear === i_fyrInt) {
            if(matchingCaptureObj.proposalDueDateFyrObjOrUndefined.fyrMonth0to11 === m) {
              fyrMonthSubmittedActualSumFromCapturesMoneyField += matchingCaptureObj.selectedMoneyFieldPartialOwnershipValueRaw;
              fyrMonthSubmittedActualCaptureIDsArray.push(matchingCaptureObj.captureID);
              fyrMonthSubmittedActualPartialNumCaptures += matchingCaptureObj.ownershipPartialMultiplier0to1;
            }
          }
        }

        //capture is within a submitted stage and is within this fyr/month, add partial ownership selected money field value
        if(matchingCaptureObj.isValidPerformanceWonCaptureTF) {
          if(matchingCaptureObj.awardDateFyrObjOrUndefined.fyrYear === i_fyrInt) {
            if(matchingCaptureObj.awardDateFyrObjOrUndefined.fyrMonth0to11 === m) {
              fyrMonthWonActualSumFromCapturesMoneyField += matchingCaptureObj.selectedMoneyFieldPartialOwnershipValueRaw;
              fyrMonthWonActualCaptureIDsArray.push(matchingCaptureObj.captureID);
              fyrMonthWonActualPartialNumCaptures += matchingCaptureObj.ownershipPartialMultiplier0to1;
            }
          }
        }
      }

      var fyrMonthQuotasActualsObj = {
        name: monthObj.mName,
        submittedQuota: fyrMonthSubmittedQuota,
        submittedActualSumFromCapturesMoneyField: fyrMonthSubmittedActualSumFromCapturesMoneyField,
        submittedActualCaptureIDsArray: fyrMonthSubmittedActualCaptureIDsArray,
        submittedActualPartialNumCaptures: fyrMonthSubmittedActualPartialNumCaptures,
        wonQuota: fyrMonthWonQuota,
        wonActualSumFromCapturesMoneyField: fyrMonthWonActualSumFromCapturesMoneyField,
        wonActualCaptureIDsArray: fyrMonthWonActualCaptureIDsArray,
        wonActualPartialNumCaptures: fyrMonthWonActualPartialNumCaptures
      };
      monthsQuotasActualsArrayOfObjs.push(fyrMonthQuotasActualsObj);

      var fyrMonthMaxQuotaOrActualValue = Math.max(fyrMonthSubmittedQuota, fyrMonthSubmittedActualSumFromCapturesMoneyField, fyrMonthWonQuota, fyrMonthWonActualSumFromCapturesMoneyField);
      if(fyrMonthMaxQuotaOrActualValue > fyrMonthlyMaxQuotaOrActualValue) {
        fyrMonthlyMaxQuotaOrActualValue = fyrMonthMaxQuotaOrActualValue;
      }
    }

    //build quotas for the 4 quarters by adding together each group of 3 fyr months
    var quartersQuotasActualsArrayOfObjs = [];
    for(let q = 0; q < 4; q++) {
      var quarterObj = c_companyFyrMonthsAndQuartersInfoObj.quartersArrayOfObjs[q];

      var fyrQuarterSubmittedQuota = 0;
      var fyrQuarterSubmittedActualSumFromCapturesMoneyField = 0;
      var fyrQuarterSubmittedActualCaptureIDsArray = [];
      var fyrQuarterSubmittedActualPartialNumCaptures = 0;
      var fyrQuarterWonQuota = 0;
      var fyrQuarterWonActualSumFromCapturesMoneyField = 0;
      var fyrQuarterWonActualCaptureIDsArray = [];
      var fyrQuarterWonActualPartialNumCaptures = 0;
      for(let m = quarterObj.startMonthIndex0to11; m <= quarterObj.endMonthIndex0to11; m++) { //for each quarter, sum the values from the 3 months in the quarter (Q1 has startindex 0 and endindex 2, Q2 has startindex 3 and endindex 5, etc)
        fyrQuarterSubmittedQuota += monthsQuotasActualsArrayOfObjs[m].submittedQuota;
        fyrQuarterSubmittedActualSumFromCapturesMoneyField += monthsQuotasActualsArrayOfObjs[m].submittedActualSumFromCapturesMoneyField;
        fyrQuarterSubmittedActualCaptureIDsArray = JSFUNC.concat_arrays_or_values_into_new_array(fyrQuarterSubmittedActualCaptureIDsArray, monthsQuotasActualsArrayOfObjs[m].submittedActualCaptureIDsArray);
        fyrQuarterSubmittedActualPartialNumCaptures += monthsQuotasActualsArrayOfObjs[m].submittedActualPartialNumCaptures;
        fyrQuarterWonQuota += monthsQuotasActualsArrayOfObjs[m].wonQuota;
        fyrQuarterWonActualSumFromCapturesMoneyField += monthsQuotasActualsArrayOfObjs[m].wonActualSumFromCapturesMoneyField;
        fyrQuarterWonActualCaptureIDsArray = JSFUNC.concat_arrays_or_values_into_new_array(fyrQuarterWonActualCaptureIDsArray, monthsQuotasActualsArrayOfObjs[m].wonActualCaptureIDsArray);
        fyrQuarterWonActualPartialNumCaptures += monthsQuotasActualsArrayOfObjs[m].wonActualPartialNumCaptures;
      }
      var fyrQuarterQuotasActualsObj = {
        name: quarterObj.qName,
        submittedQuota: fyrQuarterSubmittedQuota,
        submittedActualSumFromCapturesMoneyField: fyrQuarterSubmittedActualSumFromCapturesMoneyField,
        submittedActualCaptureIDsArray: fyrQuarterSubmittedActualCaptureIDsArray,
        submittedActualPartialNumCaptures: fyrQuarterSubmittedActualPartialNumCaptures,
        wonQuota: fyrQuarterWonQuota,
        wonActualSumFromCapturesMoneyField: fyrQuarterWonActualSumFromCapturesMoneyField,
        wonActualCaptureIDsArray: fyrQuarterWonActualCaptureIDsArray,
        wonActualPartialNumCaptures: fyrQuarterWonActualPartialNumCaptures
      };
      quartersQuotasActualsArrayOfObjs.push(fyrQuarterQuotasActualsObj);
      
      var fyrQuarterMaxQuotaOrActualValue = Math.max(fyrQuarterSubmittedQuota, fyrQuarterSubmittedActualSumFromCapturesMoneyField, fyrQuarterWonQuota, fyrQuarterWonActualSumFromCapturesMoneyField);
      if(fyrQuarterMaxQuotaOrActualValue > fyrQuarterlyMaxQuotaOrActualValue) {
        fyrQuarterlyMaxQuotaOrActualValue = fyrQuarterMaxQuotaOrActualValue;
      }
    }

    //build a single quota obj for the fyr as a sum of the 4 quarters
    var fyrSubmittedQuota = 0;
    var fyrSubmittedActualSumFromCapturesMoneyField = 0;
    var fyrSubmittedActualCaptureIDsArray = [];
    var fyrSubmittedActualPartialNumCaptures = 0;
    var fyrWonQuota = 0;
    var fyrWonActualSumFromCapturesMoneyField = 0;
    var fyrWonActualCaptureIDsArray = [];
    var fyrWonActualPartialNumCaptures = 0;
    for(let q = 0; q < 4; q++) {
      fyrSubmittedQuota += quartersQuotasActualsArrayOfObjs[q].submittedQuota;
      fyrSubmittedActualSumFromCapturesMoneyField += quartersQuotasActualsArrayOfObjs[q].submittedActualSumFromCapturesMoneyField;
      fyrSubmittedActualCaptureIDsArray = JSFUNC.concat_arrays_or_values_into_new_array(fyrSubmittedActualCaptureIDsArray, quartersQuotasActualsArrayOfObjs[q].submittedActualCaptureIDsArray);
      fyrSubmittedActualPartialNumCaptures += quartersQuotasActualsArrayOfObjs[q].submittedActualPartialNumCaptures;
      fyrWonQuota += quartersQuotasActualsArrayOfObjs[q].wonQuota;
      fyrWonActualSumFromCapturesMoneyField += quartersQuotasActualsArrayOfObjs[q].wonActualSumFromCapturesMoneyField;
      fyrWonActualCaptureIDsArray = JSFUNC.concat_arrays_or_values_into_new_array(fyrWonActualCaptureIDsArray, quartersQuotasActualsArrayOfObjs[q].wonActualCaptureIDsArray);
      fyrWonActualPartialNumCaptures += quartersQuotasActualsArrayOfObjs[q].wonActualPartialNumCaptures;
    }
    var yearQuotasActualsObj = {
      name: JSFUNC.num2str(i_fyrInt),
      submittedQuota: fyrSubmittedQuota,
      submittedActualSumFromCapturesMoneyField: fyrSubmittedActualSumFromCapturesMoneyField,
      submittedActualCaptureIDsArray: fyrSubmittedActualCaptureIDsArray,
      submittedActualPartialNumCaptures: fyrSubmittedActualPartialNumCaptures,
      wonQuota: fyrWonQuota,
      wonActualSumFromCapturesMoneyField: fyrWonActualSumFromCapturesMoneyField,
      wonActualCaptureIDsArray: fyrWonActualCaptureIDsArray,
      wonActualPartialNumCaptures: fyrWonActualPartialNumCaptures
    };
    fyrYearlyMaxQuotaOrActualValue = Math.max(fyrSubmittedQuota, fyrSubmittedActualSumFromCapturesMoneyField, fyrWonQuota, fyrWonActualSumFromCapturesMoneyField, 0);

    //build yqm data obj for this fyr and append it to the fyr array
    return({
      fyr: i_fyrInt,
      fyrSubmittedQuotaYqmObj: fyrSubmittedQuotaYqmObj,
      fyrWonQuotaYqmObj: fyrWonQuotaYqmObj,
      yearQuotasActualsArrayOfObjs: [yearQuotasActualsObj],
      quartersQuotasActualsArrayOfObjs: quartersQuotasActualsArrayOfObjs,
      monthsQuotasActualsArrayOfObjs: monthsQuotasActualsArrayOfObjs,
      fyrYearlyMaxQuotaOrActualValue: fyrYearlyMaxQuotaOrActualValue,
      fyrQuarterlyMaxQuotaOrActualValue: fyrQuarterlyMaxQuotaOrActualValue,
      fyrMonthlyMaxQuotaOrActualValue: fyrMonthlyMaxQuotaOrActualValue
    });
  }

  quota_percent_achieved_0to100(i_quotaInt, i_actualInt) {
    if(i_quotaInt === 0) {
      return(100);
    }
    return((i_actualInt / i_quotaInt) * 100);
  }

  performance_date_is_filled_out_and_between_1950_and_3001_tf(i_dateYmd) {
    return(JSFUNC.date_is_filled_out_tf(i_dateYmd) && (i_dateYmd > "1950-01-01") && (i_dateYmd < "3001-01-01"));
  }

  get c_performanceEditingSingleQuotaFyrYqmDataObj() {
    const o_performanceSelectedFyrToViewEdit = this.o_performanceSelectedFyrToViewEdit;
    return(this.compute_single_fyr_yqm_data_obj_from_fyr_within_selected_user_or_division_and_selected_capture_money_field(o_performanceSelectedFyrToViewEdit));
  }


  get c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined() {
    const o_performanceViewFyrSelectedCapturesToViewObjOrUndefined = this.o_performanceViewFyrSelectedCapturesToViewObjOrUndefined;

    if(o_performanceViewFyrSelectedCapturesToViewObjOrUndefined === undefined) {
      return(undefined);
    }

    const columnsSearchResults0Divexec1 = 1;
    var performanceEditingQuotaSubmittedSearchFieldsCstTableObj = CapturesMobx.create_search_fields_cst_table_obj_from_capture_ids_array(o_performanceViewFyrSelectedCapturesToViewObjOrUndefined.actualCaptureIDsArray, columnsSearchResults0Divexec1);
    return(performanceEditingQuotaSubmittedSearchFieldsCstTableObj);
  }



  get c_performanceGraphsDataArrayOfObjs() {
    const c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined = this.c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined;
    const o_performanceSelectedCustomPerformanceOptionID = this.o_performanceSelectedCustomPerformanceOptionID;
    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    const c_performanceUserSelectedMoneyFieldDisplayName = this.c_performanceUserSelectedMoneyFieldDisplayName;
    const c_performanceGraphSelectedStageIDsArray = this.c_performanceGraphSelectedStageIDsArray;
    const c_performanceSelectedUserOrDivisionName = this.c_performanceSelectedUserOrDivisionName;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;
    const c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01 = DatabaseMobx.c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01;
    const c_allDivisionsArrayOfObjs = DatabaseMobx.c_allDivisionsArrayOfObjs;
    const c_activeStageIDsArray = DatabaseMobx.c_activeStageIDsArray;
    const c_closedStageIDsArray = DatabaseMobx.c_closedStageIDsArray;
    const c_closedWonStageIDsArray = DatabaseMobx.c_closedWonStageIDsArray;
    const c_closedLostStageIDsArray = DatabaseMobx.c_closedLostStageIDsArray;
    const c_fieldMapOfReasonsWonLost = DatabaseMobx.c_fieldMapOfReasonsWonLost;
    const c_valueDisplayArraysObjReasonsWonOrBoth = DatabaseMobx.c_valueDisplayArraysObjReasonsWonOrBoth;
    const c_valueDisplayArraysObjReasonsLostOrBoth = DatabaseMobx.c_valueDisplayArraysObjReasonsLostOrBoth;
    const c_fieldMapOfCaptureManagers = DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfAddedDate = DatabaseMobx.c_fieldMapOfAddedDate;
    const c_fieldMapOfAwardDate = DatabaseMobx.c_fieldMapOfAwardDate;
    const c_fieldMapOfStage = DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfLastStageDate = DatabaseMobx.c_fieldMapOfLastStageDate;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;
    const c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF = UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF;

    const customPerformanceSelectionIsInvalidTF = (c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF && ((c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined === undefined) || (o_performanceSelectedCustomPerformanceOptionID === undefined)));
    const userOrDivisionSelectionIsInvalidTF = (!c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF && ((o_performanceSelectedUserTrueDivisionFalse === undefined) || (o_performanceSelectedUserOrDivisionID === undefined)));
    if(customPerformanceSelectionIsInvalidTF || userOrDivisionSelectionIsInvalidTF) {
      return([]);
    }

    const performanceMoneyFieldID = c_combinedUserObj.divexec_performance_money_field_id;

    const stageFieldID = c_fieldMapOfStage.get("id");
    const awardDateFieldID = c_fieldMapOfAwardDate.get("id");
    const reasonsWonLostFieldID = c_fieldMapOfReasonsWonLost.get("id");

    const closedWonStageIDsComma = JSFUNC.convert_array_to_comma_list(c_closedWonStageIDsArray);
    const closedLostStageIDsComma = JSFUNC.convert_array_to_comma_list(c_closedLostStageIDsArray);
    const selectedActiveStageIDsArray = c_activeStageIDsArray.filter((m_stageID) => JSFUNC.in_array(m_stageID, c_performanceGraphSelectedStageIDsArray));
    const selectedClosedStageIDsArray = c_closedStageIDsArray.filter((m_stageID) => JSFUNC.in_array(m_stageID, c_performanceGraphSelectedStageIDsArray));
    const selectedStageIDsComma = JSFUNC.convert_array_to_comma_list(c_performanceGraphSelectedStageIDsArray);
    const activeStageIDsComma = JSFUNC.convert_array_to_comma_list(selectedActiveStageIDsArray);
    const selectedClosedStageIDsComma = JSFUNC.convert_array_to_comma_list(selectedClosedStageIDsArray);

    const reasonsWonIDsComma = JSFUNC.convert_array_to_comma_list(c_valueDisplayArraysObjReasonsWonOrBoth.valueArray);
    const reasonsLostIDsComma = JSFUNC.convert_array_to_comma_list(c_valueDisplayArraysObjReasonsLostOrBoth.valueArray);

    //create the capture filter for this single user/division
    var userOrDivisionString = "";
    var ownersCaptureFieldID = undefined;
    var userOrDivisionName = "";
    var selectedUserIDOrDivisionAndSubdivisionIDsCommaString = "";
    if(c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF) {
      const selectedCustomPerformanceFieldMap = c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined;
      userOrDivisionString = "Custom Performance";
      userOrDivisionName = c_performanceSelectedUserOrDivisionName;
      if(o_performanceSelectedCustomPerformanceOptionID !== -1) {
        ownersCaptureFieldID = selectedCustomPerformanceFieldMap.get("id");
        selectedUserIDOrDivisionAndSubdivisionIDsCommaString = String(o_performanceSelectedCustomPerformanceOptionID);
      }
    }
    else if(o_performanceSelectedUserTrueDivisionFalse) { //selected user
      userOrDivisionString = "User";
      ownersCaptureFieldID = c_fieldMapOfCaptureManagers.get("id");

      const combinedUserMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_users", o_performanceSelectedUserOrDivisionID);
      userOrDivisionName = combinedUserMap.get("fullName");

      selectedUserIDOrDivisionAndSubdivisionIDsCommaString = JSFUNC.num2str(o_performanceSelectedUserOrDivisionID);
    }
    else { //selected division
      userOrDivisionString = "Division";
      ownersCaptureFieldID = c_fieldMapOfDivisionOwners.get("id");

      const divisionMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_divisions", o_performanceSelectedUserOrDivisionID);
      userOrDivisionName = divisionMap.get("name");

      const selectedDivisionTreeID = divisionMap.get("tree_id");
      var subdivisionIDsArray = JSFUNC.get_all_children_ids_array_from_parent_tree_id(c_allDivisionsArrayOfObjs, selectedDivisionTreeID);
      subdivisionIDsArray.push(o_performanceSelectedUserOrDivisionID);
      selectedUserIDOrDivisionAndSubdivisionIDsCommaString = JSFUNC.convert_array_to_comma_list(subdivisionIDsArray);
    }

    //only captures owned by this user/division
    const ownerFilterName = "Captures for " + userOrDivisionString + " '" + userOrDivisionName + "'" + ((!c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF && !o_performanceSelectedUserTrueDivisionFalse) ? (" (and all subdivisions)") : (""));
    var ownerFiltersArrayOfObjs = [];
    if(ownersCaptureFieldID !== undefined) {
      ownerFiltersArrayOfObjs.push({capture_field_id:ownersCaptureFieldID, operator:"e", value:selectedUserIDOrDivisionAndSubdivisionIDsCommaString});
    }
    const ownerMatchingCapturesFilterPresetObj = this.create_matching_captures_filter_preset_obj_from_captures_mapOfMaps_and_filters_arrayOfObjs_and_filter_name(o_tbl_captures, ownerFiltersArrayOfObjs, ownerFilterName);

    const startDate = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(c_combinedUserObj.divexec_graphs_start_date);
    const endDate = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(c_combinedUserObj.divexec_graphs_end_date);
    const startDateIsSetTF = JSFUNC.date_is_filled_out_tf(startDate);
    const endDateIsSetTF = JSFUNC.date_is_filled_out_tf(endDate);
    const lastStageDateFieldMap = c_fieldMapOfLastStageDate;
    const selectedStageFiltersArrayOfObjs = JSFUNC.concat_arrays_or_values_into_new_array(ownerFiltersArrayOfObjs, {capture_field_id:stageFieldID, operator:"e", value:selectedStageIDsComma});
    const selectedStageMatchingCapturesFilterPresetObj = ((c_performanceGraphSelectedStageIDsArray.length === 0) ? ({
      filterPresetName: ownerMatchingCapturesFilterPresetObj.filterPresetName,
      expandedFiltersArrayOfObjs: ownerMatchingCapturesFilterPresetObj.expandedFiltersArrayOfObjs,
      matchingCapturesMapOfMaps: new Map()
    }) : (
      this.create_matching_captures_filter_preset_obj_from_captures_mapOfMaps_and_filters_arrayOfObjs_and_filter_name(ownerMatchingCapturesFilterPresetObj.matchingCapturesMapOfMaps, selectedStageFiltersArrayOfObjs, ownerFilterName)
    ));
    const dateRangeSelectedStageMatchingCapturesMap = new Map();
    for(let [captureID, captureMap] of selectedStageMatchingCapturesFilterPresetObj.matchingCapturesMapOfMaps) {
      const captureStageID = captureMap.get("stage_id");
      const captureIsWonOrLostTF = JSFUNC.in_array(captureStageID, c_closedWonStageIDsArray) || JSFUNC.in_array(captureStageID, c_closedLostStageIDsArray);
      const captureIsActiveTF = JSFUNC.in_array(captureStageID, c_activeStageIDsArray);
      const captureDateFieldMap = (captureIsWonOrLostTF) ? (c_fieldMapOfAwardDate) : ((captureIsActiveTF) ? (c_fieldMapOfAddedDate) : (lastStageDateFieldMap));
      const captureDate = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, captureDateFieldMap);
      const captureMatchesStartDateTF = !startDateIsSetTF || (JSFUNC.date_is_filled_out_tf(captureDate) && (captureDate >= startDate));
      const captureMatchesEndDateTF = !endDateIsSetTF || (JSFUNC.date_is_filled_out_tf(captureDate) && (captureDate <= endDate));
      if(captureMatchesStartDateTF && captureMatchesEndDateTF) {
        dateRangeSelectedStageMatchingCapturesMap.set(captureID, captureMap);
      }
    }
    const dateRangeSelectedStageMatchingCapturesFilterPresetObj = {
      filterPresetName: selectedStageMatchingCapturesFilterPresetObj.filterPresetName,
      expandedFiltersArrayOfObjs: selectedStageMatchingCapturesFilterPresetObj.expandedFiltersArrayOfObjs,
      matchingCapturesMapOfMaps: dateRangeSelectedStageMatchingCapturesMap
    };

    //captures in won stages (can filter for won stages using the previously filtered by owner captures for only this user/division)
    const closedWonStagesFilterName = "Won Captures for " + userOrDivisionString + " '" + userOrDivisionName + "'";
    const closedWonStagesFiltersArrayOfObjs = JSFUNC.concat_arrays_or_values_into_new_array(ownerFiltersArrayOfObjs, {capture_field_id:stageFieldID, operator:"e", value:closedWonStageIDsComma});
    const closedWonStagesMatchingCapturesFilterPresetObj = this.create_matching_captures_filter_preset_obj_from_captures_mapOfMaps_and_filters_arrayOfObjs_and_filter_name(selectedStageMatchingCapturesFilterPresetObj.matchingCapturesMapOfMaps, closedWonStagesFiltersArrayOfObjs, closedWonStagesFilterName);

    //captures in lost stages (can filter for lost stages using the previously filtered by owner captures for only this user/division)
    const closedLostStagesFilterName = "Lost Captures for " + userOrDivisionString + " '" + userOrDivisionName + "'";
    const closedLostStagesFiltersArrayOfObjs = JSFUNC.concat_arrays_or_values_into_new_array(ownerFiltersArrayOfObjs, {capture_field_id:stageFieldID, operator:"e", value:closedLostStageIDsComma});
    const closedLostStagesMatchingCapturesFilterPresetObj = this.create_matching_captures_filter_preset_obj_from_captures_mapOfMaps_and_filters_arrayOfObjs_and_filter_name(selectedStageMatchingCapturesFilterPresetObj.matchingCapturesMapOfMaps, closedLostStagesFiltersArrayOfObjs, closedLostStagesFilterName);

    const activePipelineNumCapturesGraphObj = {
      sort: 1,
      filter_preset_id: -1,
      categories_field_id: stageFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: activeStageIDsComma,
      categories_include_not_set_01: 0,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      graph_type_p0_vb1_hb2_f3: 3,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: -2,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      graph_title: "Active Stages Pipeline (# Captures)"
    };

    const activePipelineTcvGraphObj = {
      sort: 2,
      filter_preset_id: -1,
      categories_field_id: stageFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: activeStageIDsComma,
      categories_include_not_set_01: 0,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      graph_type_p0_vb1_hb2_f3: 3,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: performanceMoneyFieldID,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      graph_title: "Active Stages Pipeline ($ " + c_performanceUserSelectedMoneyFieldDisplayName + ")"
    };

    const closedStagesNumCapturesGraphObj = {
      circleGraphTrueTimeGraphFalse: true,
      sort: 3,
      filter_preset_id: -1,
      categories_field_id: stageFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: selectedClosedStageIDsComma,
      categories_include_not_set_01: 0,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      graph_type_p0_vb1_hb2_f3: 0,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: -2,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      graph_title: "Closed Stages (# Captures)"
    };

    const closedStagesTcvGraphObj = {
      circleGraphTrueTimeGraphFalse: true,
      sort: 4,
      filter_preset_id: -1,
      categories_field_id: stageFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: selectedClosedStageIDsComma,
      categories_include_not_set_01: 0,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      graph_type_p0_vb1_hb2_f3: 0,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: performanceMoneyFieldID,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      graph_title: "Closed Stages ($ " + c_performanceUserSelectedMoneyFieldDisplayName + ")"
    };

    const reasonsWonNumCapturesTimeGraphObj = {
      sort: 5,
      filter_preset_id: -1,
      date_field_id: awardDateFieldID,
      use_categories_field_01: 1,
      categories_field_id: reasonsWonLostFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: reasonsWonIDsComma,
      categories_include_not_set_01: 0,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      line0_bar1: 0,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: -2,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      time_bins:"yearly",
      graph_title: "Wins by Reason (# Captures)"
    };

    const reasonsWonTcvTimeGraphObj = {
      sort: 6,
      filter_preset_id: -1,
      date_field_id: awardDateFieldID,
      use_categories_field_01: 1,
      categories_field_id: reasonsWonLostFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: reasonsWonIDsComma,
      categories_include_not_set_01: 0,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      line0_bar1: 0,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: performanceMoneyFieldID,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      time_bins:"yearly",
      graph_title: "Wins by Reason ($ " + c_performanceUserSelectedMoneyFieldDisplayName + ")"
    };

    const reasonsLostNumCapturesTimeGraphObj = {
      sort: 7,
      filter_preset_id: -1,
      date_field_id: awardDateFieldID,
      use_categories_field_01: 1,
      categories_field_id: reasonsWonLostFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: reasonsLostIDsComma,
      categories_include_not_set_01: 1,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      line0_bar1: 0,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: -2,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      time_bins:"yearly",
      graph_title: "Losses by Reason (# Captures)"
    };

    const reasonsLostTcvTimeGraphObj = {
      sort: 8,
      filter_preset_id: -1,
      date_field_id: awardDateFieldID,
      use_categories_field_01: 1,
      categories_field_id: reasonsWonLostFieldID,
      all_categories_01: 0,
      categories_option_ids_comma: reasonsLostIDsComma,
      categories_include_not_set_01: 1,
      categories_custom_colors_01: 0,
      categories_custom_colors_colon_comma_list: "",
      line0_bar1: 0,
      legend_01: 1,
      legend_hide_zero_categories_01: 0,
      num_captures_m2_or_money_field_id: performanceMoneyFieldID,
      ignore_shared_percent_calcs_01: c_companyPerformanceGraphsAllUsersIgnoreSharedPercentCalcs01,
      time_bins:"yearly",
      graph_title: "Losses by Reason ($ " + c_performanceUserSelectedMoneyFieldDisplayName + ")"
    };

    var performanceGraphsDataArrayOfObjs = [
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(activePipelineNumCapturesGraphObj, true, dateRangeSelectedStageMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(activePipelineTcvGraphObj, true, dateRangeSelectedStageMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(closedStagesNumCapturesGraphObj, true, dateRangeSelectedStageMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(closedStagesTcvGraphObj, true, dateRangeSelectedStageMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(reasonsWonNumCapturesTimeGraphObj, false, closedWonStagesMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(reasonsWonTcvTimeGraphObj, false, closedWonStagesMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(reasonsLostNumCapturesTimeGraphObj, false, closedLostStagesMatchingCapturesFilterPresetObj),
      this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(reasonsLostTcvTimeGraphObj, false, closedLostStagesMatchingCapturesFilterPresetObj)
    ];

    return(performanceGraphsDataArrayOfObjs);
  }

  get c_myPerformanceMoneyFieldIDsToNotIncludeArray() {
    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    const c_tbl_d_quota = DatabaseMobx.c_tbl_d_quota;
    const selectCaptureRevenueCardMoneyFieldFieldTypeObj = DatabaseMobx.c_selectCaptureRevenueCardMoneyFieldFieldTypeObj;

    var myPerformanceMoneyFieldIDsToNotIncludeArray = [];

    const quotaUser0Division1 = ((o_performanceSelectedUserTrueDivisionFalse) ? (0) : (1));

    if(selectCaptureRevenueCardMoneyFieldFieldTypeObj.selectWithSearchDataObj !== undefined) {
      const allRevenueCardMoneyFieldIDsArray = JSFUNC.copy_array2(selectCaptureRevenueCardMoneyFieldFieldTypeObj.selectWithSearchDataObj.valueArray);
      if(JSFUNC.is_array(allRevenueCardMoneyFieldIDsArray)) {
        myPerformanceMoneyFieldIDsToNotIncludeArray = allRevenueCardMoneyFieldIDsArray; //start with all of the money fields, remove each one that has at least one quota for it
        for(let quotaMap of c_tbl_d_quota.values()) {
          if((quotaMap.get("user0_division1") === quotaUser0Division1) && (quotaMap.get("userdiv_id") === o_performanceSelectedUserOrDivisionID)) {
            var quotaMoneyFieldID = quotaMap.get("money_field_id");
            if(JSFUNC.in_array(quotaMoneyFieldID, myPerformanceMoneyFieldIDsToNotIncludeArray)) {
              myPerformanceMoneyFieldIDsToNotIncludeArray = JSFUNC.remove_all_values_from_array(quotaMoneyFieldID, myPerformanceMoneyFieldIDsToNotIncludeArray);
            }
          }
        }
      }

      //if every money field is still present in the array of values to not include (most obvious example is user has 0 quotas set for any money field), remove the fieldID for contract revenue value so that at least that field shows up in the spinner
      if(myPerformanceMoneyFieldIDsToNotIncludeArray.length === allRevenueCardMoneyFieldIDsArray.length) {
        myPerformanceMoneyFieldIDsToNotIncludeArray = JSFUNC.remove_all_values_from_array(DatabaseMobx.c_fieldMapOfContractRevenueValue.get("id"), myPerformanceMoneyFieldIDsToNotIncludeArray);
      }
    }

    return(myPerformanceMoneyFieldIDsToNotIncludeArray);
  }








  //financial projections
  get c_finProjObj() {
    const c_divexecFilteredCapturesObj = this.c_divexecFilteredCapturesObj;
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    const finprojMoneyFieldID = c_combinedUserObj.divexec_finproj_money_field_id;
    const finprojMoneyExpandedFieldMapOrUndefined = c_tbl_captures_fields.get(finprojMoneyFieldID);

    const filterName = c_divexecFilteredCapturesObj.filterName;
    const excelFilterName = c_divexecFilteredCapturesObj.excelFilterName; //name displayed in the exported xml excel sheet is more verbose for the manual divisions/stages filter
    const filteredCaptureMapsAndTcvMultipliersArrayOfObjs = c_divexecFilteredCapturesObj.filteredCaptureMapsAndTcvMultipliersArrayOfObjs;

    return(this.compute_finproj_obj(filterName, excelFilterName, filteredCaptureMapsAndTcvMultipliersArrayOfObjs, finprojMoneyExpandedFieldMapOrUndefined));
  }

  compute_finproj_obj(i_filterName, i_excelFilterName, i_filteredCaptureMapsAndTcvMultipliersArrayOfObjs, i_finprojMoneyExpandedFieldMapOrUndefined, i_manualLowestFyr=undefined, i_manualHighestFyr=undefined) {
    const c_fieldMapOfOpportunityName = DatabaseMobx.c_fieldMapOfOpportunityName;
    const c_fieldMapOfCaptureManagers = DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfStage = DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfContractStartDate = DatabaseMobx.c_fieldMapOfContractStartDate;
    const c_fieldMapOfContractOverallValue = DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_fieldMapOfPeriodOfPerformance = DatabaseMobx.c_fieldMapOfPeriodOfPerformance;
    const c_fieldMapOfPwin = DatabaseMobx.c_fieldMapOfPwin;
    const c_companyFyrMonthsAndQuartersInfoObj = DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;

    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");
    const contractStartDateFieldDisplayName = c_fieldMapOfContractStartDate.get("display_name");
    const periodOfPerformanceFieldDisplayName = c_fieldMapOfPeriodOfPerformance.get("display_name");

    //field map and info for selected finproj capture money field (if one is selected)
    var validCaptureMoneyFieldSelectedTF = false;
    var finprojMoneyIsPwinTF = false;
    var finprojMoneyExpandedFieldMap = c_fieldMapOfContractOverallValue;
    var finprojMoneyFieldDisplayName = "--No Capture Money Field Selected--";
    if(i_finprojMoneyExpandedFieldMapOrUndefined !== undefined) {
      validCaptureMoneyFieldSelectedTF = true;
      finprojMoneyIsPwinTF = (i_finprojMoneyExpandedFieldMapOrUndefined.get("rawPwinAdjustedContractOverallValueTF") || i_finprojMoneyExpandedFieldMapOrUndefined.get("rawPwinAdjustedContractRevenueValueTF") || i_finprojMoneyExpandedFieldMapOrUndefined.get("rawPwinAdjustedAllocatedRevenueValueTF") || i_finprojMoneyExpandedFieldMapOrUndefined.get("rawPwinAdjustedAllocatedNetValueTF"));
      finprojMoneyExpandedFieldMap = i_finprojMoneyExpandedFieldMapOrUndefined;
      finprojMoneyFieldDisplayName = i_finprojMoneyExpandedFieldMapOrUndefined.get("display_name");
    }

    //get the selected soft-coded capture table columns, or recreate the former hardcoded columns as the default
    const selectedCstColumnPresetID = UserMobx.c_combinedUserObj.divexec_finproj_captures_list_selected_cst_column_preset_id;
    var cstColumnsArrayOfObjs = [];
    if(JSFUNC.select_int_is_filled_out_tf(selectedCstColumnPresetID) || (JSFUNC.is_number_not_nan(selectedCstColumnPresetID) && (selectedCstColumnPresetID <= -100))) {
      const allCstColumnsExpandedPresetObj = CapturesMobx.get_database_or_system_expanded_preset_obj_with_preset_items_arrayOfObjs_from_preset_type_and_preset_id("cstColumns", selectedCstColumnPresetID);
      cstColumnsArrayOfObjs = allCstColumnsExpandedPresetObj.expandedPresetItemsArrayOfObjs;
    }
    else {
      const defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs = [
        {expandedCaptureFieldMap:c_fieldMapOfOpportunityName, widthEm:20, displayNameOverwrite:"Capture Name", valueIsCaptureFullNameTF:true},
        {expandedCaptureFieldMap:c_fieldMapOfCaptureManagers, widthEm:10},
        {expandedCaptureFieldMap:c_fieldMapOfDivisionOwners, widthEm:10},
        {expandedCaptureFieldMap:c_fieldMapOfStage, widthEm:10},
        {expandedCaptureFieldMap:c_fieldMapOfContractStartDate, widthEm:10},
        {expandedCaptureFieldMap:finprojMoneyExpandedFieldMap, widthEm:10, displayNameOverwrite:finprojMoneyFieldDisplayName},
        {expandedCaptureFieldMap:c_fieldMapOfPeriodOfPerformance, widthEm:5}
      ];
      if(finprojMoneyIsPwinTF) {
        defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs.push({expandedCaptureFieldMap:c_fieldMapOfPwin, widthEm:10});
      }
      for(let c = 0; c < defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs.length; c++) {
        cstColumnsArrayOfObjs.push({
          id:(-1 - c),
          cst_column_preset_id:-1,
          capture_field_id:defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs[c].expandedCaptureFieldMap.get("id"),
          width_em:defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs[c].widthEm,
          sort:(c + 1),
          cst_sum_row_01:0,
          displayNameOverwrite:defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs[c].displayNameOverwrite,
          valueIsCaptureFullNameTF:defaultExpandedCaptureFieldMapsAndWidthsArrayOfObjs[c].valueIsCaptureFullNameTF
        });
      }
    }

    const expandedFinProjCstColumnsArrayOfObjs = CapturesMobx.create_cst_expanded_columns_arrayOfObjs_from_cst_columns_arrayOfObjs(cstColumnsArrayOfObjs);
    var filteredCapturesMapOfMaps = new Map();
    for(let captureMapAndTcvMultiplierObj of i_filteredCaptureMapsAndTcvMultipliersArrayOfObjs) {
      filteredCapturesMapOfMaps.set(captureMapAndTcvMultiplierObj.captureMap.get("id"), captureMapAndTcvMultiplierObj.captureMap);
    }
    const cstMaskedCaptureValuesArrayOfObjs = CapturesMobx.create_filtered_cst_masked_capture_values_arrayOfObjs_from_filtered_captures_mapOfMaps_and_expanded_cst_columns_arrayOfObjs_and_sort_capture_field_ids_array(filteredCapturesMapOfMaps, expandedFinProjCstColumnsArrayOfObjs, []);
    var cstMaskedCaptureValuesMap = new Map();
    for(let cstMaskedCaptureValuesObj of cstMaskedCaptureValuesArrayOfObjs) {
      cstMaskedCaptureValuesMap.set(cstMaskedCaptureValuesObj.id, cstMaskedCaptureValuesObj);
    }

    var tableColumnFieldsArrayOfObjs = expandedFinProjCstColumnsArrayOfObjs.map((m_expandedCstColumnObj) => ({
      captureFieldID:m_expandedCstColumnObj.capture_field_id,
      displayName:JSFUNC.prop_value(m_expandedCstColumnObj.displayNameOverwrite, m_expandedCstColumnObj.fieldDisplayName),
      widthEm:m_expandedCstColumnObj.width_em,
      valueIsCaptureFullNameTF:m_expandedCstColumnObj.valueIsCaptureFullNameTF
    }));
    tableColumnFieldsArrayOfObjs.push({captureFieldID:undefined, displayName:"$ Value per Month", widthEm:10});

    //count the number of table column fields
    const numTableColumnFields = tableColumnFieldsArrayOfObjs.length;

    //determine the current fyr year and month based on today's date
    const nowJsDateObj = new Date();
    const nowYear = nowJsDateObj.getFullYear();
    const nowMonthNum0to11 = nowJsDateObj.getMonth();
    const nowFyrObj = DatabaseMobx.convert_year_month0to11_to_fyrYear_fyrMonth0to11_obj(nowYear, nowMonthNum0to11);
    const nowFyrYear = nowFyrObj.fyrYear;
    const nowFyrMonth0to11 = nowFyrObj.fyrMonth0to11;

    //first loop to copy capture fields, compute contract end date, determine earliest and latest dates
    var lowestFyr = undefined;
    var highestFyr = undefined;
    var finProjCapturesArrayOfObjs = [];
    for(let catureMapAndTcvMultiplierObj of  i_filteredCaptureMapsAndTcvMultipliersArrayOfObjs) {
      var captureMap = catureMapAndTcvMultiplierObj.captureMap;
      var partialMultiplier0to1 = catureMapAndTcvMultiplierObj.partialMultiplier0to1;

      //get info about this capture
      var captureID = captureMap.get("id");
      var captureStageID = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, c_fieldMapOfStage);

      var contractStartDateValueMaskSortIfoCanEditObj = DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMap, c_fieldMapOfContractStartDate);
      var csdValueRaw = contractStartDateValueMaskSortIfoCanEditObj.valueRaw;
      var csdSort = contractStartDateValueMaskSortIfoCanEditObj.valueSort;
      var csdValidTF = (contractStartDateValueMaskSortIfoCanEditObj.isFilledOutTF && (csdValueRaw > "1950-01-01") && (csdValueRaw < "3001-01-01"));

      var popValueRaw = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, c_fieldMapOfPeriodOfPerformance);
      var popValidTF = JSFUNC.is_number_not_nan_gt_0(popValueRaw);

      //selected finproj money field (or COV if none selected)
      var captureMoneyFieldValueRaw = 0;
      var capturePartialMoneyFieldValueRaw = 0;
      if(validCaptureMoneyFieldSelectedTF) {
        captureMoneyFieldValueRaw = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, i_finprojMoneyExpandedFieldMapOrUndefined);
        capturePartialMoneyFieldValueRaw = ((partialMultiplier0to1 < 1) ? (captureMoneyFieldValueRaw * partialMultiplier0to1) : (captureMoneyFieldValueRaw)); //compute the partial TCV from the provided expanded filters in the filter preset
      }

      //valuePerMonth special masking initialization
      var captureValuePerMonthRawOverwrite = undefined;
      var captureValuePerMonthPlainTextOverwrite = undefined;

      //initialize date calculations collected in output obj
      var contractEndDate = undefined; //flag that the contract start date and pop were both valid if this is not undefined
      var startFyrYear = undefined;
      var startFyrMonthNum0to11 = undefined;
      var endFyrYear = undefined;
      var endFyrMonthNum0to11 = undefined;
      var valuePerMonth = undefined;
      var firstMonthValue = undefined;
      var lastMonthValue = undefined;
      if(!(csdValidTF && popValidTF)) { //either CSD or PoP is invalid
        captureValuePerMonthRawOverwrite = 0;
        captureValuePerMonthPlainTextOverwrite = "--" + ((!csdValidTF) ? (contractStartDateFieldDisplayName) : (periodOfPerformanceFieldDisplayName)) + " is invalid--";
      }
      else { //both CSD and PoP are valid
        var startJsDateObj = JSFUNC.convert_mysqldate_to_jsdateobj(csdValueRaw);
        var startYear = startJsDateObj.getFullYear();
        var startMonthNum0to11 = startJsDateObj.getMonth();
        var startDate1to31 = startJsDateObj.getDate();

        //compute the contract end date by adding the number of pop months to the start date, then moving back one day
        startJsDateObj.setMonth(startMonthNum0to11 + popValueRaw);
        startJsDateObj.setDate(startDate1to31 - 1);
        var endYear = startJsDateObj.getFullYear();
        var endMonthNum0to11 = startJsDateObj.getMonth();
        var endDate1to31 = startJsDateObj.getDate();
        contractEndDate = endYear + "-" + (endMonthNum0to11 + 1) + "-" + endDate1to31;

        //calculate the COV per month (COV/pop)
        valuePerMonth = (capturePartialMoneyFieldValueRaw / popValueRaw); //ok for popValueRaw to be in denominator as it was checked above to be a number and >0
        captureValuePerMonthRawOverwrite = valuePerMonth; //specify the raw overwrite, but not the plaintext to mask this value with the COV field type styling

        //calculate the COV in the first month (could be a fraction of the valuePerMonth if the start date is not on the first)
        if(startDate1to31 === 1) {
          firstMonthValue = valuePerMonth;
          lastMonthValue = valuePerMonth;
        }
        else {
          var thirtyMinusDate = (30 - startDate1to31);
          if(thirtyMinusDate <= 0) {
            thirtyMinusDate = 1;
          }
          firstMonthValue = ((thirtyMinusDate / 30) * valuePerMonth);
          lastMonthValue = (valuePerMonth - firstMonthValue);
        }

        //determine the lowest/highest fyr year and month
        var startFyrObj = DatabaseMobx.convert_year_month0to11_to_fyrYear_fyrMonth0to11_obj(startYear, startMonthNum0to11);
        startFyrYear = startFyrObj.fyrYear;
        startFyrMonthNum0to11 = startFyrObj.fyrMonth0to11;

        if((lowestFyr === undefined) || (startFyrYear < lowestFyr)) {
          lowestFyr = startFyrYear;
        }

        var endFyrObj = DatabaseMobx.convert_year_month0to11_to_fyrYear_fyrMonth0to11_obj(endYear, endMonthNum0to11);
        endFyrYear = endFyrObj.fyrYear;
        endFyrMonthNum0to11 = endFyrObj.fyrMonth0to11;

        if((highestFyr === undefined) || (endFyrYear > highestFyr)) {
          highestFyr = endFyrYear;
        }
      }

      const cstMaskedCaptureValuesObj = cstMaskedCaptureValuesMap.get(captureID);
      var tableColumnCaptureFieldValueArrayOfObjs = [];
      for(let expandedCstColumnObj of expandedFinProjCstColumnsArrayOfObjs) {
        const captureFieldID = expandedCstColumnObj.capture_field_id;
        const fieldTypeObj = expandedCstColumnObj.expandedCaptureFieldMap.get("fieldTypeObj");
        const valueIsCaptureFullNameTF = (expandedCstColumnObj.valueIsCaptureFullNameTF === true);
        const valueMaskPlainText = ((valueIsCaptureFullNameTF) ? (cstMaskedCaptureValuesObj.captureFullName) : (cstMaskedCaptureValuesObj[captureFieldID + "MASKPT"]));
        tableColumnCaptureFieldValueArrayOfObjs.push({
          valueMaskPlainText:valueMaskPlainText,
          valueMaskCsvXmlPlainText:((valueIsCaptureFullNameTF) ? (valueMaskPlainText) : (cstMaskedCaptureValuesObj[captureFieldID + "MASKCXPT"])),
          valueMask:((valueIsCaptureFullNameTF) ? (valueMaskPlainText) : (cstMaskedCaptureValuesObj[captureFieldID + "MASKNCL"])),
          moneyTF:((fieldTypeObj !== undefined) && fieldTypeObj.moneyTF),
          percentTF:((fieldTypeObj !== undefined) && fieldTypeObj.percentTF),
          valueDisplayIsNumericTF:((fieldTypeObj !== undefined) && fieldTypeObj.valueDisplayIsNumericTF),
          cstCellAlignClass:expandedCstColumnObj.cstCellAlignClass
        });
      }

      const valuePerMonthMaskSortIfoObj = DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(captureValuePerMonthRawOverwrite, c_fieldMapOfContractOverallValue.get("fieldTypeObj"));
      tableColumnCaptureFieldValueArrayOfObjs.push({
        valueMaskPlainText:((captureValuePerMonthPlainTextOverwrite !== undefined) ? (captureValuePerMonthPlainTextOverwrite) : (valuePerMonthMaskSortIfoObj.valueMaskPlainText)),
        valueMaskCsvXmlPlainText:valuePerMonthMaskSortIfoObj.valueMaskCsvXmlPlainText,
        valueMask:((captureValuePerMonthPlainTextOverwrite !== undefined) ? (DatabaseMobx.error_font_html(captureValuePerMonthPlainTextOverwrite)) : (valuePerMonthMaskSortIfoObj.valueMask)),
        moneyTF:true,
        percentTF:false,
        valueDisplayIsNumericTF:true,
        cstCellAlignClass:c_fieldMapOfContractOverallValue.get("cstCellAlignClass")
      });

      //push the final finProjCaptureObj into the accumulating array
      finProjCapturesArrayOfObjs.push({
        id: captureID,
        stageID: captureStageID,
        csdSort: csdSort,
        contractEndDate: contractEndDate,
        finProjCaptureIsValidTF: (contractEndDate !== undefined),
        startFyrYear: startFyrYear,
        startFyrMonthNum0to11: startFyrMonthNum0to11,
        startDate1to31: startDate1to31,
        endFyrYear: endFyrYear,
        endFyrMonthNum0to11: endFyrMonthNum0to11,
        valuePerMonth: valuePerMonth,
        firstMonthValue: firstMonthValue,
        lastMonthValue: lastMonthValue,
        tableColumnCaptureFieldValueArrayOfObjs: tableColumnCaptureFieldValueArrayOfObjs
      });
    }

    //if a manual lowest/highest fyr was provided as input, use those values
    if(JSFUNC.is_number(i_manualLowestFyr) && JSFUNC.is_number(i_manualHighestFyr) && (i_manualHighestFyr >= i_manualLowestFyr)) {
      lowestFyr = i_manualLowestFyr;
      highestFyr = i_manualHighestFyr;
    }

    //if the lowest/highest fyr values are still undefined, that means there are 0 captures that have a valid contract start date and pop for this capture filter, set the low/high fyr as the current year
    if((lowestFyr === undefined) || (highestFyr === undefined)) {
      lowestFyr = nowFyrYear;
      highestFyr = nowFyrYear;
    }

    //create the data matrix fyr row labels array
    var fyrArray = [];
    for(let fyr = lowestFyr; fyr <= highestFyr; fyr++) {
      fyrArray.push(fyr);
    }
    const numYears = fyrArray.length;

    //initialize a data matrix with rows for fyr from lowest to highest (indexed 0 to Y-1), and 12 columns for each month (indexed 0 to 11)
    const moneyValueMatrix = this.finproj_compute_monthly_money_value_matrix_for_all_fyr(finProjCapturesArrayOfObjs, fyrArray, undefined);

    //loop through every finProj capture obj and add their split tcv across the data matrix fyr/months
    for(let finProjCaptureObj of finProjCapturesArrayOfObjs) {
      var captureMoneyValuePerFyrArray = JSFUNC.array_fill(numYears, 0); //initialize a TCV per FYR matrix for each capture
      if(finProjCaptureObj.finProjCaptureIsValidTF) { //only compute this capture if it has a valid contract end date
        var endReachedTF = false; //turns true when the last data for the contract end date has been filled in, no other future fyr or months need to be checked after this point and while loops stop
        var y = 0;
        while(!endReachedTF && y < numYears) {
          var fyr = fyrArray[y];
          var m = 0;
          while(!endReachedTF && m < 12) {
            if(fyr >= finProjCaptureObj.endFyrYear && m >= finProjCaptureObj.endFyrMonthNum0to11) { //end condition of last month of last fyr
              captureMoneyValuePerFyrArray[y] += finProjCaptureObj.lastMonthValue;
              endReachedTF = true;
            }
            else if(fyr === finProjCaptureObj.startFyrYear) { //first fyr
              if(m === finProjCaptureObj.startFyrMonthNum0to11) { //first month of first fyr, could be split based on if start date is 1st of month or later in the month
                captureMoneyValuePerFyrArray[y] += finProjCaptureObj.firstMonthValue;
              }
              else if(m > finProjCaptureObj.startFyrMonthNum0to11) { //other months within the first year
                captureMoneyValuePerFyrArray[y] += finProjCaptureObj.valuePerMonth;
              }
            }
            else if(fyr > finProjCaptureObj.startFyrYear) {
              captureMoneyValuePerFyrArray[y] += finProjCaptureObj.valuePerMonth;
            }
            m++;
          }
          y++;
        }
      }
      finProjCaptureObj.captureMoneyValuePerFyrArray = captureMoneyValuePerFyrArray; //place the calculated TCV/FYR array for this capture with the captureObj
    }

    //compute a total TCV per fyr array for the last column of the finProj table
    var totalMoneyValuePerFyrArray = [];
    for(let y = 0; y < numYears; y++) {
      totalMoneyValuePerFyrArray[y] = 0; //initialize the fyr total to 0 to sum the months together in this fyr
      for(let m = 0; m < 12; m++) {
        totalMoneyValuePerFyrArray[y] += moneyValueMatrix[y][m];
      }
    }

    //compute a total TCV for all fyr
    var totalTcv = 0;
    for(let y = 0; y < numYears; y++) {
      totalTcv += totalMoneyValuePerFyrArray[y];
    }

    //sort the captures table by the contract start date
    JSFUNC.sort_arrayOfObjs(finProjCapturesArrayOfObjs, "csdSort", true);
    const numCaptures = finProjCapturesArrayOfObjs.length;

    //return the finProjObj
    return({
      fyrArray: fyrArray,
      numYears: numYears,
      fyrMthLabelsArray: c_companyFyrMonthsAndQuartersInfoObj.fyrMthNamesArray,
      moneyValueMatrix: moneyValueMatrix,
      totalMoneyValuePerFyrArray: totalMoneyValuePerFyrArray,
      totalTcv: totalTcv,
      finProjCapturesArrayOfObjs: finProjCapturesArrayOfObjs,
      numCaptures: numCaptures,
      filterName: i_filterName,
      excelFilterName: i_excelFilterName,
      finprojMoneyFieldDisplayName: finprojMoneyFieldDisplayName,
      includePwinTF: finprojMoneyIsPwinTF,
      tableColumnFieldsArrayOfObjs: tableColumnFieldsArrayOfObjs,
      numTableColumnFields: numTableColumnFields
    });
  }


  finproj_compute_monthly_money_value_matrix_for_all_fyr(i_finProjCapturesArrayOfObjs, i_fyrArray, i_stageIDsArrayToFilterOrUndefined) {
    const numYears = i_fyrArray.length;
    const filteringByStageIDsTF = JSFUNC.is_array(i_stageIDsArrayToFilterOrUndefined);

    //initialize each fyr/month cell to $0
    var moneyValueMatrix = JSFUNC.zeros_arrayOfArrays(numYears, 12);

    //loop through every finProj capture obj and add their split tcv across the data matrix fyr/months
    for(let finProjCaptureObj of i_finProjCapturesArrayOfObjs) {
      if(finProjCaptureObj.finProjCaptureIsValidTF) { //only compute this capture if it has a valid contract end date
        if(!filteringByStageIDsTF || JSFUNC.in_array(finProjCaptureObj.stageID, i_stageIDsArrayToFilterOrUndefined)) { //only compute this capture if it is within the requested stage(s)
          var endReachedTF = false; //turns true when the last data for the contract end date has been filled in, no other future fyr or months need to be checked after this point and while loops stop
          var y = 0;
          while(!endReachedTF && (y < numYears)) {
            var fyr = i_fyrArray[y];
            var m = 0;
            while(!endReachedTF && (m < 12)) {
              if((fyr >= finProjCaptureObj.endFyrYear) && (m >= finProjCaptureObj.endFyrMonthNum0to11)) { //end condition of last month of last fyr
                moneyValueMatrix[y][m] += finProjCaptureObj.lastMonthValue;
                endReachedTF = true;
              }
              else if(fyr === finProjCaptureObj.startFyrYear) { //first fyr
                if(m === finProjCaptureObj.startFyrMonthNum0to11) { //first month of first fyr, could be split based on if start date is 1st of month or later in the month
                  moneyValueMatrix[y][m] += finProjCaptureObj.firstMonthValue;
                }
                else if(m > finProjCaptureObj.startFyrMonthNum0to11) { //other months within the first year
                  moneyValueMatrix[y][m] += finProjCaptureObj.valuePerMonth;
                }
              }
              else if(fyr > finProjCaptureObj.startFyrYear) {
                moneyValueMatrix[y][m] += finProjCaptureObj.valuePerMonth;
              }
              m++;
            }
            y++;
          }
        }
      }
    }

    return(moneyValueMatrix);
  }


  get c_finProjYearlyGraphObj() {
    const c_finProjObj = this.c_finProjObj;
    const c_tbl_d_quota = DatabaseMobx.c_tbl_d_quota;
    const c_closedWonStageIDsArray = DatabaseMobx.c_closedWonStageIDsArray;
    const c_companyFyrMonthsAndQuartersInfoObj = DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    const fyrArray = c_finProjObj.fyrArray;
    const numYears = c_finProjObj.numYears;
    const companyFyrStartMonthIndex0to11 = c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11;
    const userSelectedStackedAreaActiveStageIDsArray = JSFUNC.convert_comma_list_to_int_array(c_combinedUserObj.divexec_finproj_stacked_area_active_stage_ids_comma);
    const displayStackedAreaGraphTF = (c_combinedUserObj.divexec_finproj_view_stackedarea0_vbars1 === 0);
    const nowYearInt = JSFUNC.now_year_int();

    //initialize graph categories
    var categoriesArrayOfObjs = [];

    //1) all won captures stackedArea
    const wonCapturesStackedAreaMoneyValueMatrix = this.finproj_compute_monthly_money_value_matrix_for_all_fyr(c_finProjObj.finProjCapturesArrayOfObjs, c_finProjObj.fyrArray, c_closedWonStageIDsArray);
    categoriesArrayOfObjs.push({
      idDateValueArrayOfObjs: this.finproj_convert_money_value_matrix_to_category_id_date_value_arrayOfObjs(wonCapturesStackedAreaMoneyValueMatrix, c_combinedUserObj.divexec_finproj_view_y0q1m2, c_finProjObj.fyrArray, companyFyrStartMonthIndex0to11),
      color: "33aa33",
      opacity0to1: 0.75,
      label: "All Won Captures (Backlog)",
      stackedAreaLineTF: displayStackedAreaGraphTF
    });

    //2) each selected active stage as a stackedArea
    for(let activeStageID of userSelectedStackedAreaActiveStageIDsArray) {
      var stageMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_stages_pool", activeStageID);
      var activeStageCapturesStackedAreaMoneyValueMatrix = this.finproj_compute_monthly_money_value_matrix_for_all_fyr(c_finProjObj.finProjCapturesArrayOfObjs, c_finProjObj.fyrArray, [activeStageID]);
      categoriesArrayOfObjs.push({
        idDateValueArrayOfObjs: this.finproj_convert_money_value_matrix_to_category_id_date_value_arrayOfObjs(activeStageCapturesStackedAreaMoneyValueMatrix, c_combinedUserObj.divexec_finproj_view_y0q1m2, c_finProjObj.fyrArray, companyFyrStartMonthIndex0to11),
        color: stageMap.get("color"),
        opacity0to1: 0.4,
        label: stageMap.get("name"),
        stackedAreaLineTF: displayStackedAreaGraphTF
      });
    }

    //3) goal line for selected division
    //precompute all matching goals for the selected division and money field
    const allMatchingGoalsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(c_tbl_d_quota, ["user0_division1", "userdiv_id", "money_field_id"], [1, c_combinedUserObj.divexec_finproj_goals_division_id, c_combinedUserObj.divexec_finproj_money_field_id], "fyr", true);

    var goalsLowestFyr = undefined;
    var goalsHighestFyr = undefined;
    for(let matchingGoalsObj of allMatchingGoalsArrayOfObjs) {
      const goalFyr = matchingGoalsObj.fyr;
      if(JSFUNC.is_number(goalFyr)) {
        if((goalsLowestFyr === undefined) || (goalFyr < goalsLowestFyr)) {
          goalsLowestFyr = goalFyr;
        }
        if((goalsHighestFyr === undefined) || (goalFyr > goalsHighestFyr)) {
          goalsHighestFyr = goalFyr;
        }
      }
    }

    var goalsFyrArray = [];
    if((goalsLowestFyr !== undefined) && (goalsHighestFyr !== undefined)) {
      for(let fyr = goalsLowestFyr; fyr <= goalsHighestFyr; fyr++) {
        goalsFyrArray.push(fyr);
      }
    }

    const goalsNumYears = goalsFyrArray.length;
    var goalsMoneyValueMatrix = JSFUNC.zeros_arrayOfArrays(goalsNumYears, 12); //build a moneyValueMatrix[y][m] for all goals fyr for this finproj selected money field
    if(JSFUNC.select_int_is_filled_out_tf(c_combinedUserObj.divexec_finproj_money_field_id)) { //no need to search for goals if no money field is selected
      if(JSFUNC.select_int_is_filled_out_tf(c_combinedUserObj.divexec_finproj_goals_division_id)) { //no need to search for goals if no goals divisionID is selected
        for(let y = 0; y < goalsNumYears; y++) {
          var fyr = goalsFyrArray[y];
          var matchingGoalsObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(allMatchingGoalsArrayOfObjs, "fyr", fyr);
          if(matchingGoalsObjOrUndefined !== undefined) {
            var waterfallProjectionsWonGoalYqmObj = matchingGoalsObjOrUndefined.waterfallProjectionsWonGoalYqmObj;
            for(let m = 0; m < 12; m++) {
              goalsMoneyValueMatrix[y][m] = waterfallProjectionsWonGoalYqmObj.monthly12Array[m];
            }
          }
        }
      }
    }

    const selectedGoalsDivisionMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_divisions", c_combinedUserObj.divexec_finproj_goals_division_id);
    
    categoriesArrayOfObjs.push({
      idDateValueArrayOfObjs: this.finproj_convert_money_value_matrix_to_category_id_date_value_arrayOfObjs(goalsMoneyValueMatrix, c_combinedUserObj.divexec_finproj_view_y0q1m2, goalsFyrArray, companyFyrStartMonthIndex0to11),
      color: "000099",
      label: "Goal (" + selectedGoalsDivisionMap.get("name") + ")",
      stackedAreaLineTF: false,
      forceLineOverBarTF: true
    });
    
    //start/end dates
    var startDate = nowYearInt + "-01-01";
    var endDate = nowYearInt + "-12-31";

    var lowestFyrAcrossFinProjAndGoals = undefined;
    var highestFyrAcrossFinProjAndGoals = undefined;
    if(numYears > 0) {
      lowestFyrAcrossFinProjAndGoals = fyrArray[0];
      highestFyrAcrossFinProjAndGoals = fyrArray[numYears - 1];
    }

    if(goalsNumYears > 0) {
      if((lowestFyrAcrossFinProjAndGoals === undefined) || (goalsFyrArray[0] < lowestFyrAcrossFinProjAndGoals)) {
        lowestFyrAcrossFinProjAndGoals = goalsFyrArray[0];
      }
      if((highestFyrAcrossFinProjAndGoals === undefined) || (goalsFyrArray[goalsNumYears - 1] > highestFyrAcrossFinProjAndGoals)) {
        highestFyrAcrossFinProjAndGoals = goalsFyrArray[goalsNumYears - 1];
      }
    }

    if((lowestFyrAcrossFinProjAndGoals !== undefined) && (highestFyrAcrossFinProjAndGoals !== undefined)) {
      startDate = this.finproj_date_from_fyr_and_month_index(lowestFyrAcrossFinProjAndGoals, 0, companyFyrStartMonthIndex0to11);
      endDate = this.finproj_date_from_fyr_and_month_index((highestFyrAcrossFinProjAndGoals + 1), 0, companyFyrStartMonthIndex0to11);
    }

    if(JSFUNC.date_is_filled_out_tf(c_combinedUserObj.divexec_finproj_view_start_date)) {
      startDate = c_combinedUserObj.divexec_finproj_view_start_date;
    }

    if(JSFUNC.date_is_filled_out_tf(c_combinedUserObj.divexec_finproj_view_end_date)) {
      endDate = c_combinedUserObj.divexec_finproj_view_end_date;
    }

    return({
      categoriesArrayOfObjs: categoriesArrayOfObjs,
      startDate: startDate,
      endDate: endDate
    });
  }


  finproj_date_from_fyr_and_month_index(i_fyr, i_fyrMonthIndex0to11, i_fyrStartMonthIndex0to11) {
    const realMonthYearObj = JSFUNC.compute_real_year_month_obj_from_fyr_month_index0to11_and_fyr_start_month0to11(i_fyr, i_fyrMonthIndex0to11, i_fyrStartMonthIndex0to11);
    return(realMonthYearObj.realYear + "-" + JSFUNC.zero_pad_integer_from_left((realMonthYearObj.realMonthIndex0To11 + 1), 2) + "-01");
  }


  finproj_convert_money_value_matrix_to_category_id_date_value_arrayOfObjs(moneyValueMatrix, i_viewY0Q1M2, i_fyrArray, i_fyrStartMonthIndex0to11) {
    var idDateValueArrayOfObjs = [];
    if(i_viewY0Q1M2 == 1) { //quarterly
      for(let y = 0; y < i_fyrArray.length; y++) {
        for(let q = 0; q < 4; q++) {
          for(let qm = 0; qm < 3; qm++) {
            var m = ((q*3) + qm);
            idDateValueArrayOfObjs.push({
              id: i_fyrArray[y] + "-" + (q + 1),
              date: this.finproj_date_from_fyr_and_month_index(i_fyrArray[y], m, i_fyrStartMonthIndex0to11),
              value: moneyValueMatrix[y][m]
            });
          }
        }
      }
    }
    else if(i_viewY0Q1M2 == 2) { //monthly
      for(let y = 0; y < i_fyrArray.length; y++) {
        for(let m = 0; m < 12; m++) {
          idDateValueArrayOfObjs.push({
            id: i_fyrArray[y] + "-" + JSFUNC.zero_pad_integer_from_left((m + 1), 2),
            date: this.finproj_date_from_fyr_and_month_index(i_fyrArray[y], m, i_fyrStartMonthIndex0to11),
            value: moneyValueMatrix[y][m]
          });
        }
      }
    }
    else { //yearly
      for(let y = 0; y < i_fyrArray.length; y++) {
        idDateValueArrayOfObjs.push({
          id: i_fyrArray[y],
          date: this.finproj_date_from_fyr_and_month_index(i_fyrArray[y], 0, i_fyrStartMonthIndex0to11),
          value: JSFUNC.array_sum(moneyValueMatrix[y])
        });
      }
    }
    return(idDateValueArrayOfObjs);
  }


  get c_finProjEditingWaterfallGoalSingleFyrYqmObjOrUndefined() {
    const o_finProjGraphEditingGoalFyr = this.o_finProjGraphEditingGoalFyr;
    const c_tbl_d_quota = DatabaseMobx.c_tbl_d_quota;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    /*var v = "c_tbl_d_quota";
    for(let qMap of c_tbl_d_quota.values()) {
      v += "\ni:" + qMap.get("id") + ", d:" + qMap.get("userdiv_id") + ", m:" + qMap.get("money_field_id") + ", y:" + qMap.get("fyr") + ", w:" + qMap.get("waterfall_projections_won_goal_12_months_comma");
    }alert(v)

    alert("request:\nuserdiv_id: " + c_combinedUserObj.divexec_finproj_goals_division_id + "\nmoney_field_id: " + c_combinedUserObj.divexec_finproj_money_field_id + "\nfyr: " + o_finProjGraphEditingGoalFyr);*/

    if(JSFUNC.select_int_is_filled_out_tf(c_combinedUserObj.divexec_finproj_money_field_id)) { //no need to search for goals if no money field is selected
      if(JSFUNC.select_int_is_filled_out_tf(c_combinedUserObj.divexec_finproj_goals_division_id)) { //no need to search for goals if no goals divisionID is selected
        const matchingGoalsMapOrUndefined = JSFUNC.get_first_map_matching_field_value(c_tbl_d_quota, ["user0_division1", "userdiv_id", "money_field_id", "fyr"], [1, c_combinedUserObj.divexec_finproj_goals_division_id, c_combinedUserObj.divexec_finproj_money_field_id, o_finProjGraphEditingGoalFyr]);
        if(matchingGoalsMapOrUndefined !== undefined) {
          const matchingWaterfallProjectionsWonGoalYqmObj = matchingGoalsMapOrUndefined.get("waterfallProjectionsWonGoalYqmObj");//alert(JSFUNC.print_obj_vertical(matchingWaterfallProjectionsWonGoalYqmObj) + "\n\nmonth12: " + JSFUNC.print_array(matchingWaterfallProjectionsWonGoalYqmObj.monthly12Array))
          return(matchingWaterfallProjectionsWonGoalYqmObj);
        }
      }
    }//alert('no match!')
    return(undefined);
  }


  generate_finproj_excel_xml_string(i_finProjObj) {
    const fyrArray = i_finProjObj.fyrArray;
    const numYears = i_finProjObj.numYears;
    const fyrMthLabelsArray = i_finProjObj.fyrMthLabelsArray;
    const moneyValueMatrix = i_finProjObj.moneyValueMatrix;
    const totalMoneyValuePerFyrArray = i_finProjObj.totalMoneyValuePerFyrArray;
    const totalTcv = i_finProjObj.totalTcv;
    const finProjCapturesArrayOfObjs = i_finProjObj.finProjCapturesArrayOfObjs;
    const numCaptures = i_finProjObj.numCaptures;
    const filterName = i_finProjObj.filterName;
    const excelFilterName = i_finProjObj.excelFilterName;
    const includePwinTF = i_finProjObj.includePwinTF;
    const finprojMoneyFieldDisplayName = i_finProjObj.finprojMoneyFieldDisplayName;
    const tableColumnFieldsArrayOfObjs = i_finProjObj.tableColumnFieldsArrayOfObjs;
    const numTableColumnFields = i_finProjObj.numTableColumnFields;

    const includePwinYesNoString = ((includePwinTF) ? ("Yes") : ("No"));

  	var xmlOut = '<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?>';
  	xmlOut += '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns:html="http://www.w3.org/TR/REC-html40">';
  	xmlOut += '<DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"><Author>CaptureExec</Author><LastAuthor>CaptureExec</LastAuthor><Created>2017-09-30T10:20:40Z</Created><LastSaved>2017-09-30T10:58:22Z</LastSaved><Version>12.00</Version></DocumentProperties>';
  	xmlOut += '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><WindowHeight>7995</WindowHeight><WindowWidth>15315</WindowWidth><WindowTopX>0</WindowTopX><WindowTopY>75</WindowTopY><ProtectStructure>False</ProtectStructure><ProtectWindows>False</ProtectWindows></ExcelWorkbook>';

  	xmlOut += '<Styles>';
  	xmlOut += '<Style ss:ID="Default" ss:Name="Normal"><Alignment ss:Vertical="Bottom"/><Borders/><Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000"/><Interior/><NumberFormat/><Protection/></Style>';
  	xmlOut += '<Style ss:ID="s18" ss:Name="Currency"><NumberFormat ss:Format="_(&quot;$&quot;* #,##0.00_);_(&quot;$&quot;* \(#,##0.00\);_(&quot;$&quot;* &quot;-&quot;??_);_(@_)"/></Style>';
  	xmlOut += '<Style ss:ID="s20" ss:Name="Percent"><NumberFormat ss:Format="0%"/></Style>';
  	xmlOut += '<Style ss:ID="s62"><Alignment ss:Horizontal="Center" ss:Vertical="Bottom"/><Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000" ss:Bold="1"/></Style>';
  	xmlOut += '<Style ss:ID="s65"><Alignment ss:Horizontal="Left" ss:Vertical="Bottom"/></Style>';
  	xmlOut += '<Style ss:ID="s66"><Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000" ss:Bold="1"/></Style>';
  	xmlOut += '<Style ss:ID="s68" ss:Parent="s18"><Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000"/><NumberFormat ss:Format="&quot;$&quot;#,##0"/></Style>';
  	xmlOut += '<Style ss:ID="s69"><Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000" ss:Bold="1"/><NumberFormat ss:Format="&quot;$&quot;#,##0"/></Style>';
  	xmlOut += '<Style ss:ID="s71" ss:Parent="s20"><Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="11" ss:Color="#000000"/></Style>';
  	xmlOut += '<Style ss:ID="s72"><NumberFormat ss:Format="Short Date"/></Style>';
  	xmlOut += '</Styles>';

  	xmlOut += '<Worksheet ss:Name="Summary">';
  	xmlOut += '<Table ss:ExpandedColumnCount="14" ss:ExpandedRowCount="' + (11 + numYears) + '" x:FullColumns="1" x:FullRows="1" ss:DefaultRowHeight="15">';
  	xmlOut += '<Column ss:StyleID="s62" ss:AutoFitWidth="0" ss:Width="35.25"/>';
  	xmlOut += '<Column ss:AutoFitWidth="0" ss:Width="100" ss:Span="11"/>';
  	xmlOut += '<Column ss:Index="14" ss:AutoFitWidth="0" ss:Width="150"/>';
  	xmlOut += '<Row ss:AutoFitHeight="0"><Cell ss:MergeAcross="13"><Data ss:Type="String">CaptureExec Financial Projections</Data></Cell></Row>';
  	xmlOut += '<Row ss:AutoFitHeight="0"><Cell ss:MergeAcross="13" ss:StyleID="s65"><Data ss:Type="String">$ Value Field Used: ' + JSFUNC.htmlspecialchars(finprojMoneyFieldDisplayName) + '</Data></Cell></Row>';
  	xmlOut += '<Row ss:AutoFitHeight="0"><Cell ss:MergeAcross="13" ss:StyleID="s65"><Data ss:Type="String">Capture Filter: ' + JSFUNC.htmlspecialchars(excelFilterName) + '</Data></Cell></Row>';
  	xmlOut += '<Row ss:AutoFitHeight="0"><Cell ss:MergeAcross="13" ss:StyleID="s65"><Data ss:Type="String">Multiply PWin into TCV: ' + includePwinYesNoString + '</Data></Cell></Row>';
  	xmlOut += '<Row ss:AutoFitHeight="0" ss:StyleID="s66">';
  	xmlOut += '<Cell ss:StyleID="s62"/>';
  	xmlOut += '<Cell ss:MergeAcross="2" ss:StyleID="s62"><Data ss:Type="String">Q1</Data></Cell>';
  	xmlOut += '<Cell ss:MergeAcross="2" ss:StyleID="s62"><Data ss:Type="String">Q2</Data></Cell>';
  	xmlOut += '<Cell ss:MergeAcross="2" ss:StyleID="s62"><Data ss:Type="String">Q3</Data></Cell>';
  	xmlOut += '<Cell ss:MergeAcross="2" ss:StyleID="s62"><Data ss:Type="String">Q4</Data></Cell>';
  	xmlOut += '</Row>';
  	xmlOut += '<Row ss:AutoFitHeight="0" ss:StyleID="s62">';
  	xmlOut += '<Cell><Data ss:Type="String">FYR</Data></Cell>';
    for(let m = 0; m < 12; m++) {
      xmlOut += '<Cell><Data ss:Type="String">' + fyrMthLabelsArray[m] + '</Data></Cell>';
    }
  	xmlOut += '<Cell><Data ss:Type="String">Total</Data></Cell>';
  	xmlOut += '</Row>';

  	//summary data rows
  	for(let y = 0; y < numYears; y++) {
  		xmlOut += '<Row ss:AutoFitHeight="0">';
  		xmlOut += '<Cell><Data ss:Type="Number">' + fyrArray[y] + '</Data></Cell>';
      for(let m = 0; m < 12; m++) {
        xmlOut += '<Cell ss:StyleID="s68"><Data ss:Type="Number">' + moneyValueMatrix[y][m] + '</Data></Cell>';
      }
    	xmlOut += '<Cell ss:StyleID="s68"><Data ss:Type="Number">' + totalMoneyValuePerFyrArray[y] + '</Data></Cell>';
  		xmlOut += '</Row>';
  	}

  	//summary total
  	xmlOut += '<Row ss:AutoFitHeight="0"><Cell ss:MergeAcross="12"/><Cell ss:StyleID="s69"><Data ss:Type="Number">' + totalTcv + '</Data></Cell></Row>';

  	//summary end of worksheet
  	xmlOut += '</Table>';
  	xmlOut += '<WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">';
  	xmlOut += '<PageSetup><Header x:Margin="0.3"/><Footer x:Margin="0.3"/><PageMargins x:Bottom="0.75" x:Left="0.7" x:Right="0.7" x:Top="0.75"/></PageSetup>';
  	xmlOut += '<Unsynced/>';
  	xmlOut += '<Print><ValidPrinterInfo/><HorizontalResolution>-3</HorizontalResolution><VerticalResolution>0</VerticalResolution></Print>';
  	xmlOut += '<Selected/>';
  	xmlOut += '<Panes><Pane><Number>3</Number><ActiveRow>6</ActiveRow></Pane></Panes>';
  	xmlOut += '<ProtectObjects>False</ProtectObjects>';
  	xmlOut += '<ProtectScenarios>False</ProtectScenarios>';
  	xmlOut += '</WorksheetOptions>';
  	xmlOut += '</Worksheet>';

  	//capture detail worksheet
  	xmlOut += '<Worksheet ss:Name="Capture Detail">';
  	xmlOut += '<Table ss:ExpandedColumnCount="' + (numTableColumnFields + numYears) + '" ss:ExpandedRowCount="' + (2 + numCaptures) + '" x:FullColumns="1" x:FullRows="1" ss:DefaultRowHeight="15">';
    for(let f = 0; f < numTableColumnFields; f++) {
      xmlOut += '<Column ss:AutoFitWidth="0" ss:Width="' + (tableColumnFieldsArrayOfObjs[f].widthEm * 10) + '"/>';
    }
  	for(let fyr of fyrArray) {
  		xmlOut += '<Column ss:AutoFitWidth="0" ss:Width="100"/>';
  	}

  	xmlOut += '<Row ss:AutoFitHeight="0">';
  	xmlOut += '<Cell ss:MergeAcross="' + (numTableColumnFields - 1) + '" ss:StyleID="s62"><Data ss:Type="String">Capture Info</Data></Cell>';
  	xmlOut += '<Cell' + ((numYears > 1) ? (' ss:MergeAcross="' + (numYears - 1) + '"') : ('')) + ' ss:StyleID="s62"><Data ss:Type="String">TCV Contribution Per Year</Data></Cell>';
  	xmlOut += '</Row>';

  	xmlOut += '<Row ss:AutoFitHeight="0" ss:StyleID="s62">';
    for(let tableColumnFieldObj of tableColumnFieldsArrayOfObjs) {
      xmlOut += '<Cell><Data ss:Type="String">' + JSFUNC.htmlspecialchars(tableColumnFieldObj.displayName) + '</Data></Cell>';
    }
  	for(let fyr of fyrArray) {
  		xmlOut += '<Cell><Data ss:Type="Number">' + fyr + '</Data></Cell>';
  	}
  	xmlOut += '</Row>';

  	for(let finProjCaptureObj of finProjCapturesArrayOfObjs) {
			xmlOut += '<Row ss:AutoFitHeight="0">';
      for(let tableColumnCaptureFieldValueObj of finProjCaptureObj.tableColumnCaptureFieldValueArrayOfObjs) {
          const cellValue = JSFUNC.prop_value(tableColumnCaptureFieldValueObj.valueMaskCsvXmlPlainText, "");
          const cellValueIsValidNumberTF = ((JSFUNC.is_number(cellValue) || (JSFUNC.is_string(cellValue) && (cellValue.trim() !== ""))) && Number.isFinite(Number(cellValue)));
          if(cellValueIsValidNumberTF && tableColumnCaptureFieldValueObj.moneyTF) {
            xmlOut += '<Cell ss:StyleID="s68"><Data ss:Type="Number">' + cellValue + '</Data></Cell>';
        }
          else if(cellValueIsValidNumberTF && tableColumnCaptureFieldValueObj.percentTF) {
            xmlOut += '<Cell ss:StyleID="s71"><Data ss:Type="Number">' + cellValue + '</Data></Cell>';
        }
          else if(cellValueIsValidNumberTF && tableColumnCaptureFieldValueObj.valueDisplayIsNumericTF) {
            xmlOut += '<Cell><Data ss:Type="Number">' + cellValue + '</Data></Cell>';
        }
        else {
            xmlOut += '<Cell><Data ss:Type="String">' + JSFUNC.htmlspecialchars(String(cellValue)) + '</Data></Cell>';
        }
      }

			for(let captureCovPerFyr of finProjCaptureObj.captureMoneyValuePerFyrArray) {
				xmlOut += '<Cell ss:StyleID="s68"><Data ss:Type="Number">' + JSFUNC.htmlspecialchars(captureCovPerFyr) + '</Data></Cell>';
			}
			xmlOut += '</Row>';
  	}

  	xmlOut += '</Table>';
  	xmlOut += '<WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">';
  	xmlOut += '<PageSetup><Header x:Margin="0.3"/><Footer x:Margin="0.3"/><PageMargins x:Bottom="0.75" x:Left="0.7" x:Right="0.7" x:Top="0.75"/></PageSetup>';
  	xmlOut += '<Unsynced/>';
  	xmlOut += '<Panes><Pane><Number>3</Number><ActiveRow>9</ActiveRow><ActiveCol>2</ActiveCol></Pane></Panes>';
  	xmlOut += '<ProtectObjects>False</ProtectObjects><ProtectScenarios>False</ProtectScenarios>';
  	xmlOut += '</WorksheetOptions>';
  	xmlOut += '</Worksheet>';
  	xmlOut += '</Workbook>';

  	return(xmlOut);
  }









  //graphs
  get c_tabDailySnapshotTrueTrendAnalyzerFalse() {
    return(CaptureExecMobx.o_leftNavTabNameSelected === "Daily Snapshot");
  }

  get c_dailySnapshotPagesArrayOfObjs() {
    const pageFieldNamesArray = this.graphs_daily_snapshot_page_field_names_array();
    return(this.get_pages_arrayOfObjs_from_tbl_mapOfMaps_also_replacing_replica_rows("tbl_d_daily_snapshot_pages", UserMobx.o_userID, pageFieldNamesArray));
  }

  get c_trendAnalyzerPagesArrayOfObjs() {
    const pageFieldNamesArray = this.graphs_trend_analyzer_page_field_names_array();
    return(this.get_pages_arrayOfObjs_from_tbl_mapOfMaps_also_replacing_replica_rows("tbl_d_trend_analyzer_pages", UserMobx.o_userID, pageFieldNamesArray));
  }

  get_pages_arrayOfObjs_from_tbl_mapOfMaps_also_replacing_replica_rows(i_pagesTblName, i_filterUserID, i_pageFieldNamesArray) {
    //get the tblRef from the tblName
    const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(i_pagesTblName);

    //get all of the graphs on this user's currently open page
    var pagesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(tblRefMapOfMaps, "user_id", i_filterUserID, "sort", true);

    //loop through each graph and replace values for replicas of public graphs
    for(let pageObj of pagesArrayOfObjs) {
      if(pageObj.replica_of_page_id > 0) { //if this page/graph is a replica of another public page/graph, replace all pageObj values with the referenced graph's values
        var referencedPageMap = tblRefMapOfMaps.get(pageObj.replica_of_page_id);
        if(referencedPageMap !== undefined) {
          for(let fieldName of i_pageFieldNamesArray) {
            if(!JSFUNC.in_array(fieldName, ["user_id", "sort", "public_01", "replica_of_page_id"])) { //these page/graph fields keep their original value from the replica row
              pageObj[fieldName] = referencedPageMap.get(fieldName); //all other graph fields have their values copied from the referenced graph
            }
          }
        }
        else { //reference graph doesn't exist, change the graph title so that it shows up with a message
          pageObj.name = "--Public Page (ID: " + pageObj.replica_of_page_id + ") Does Not Exist--";
        }
      }
    }
    return(pagesArrayOfObjs);
  }

  get c_dailySnapshotGraphsArrayOfObjs() {
    const dailySnapshotFieldNamesArray = this.graphs_daily_snapshot_graphs_field_names_array();
    return(this.get_graphs_arrayOfObjs_from_tbl_mapOfMaps_also_replacing_replica_rows("tbl_d_daily_snapshot_pages", "tbl_d_daily_snapshot_graphs", this.o_dailySnapshotSelectedPageID, dailySnapshotFieldNamesArray));
  }

  get c_trendAnalyzerGraphsArrayOfObjs() {
    const trendAnalyzerFieldNamesArray = this.graphs_trend_analyzer_graphs_field_names_array();
    return(this.get_graphs_arrayOfObjs_from_tbl_mapOfMaps_also_replacing_replica_rows("tbl_d_trend_analyzer_pages", "tbl_d_trend_analyzer_graphs", this.o_trendAnalyzerSelectedPageID, trendAnalyzerFieldNamesArray));
  }

  get_graphs_arrayOfObjs_from_tbl_mapOfMaps_also_replacing_replica_rows(i_pagesTblName, i_graphsTblName, i_filterPageID, i_tblFieldNamesArray) {
    //if loading graphs for a page_id filter value, check if the corresponding page row is a replica, if so, use the replica_of_page_id as the filter page_id value
    var filterPageID = i_filterPageID;
    const pagesTblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(i_pagesTblName);
    const referencedPageMap = pagesTblRefMapOfMaps.get(i_filterPageID);
    if(referencedPageMap !== undefined) {
      if(referencedPageMap.get("replica_of_page_id") > 0) {
        filterPageID = referencedPageMap.get("replica_of_page_id");
      }
    }

    //get the tblRef from the tblName
    const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(i_graphsTblName);

    //get all of the graphs on this user's currently open page
    var graphsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(tblRefMapOfMaps, "page_id", filterPageID, "sort", true);

    //loop through each graph and replace values for replicas of public graphs
    for(let graphObj of graphsArrayOfObjs) {
      if(graphObj.replica_of_graph_id > 0) { //if this page/graph is a replica of another public page/graph, replace all graphObj values with the referenced graph's values
        var referencedGraphMap = tblRefMapOfMaps.get(graphObj.replica_of_graph_id);
        if(referencedGraphMap !== undefined) {
          for(let fieldName of i_tblFieldNamesArray) {
            if(!JSFUNC.in_array(fieldName, ["page_id", "sort", "public_01", "replica_of_graph_id"])) { //these page/graph fields keep their original value from the replica row
              graphObj[fieldName] = referencedGraphMap.get(fieldName); //all other graph fields have their values copied from the referenced graph
            }
          }
        }
        else { //reference graph doesn't exist, change the graph title so that it shows up with a message
          graphObj.graph_title = "--Public Graph (ID: " + graphObj.replica_of_graph_id + ") Does Not Exist--";
        }
      }
    }
    return(graphsArrayOfObjs);
  }

  get c_graphsSelectedTabName() {
    return((this.c_tabDailySnapshotTrueTrendAnalyzerFalse) ? ("Daily Snapshot") : ("Trend Analyzer"));
  }
  get c_graphsSelectedTabPagesTblName() {
    return((this.c_tabDailySnapshotTrueTrendAnalyzerFalse) ? ("tbl_d_daily_snapshot_pages") : ("tbl_d_trend_analyzer_pages"));
  }
  get c_graphsSelectedTabGraphsTblName() {
    return((this.c_tabDailySnapshotTrueTrendAnalyzerFalse) ? ("tbl_d_daily_snapshot_graphs") : ("tbl_d_trend_analyzer_graphs"));
  }

  get c_graphsSelectedTabAllPagesArrayOfObjs() {
    return((this.c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.c_dailySnapshotPagesArrayOfObjs) : (this.c_trendAnalyzerPagesArrayOfObjs));
  }

  get c_graphsSelectedTabAllGraphsArrayOfObjs() {
    return((this.c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.c_dailySnapshotGraphsArrayOfObjs) : (this.c_trendAnalyzerGraphsArrayOfObjs));
  }

  get c_graphsSelectedTabUserAllAddedPageIDsArray() {
    var graphsSelectedTabUserAllAddedPageIDsArray = [];
    for(let pageObj of this.c_graphsSelectedTabAllPagesArrayOfObjs) {
      if(pageObj.replica_of_page_id > 0) {
        graphsSelectedTabUserAllAddedPageIDsArray.push(pageObj.replica_of_page_id);
      }
      else {
        graphsSelectedTabUserAllAddedPageIDsArray.push(pageObj.id);
      }
    }
    return(graphsSelectedTabUserAllAddedPageIDsArray);
  }

  get c_graphsSelectedTabUserAllAddedGraphIDsObjOfArrays() {
    var graphIDsArray = [];
    var pageNamesCommaArray = [];
    for(let graphObj of this.c_graphsSelectedTabAllGraphsArrayOfObjs) {
      if(graphObj.replica_of_graph_id > 0) {
        if(!JSFUNC.in_array(graphObj.replica_of_graph_id, graphIDsArray)) {
          graphIDsArray.push(graphObj.replica_of_graph_id);

          var pageNamesArray = [];
          for(let pageObj of this.c_graphsSelectedTabAllPagesArrayOfObjs) {
            if((pageObj.user_id === UserMobx.o_userID) && (pageObj.id === graphObj.page_id)) {
              pageNamesArray.push(pageObj.name);
            }
          }
          pageNamesCommaArray.push(pageNamesArray.join(", "));
        }
      }
    }
    return({
      graphIDsArray: graphIDsArray,
      pageNamesCommaArray: pageNamesCommaArray
    });
  }

  get c_graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs() {
    //only take public pages from this tab (daily or trend), record all unique user creators for later categorization and sorting
    const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(this.c_graphsSelectedTabPagesTblName);
    var allPublicPagesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(tblRefMapOfMaps, "public_01", 1);

    var graphsSelectedTabAllPublicPagesArrayOfObjs = [];
    var uniqueCreatorUserIDsArray = [];
    for(let pageObj of allPublicPagesArrayOfObjs) {
      var copyPublicPageObj = JSFUNC.copy_obj(pageObj);
      graphsSelectedTabAllPublicPagesArrayOfObjs.push(copyPublicPageObj);

      if(pageObj.created_by_user_id !== UserMobx.o_userID) { //do not show public pages that the logged in user has created themselves in this list
        if(!JSFUNC.in_array(pageObj.created_by_user_id, uniqueCreatorUserIDsArray)) { //only store 1 copy of each userID
          uniqueCreatorUserIDsArray.push(pageObj.created_by_user_id);
        }
      }
    }

    //loop through each unique user
    var graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs = [];
    for(let uniqueCreatorUserID of uniqueCreatorUserIDsArray) {
      var userPagesArrayOfObjs = [];
      for(let pageObj of graphsSelectedTabAllPublicPagesArrayOfObjs) {
        if(pageObj.created_by_user_id === uniqueCreatorUserID) {
          userPagesArrayOfObjs.push(pageObj);
        }
      }

      //within each user creator, sort all graphs by title alphabetically
      JSFUNC.sort_arrayOfObjs(userPagesArrayOfObjs, "name", true);

      var userNameMaskSortIfoObj = DatabaseMobx.user_name_mask_sort_ifo_obj_from_user_id(uniqueCreatorUserID);
      graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs.push({
        id: uniqueCreatorUserID,
        userNameMaskPlainText: userNameMaskSortIfoObj.valueMaskPlainText,
        userNameSort: userNameMaskSortIfoObj.valueSort,
        userPagesArrayOfObjs: userPagesArrayOfObjs
      });

      //sort the creators by their name alphabetically
      JSFUNC.sort_arrayOfObjs(graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs, "userNameSort", true);
    }

    return(graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs);
  }

  get c_graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs() {
    const c_graphsSelectedTabGraphsTblName = this.c_graphsSelectedTabGraphsTblName;

    //only take public graphs from this tab (daily or trend), record all unique user creators for later categorization and sorting
    const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(c_graphsSelectedTabGraphsTblName);
    var allPublicGraphsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(tblRefMapOfMaps, "public_01", 1);

    //get every public graph, compute the user name of the creator
    var graphsSelectedTabAllPublicGraphsArrayOfObjs = [];
    var uniqueCreatorUserIDsArray = [];
    for(let graphObj of allPublicGraphsArrayOfObjs) {
      var copyPublicGraphObj = JSFUNC.copy_obj(graphObj);
      var userNameMaskSortIfoObj = DatabaseMobx.user_name_mask_sort_ifo_obj_from_user_id(graphObj.created_by_user_id);
      copyPublicGraphObj.userNameMaskPlainText = userNameMaskSortIfoObj.valueMaskPlainText;
      copyPublicGraphObj.userNameSort = userNameMaskSortIfoObj.valueSort;
      graphsSelectedTabAllPublicGraphsArrayOfObjs.push(copyPublicGraphObj);

      if(!JSFUNC.in_array(graphObj.created_by_user_id, uniqueCreatorUserIDsArray)) {
        uniqueCreatorUserIDsArray.push(graphObj.created_by_user_id);
      }
    }

    //compute all graphDataObjs for every public graph
    const allPublicGraphsDataArrayOfObjs = this.compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs(graphsSelectedTabAllPublicGraphsArrayOfObjs);

    //loop through each user creator found, add each public graph, then sort them by title
    var graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs = [];
    for(let uniqueCreatorUserID of uniqueCreatorUserIDsArray) {
      var userGraphsDataArrayOfObjs = [];
      var uniqueCreatorUserNameMaskPlainText = undefined;
      var uniqueCreatorUserNameSort = undefined;
      for(let graphDataObj of allPublicGraphsDataArrayOfObjs) {
        if(graphDataObj.graphObj.created_by_user_id === uniqueCreatorUserID) {
          graphDataObj.graphTitleSort = graphDataObj.graphObj.graph_title.toLowerCase(); //bring the graph title to the top layer of the data obj so that it can be sorted
          userGraphsDataArrayOfObjs.push(graphDataObj);
          
          uniqueCreatorUserNameMaskPlainText = graphDataObj.graphObj.userNameMaskPlainText;
          uniqueCreatorUserNameSort = graphDataObj.graphObj.userNameSort;
        }
      }

      //within each user creator, sort all graphs by title alphabetically
      JSFUNC.sort_arrayOfObjs(userGraphsDataArrayOfObjs, "graphTitleSort", true);

      graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs.push({
        id: uniqueCreatorUserID,
        userNameMaskPlainText: uniqueCreatorUserNameMaskPlainText,
        userNameSort: uniqueCreatorUserNameSort,
        userGraphsDataArrayOfObjs: userGraphsDataArrayOfObjs
      });

      //sort the creators by their name alphabetically
      JSFUNC.sort_arrayOfObjs(graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs, "userNameSort", true);
    }

    return(graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs);
  }

  get c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj() {
    const c_activeStageIDsArray = DatabaseMobx.c_activeStageIDsArray;
    const c_closedWonStageIDsArray = DatabaseMobx.c_closedWonStageIDsArray;
    const c_closedLostStageIDsArray = DatabaseMobx.c_closedLostStageIDsArray;
    const c_fieldMapOfCaptureManagers = DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfPrimeSub = DatabaseMobx.c_fieldMapOfPrimeSub;
    const c_fieldMapOfContractType = DatabaseMobx.c_fieldMapOfContractType;
    const c_fieldMapOfStage = DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfIdiqCaptureIDTOLink = DatabaseMobx.c_fieldMapOfIdiqCaptureIDTOLink;
    const c_fieldMapOfCompetitionTypeBmSetAsideIDsComma = DatabaseMobx.c_fieldMapOfCompetitionTypeBmSetAsideIDsComma;
    const c_fieldMapOfContractRevenueValue = DatabaseMobx.c_fieldMapOfContractRevenueValue;
    const c_fieldMapOfContractStartDate = DatabaseMobx.c_fieldMapOfContractStartDate;

    const systemAllActiveCapturesInCompanyFilterPresetID = -304;
    const systemAllClosedCapturesInCompanyFilterPresetID = -305;
    const systemAllClosedWonCapturesInCompanyFilterPresetID = -306;
    const systemAllActiveTaskOrdersFilterPresetID = -350;
    const activeStageIDsComma = JSFUNC.convert_array_to_comma_list(c_activeStageIDsArray);
    const wonAndLostStageIDsComma = JSFUNC.convert_array_to_comma_list(JSFUNC.concat_arrays_or_values_into_new_array(c_closedWonStageIDsArray, c_closedLostStageIDsArray));

    var dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs = [];
    var trendAnalyzerAllSystemGraphsDataPerSystemPageArrayOfObjs = [];
    
    const numCapturesM2AndCrvMoneyFieldIDArray = [-2, c_fieldMapOfContractRevenueValue.get("id")]; //inside loop for each pair of #/$ graphs
    const cmTitleSymbolsArray = ["#", "$"];

    //Daily Snapshot Page #1: "Company Analysis - Active Captures Only"
    const dsP1CategoriesExpandedCaptureFieldMapsArray = [c_fieldMapOfStage, c_fieldMapOfDivisionOwners, c_fieldMapOfCaptureManagers, c_fieldMapOfContractType, c_fieldMapOfCompetitionTypeBmSetAsideIDsComma];
    const dsP1AllCategories01Array = [0, 1, 1, 1, 1];
    const dsP1CategoriesOptionIDsCommaArray = [activeStageIDsComma, "", "", "", ""];
    const dsP1CategoriesIncludeNotSet01Array = [0, 1, 1, 0, 0];
    const dsP1GraphType0123Array = [1, 2, 0, 1, 1];
    const dsP1LegendHideZeroCategories01Array = [0, 0, 0, 0, 1];
    var systemDSPage1GraphsArrayOfObjs = [];
    for(let g = 0; g < dsP1CategoriesExpandedCaptureFieldMapsArray.length; g++) {
      var expandedCaptureFieldMap = dsP1CategoriesExpandedCaptureFieldMapsArray[g];
      for(let cm = 0; cm < 2; cm++) {
        var dsP1GraphObj = this.graphs_daily_snapshot_create_new_graph_obj();
        dsP1GraphObj.filter_preset_id = systemAllActiveCapturesInCompanyFilterPresetID;
        dsP1GraphObj.categories_field_id = expandedCaptureFieldMap.get("id");
        dsP1GraphObj.all_categories_01 = dsP1AllCategories01Array[g];
        dsP1GraphObj.categories_option_ids_comma = dsP1CategoriesOptionIDsCommaArray[g];
        dsP1GraphObj.categories_include_not_set_01 = dsP1CategoriesIncludeNotSet01Array[g];
        dsP1GraphObj.graph_type_p0_vb1_hb2_f3 = dsP1GraphType0123Array[g];
        dsP1GraphObj.legend_hide_zero_categories_01 = dsP1LegendHideZeroCategories01Array[g];
        dsP1GraphObj.num_captures_m2_or_money_field_id = numCapturesM2AndCrvMoneyFieldIDArray[cm];
        dsP1GraphObj.y_axis_log_01 = 1;
        dsP1GraphObj.graph_title = expandedCaptureFieldMap.get("display_name") + " (" + cmTitleSymbolsArray[cm] + ")";
        systemDSPage1GraphsArrayOfObjs.push(dsP1GraphObj);
      }
    }
    const systemDSPage1GraphsDataArrayOfObjs = this.compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs(systemDSPage1GraphsArrayOfObjs);
    dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs.push({
      id: -1,
      userNameMaskPlainText: "[System Graphs] Company Analysis - Active Captures Only",
      userNameSort: 1,
      userGraphsDataArrayOfObjs: systemDSPage1GraphsDataArrayOfObjs
    });

    //Daily Snapshot Page #2: "IDIQs - Active Captures Only"
    var systemDS1IDIQsCountGraphObj = this.graphs_daily_snapshot_create_new_graph_obj();
    systemDS1IDIQsCountGraphObj.filter_preset_id = systemAllActiveTaskOrdersFilterPresetID;
    systemDS1IDIQsCountGraphObj.categories_field_id = c_fieldMapOfIdiqCaptureIDTOLink.get("id");
    systemDS1IDIQsCountGraphObj.all_categories_01 = 1;
    systemDS1IDIQsCountGraphObj.categories_include_not_set_01 = 1;
    systemDS1IDIQsCountGraphObj.graph_type_p0_vb1_hb2_f3 = 1;
    systemDS1IDIQsCountGraphObj.legend_hide_zero_categories_01 = 0;
    systemDS1IDIQsCountGraphObj.num_captures_m2_or_money_field_id = -2;
    systemDS1IDIQsCountGraphObj.y_axis_log_01 = 1;
    systemDS1IDIQsCountGraphObj.graph_title = c_fieldMapOfIdiqCaptureIDTOLink.get("display_name") + " (#)";

    var systemDS2IDIQsMoneyGraphObj = this.graphs_daily_snapshot_create_new_graph_obj();
    systemDS2IDIQsMoneyGraphObj.filter_preset_id = systemAllActiveTaskOrdersFilterPresetID;
    systemDS2IDIQsMoneyGraphObj.categories_field_id = c_fieldMapOfIdiqCaptureIDTOLink.get("id");
    systemDS2IDIQsMoneyGraphObj.all_categories_01 = 1;
    systemDS2IDIQsMoneyGraphObj.categories_include_not_set_01 = 1;
    systemDS2IDIQsMoneyGraphObj.graph_type_p0_vb1_hb2_f3 = 1;
    systemDS2IDIQsMoneyGraphObj.legend_hide_zero_categories_01 = 0;
    systemDS2IDIQsMoneyGraphObj.num_captures_m2_or_money_field_id = c_fieldMapOfContractRevenueValue.get("id");
    systemDS2IDIQsMoneyGraphObj.y_axis_log_01 = 1;
    systemDS2IDIQsMoneyGraphObj.graph_title = c_fieldMapOfIdiqCaptureIDTOLink.get("display_name") + " ($)";

    const systemDSPage2GraphsArrayOfObjs = [
      systemDS1IDIQsCountGraphObj,
      systemDS2IDIQsMoneyGraphObj
    ];

    const systemDSPage2GraphsDataArrayOfObjs = this.compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs(systemDSPage2GraphsArrayOfObjs);
    dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs.push({
      id: -2,
      userNameMaskPlainText: "[System Graphs] IDIQs - Active Captures Only",
      userNameSort: 2,
      userGraphsDataArrayOfObjs: systemDSPage2GraphsDataArrayOfObjs
    });
    
    //Trend Analyzer Page #1: "Company Trends"
    const taP1FilterPresetIDArray = [systemAllClosedCapturesInCompanyFilterPresetID, systemAllActiveCapturesInCompanyFilterPresetID, systemAllActiveCapturesInCompanyFilterPresetID, systemAllClosedWonCapturesInCompanyFilterPresetID];
    const taP1CategoriesExpandedCaptureFieldMapsArray = [c_fieldMapOfStage, c_fieldMapOfPrimeSub, c_fieldMapOfCompetitionTypeBmSetAsideIDsComma, c_fieldMapOfDivisionOwners];
    const taP1AllCategories01Array = [0, 1, 1, 1];
    const taP1CategoriesOptionIDsCommaArray = [wonAndLostStageIDsComma, "", "", ""];
    const taP1CategoriesIncludeNotSet01Array = [0, 0, 0, 1];
    const taP1GraphType0123Array = [2, 0, 2, 2];
    const taP1LegendHideZeroCategories01Array = [0, 0, 1, 0];
    const taP1GraphTitleArray = ["Wins vs Losses", "Prime vs Sub", c_fieldMapOfCompetitionTypeBmSetAsideIDsComma.get("display_name"), "Wins by " + c_fieldMapOfDivisionOwners.get("display_name")];
    var systemTAPage1GraphsArrayOfObjs = [];
    for(let g = 0; g < taP1FilterPresetIDArray.length; g++) {
      var expandedCaptureFieldMap = taP1CategoriesExpandedCaptureFieldMapsArray[g];
      for(let cm = 0; cm < 2; cm++) {
        var taP1GraphObj = this.graphs_trend_analyzer_create_new_graph_obj();
        taP1GraphObj.filter_preset_id = taP1FilterPresetIDArray[g];
        taP1GraphObj.date_field_id = c_fieldMapOfContractStartDate.get("id");
        taP1GraphObj.use_categories_field_01 = 1;
        taP1GraphObj.categories_field_id = expandedCaptureFieldMap.get("id");
        taP1GraphObj.all_categories_01 = taP1AllCategories01Array[g];
        taP1GraphObj.categories_option_ids_comma = taP1CategoriesOptionIDsCommaArray[g];
        taP1GraphObj.categories_include_not_set_01 = taP1CategoriesIncludeNotSet01Array[g];
        taP1GraphObj.line0_bar1 = taP1GraphType0123Array[g];
        taP1GraphObj.legend_hide_zero_categories_01 = taP1LegendHideZeroCategories01Array[g];
        taP1GraphObj.num_captures_m2_or_money_field_id = numCapturesM2AndCrvMoneyFieldIDArray[cm];
        taP1GraphObj.time_bins = "yearly";
        taP1GraphObj.y_axis_log_01 = 1;
        taP1GraphObj.graph_title = taP1GraphTitleArray[g] + " (" + cmTitleSymbolsArray[cm] + ")";
        systemTAPage1GraphsArrayOfObjs.push(taP1GraphObj);
      }
    }
    const systemTAPage1GraphsDataArrayOfObjs = this.compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs(systemTAPage1GraphsArrayOfObjs);
    trendAnalyzerAllSystemGraphsDataPerSystemPageArrayOfObjs.push({
      id: -1,
      userNameMaskPlainText: "[System Graphs] Trend Analzyer",
      userNameSort: 1,
      userGraphsDataArrayOfObjs: systemTAPage1GraphsDataArrayOfObjs
    });

    return({
      dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs: dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs,
      trendAnalyzerAllSystemGraphsDataPerSystemPageArrayOfObjs: trendAnalyzerAllSystemGraphsDataPerSystemPageArrayOfObjs
    });
  }

  get c_graphsSelectedTabAllSystemGraphsDataPerUserCreatorArrayOfObjs() {
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj = this.c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj;

    var selectedTabAllSystemGraphsDataPerSystemPageArrayOfObjs = [];
    if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
      selectedTabAllSystemGraphsDataPerSystemPageArrayOfObjs = c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj.dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs;
    }
    else {
      selectedTabAllSystemGraphsDataPerSystemPageArrayOfObjs = c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj.trendAnalyzerAllSystemGraphsDataPerSystemPageArrayOfObjs;
    }

    var systemAllPagesGraphsDataArrayOfObjs = [];
    for(let allSystemGraphsDataOnPageObj of selectedTabAllSystemGraphsDataPerSystemPageArrayOfObjs) {
      for(let graphDataObj of allSystemGraphsDataOnPageObj.userGraphsDataArrayOfObjs) {
        systemAllPagesGraphsDataArrayOfObjs.push(graphDataObj);
      }
    }

    return([{
      id: -1,
      userNameMaskPlainText: "[System Graphs]",
      userNameSort: 1,
      userGraphsDataArrayOfObjs: systemAllPagesGraphsDataArrayOfObjs
    }]);
  }


  get c_graphsSelectedPageID() {
    return((this.c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.o_dailySnapshotSelectedPageID) : (this.o_trendAnalyzerSelectedPageID));
  }
  get c_graphsSelectedPageObj() {
    if(this.c_graphsSelectedPageID !== undefined) {
      for(let pageObj of this.c_graphsSelectedTabAllPagesArrayOfObjs) {
        if(pageObj.id === this.c_graphsSelectedPageID) {
          return(pageObj);
        }
      }
    }
    return(undefined);
  }
  get c_graphsSelectedPageIsReplicaOfPublicPageTF() {
    if(this.c_graphsSelectedPageObj !== undefined) {
      return(this.c_graphsSelectedPageObj.replica_of_page_id > 0);
    }
    return(false);
  }
  get c_graphsSelectedPageNumGraphsPerRow() {
    if(!CaptureExecMobx.c_isMobileTF) {
      if(this.c_graphsSelectedPageObj !== undefined) {
        return(this.c_graphsSelectedPageObj.num_graphs_per_row);
      }
    }
    return(1);
  }
  get c_graphsSelectedPageGraphHeightEm() {
    if(this.c_graphsSelectedPageObj !== undefined) {
      return(this.c_graphsSelectedPageObj.graph_height_em);
    }
    return(28);
  }

  get c_graphsSelectedPageGraphsDataArrayOfObjs() {
    //if a graph is being edited, remove all graphs from the page in the background behind edit floating box so that all the changes don't redraw every graph on the page which could be very slow
    if(this.o_graphsEditingGraphID !== undefined) {
      return([]);
    }

    //otherwise compute all the graph data
    return(this.compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs(this.c_graphsSelectedTabAllGraphsArrayOfObjs));
  }

  get c_graphsEditingGraphDataObj() {
    if(this.o_graphsEditingGraphID === undefined) {
      return(undefined);
    }

    for(let graphObj of this.c_graphsSelectedTabAllGraphsArrayOfObjs) {
      if(graphObj.id === this.o_graphsEditingGraphID) {
        var graphsDataArrayOfObjs = this.compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs([graphObj]);
        if(graphsDataArrayOfObjs.length === 1) {
          return(graphsDataArrayOfObjs[0]);
        }
        return(undefined);
      }
    }
    return(undefined);
  }

  compute_graphs_data_arrayOfObjs_from_graphs_arrayOfObjs(i_graphsArrayOfObjs) {
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;

    if(!JSFUNC.is_array_not_empty(i_graphsArrayOfObjs)) {
      return([]);
    }

    //get all of the unique filter presetIDs from all of the graphs on this page
    var allGraphsUniqueFilterPresetIDsArray = [];
    for(let graphObj of i_graphsArrayOfObjs) {
      allGraphsUniqueFilterPresetIDsArray.push(graphObj.filter_preset_id);
    }
    allGraphsUniqueFilterPresetIDsArray = JSFUNC.unique(allGraphsUniqueFilterPresetIDsArray);

    //for each filterPresetID, load the filters and create an expandedFiltersObj, filter all of the captures using it and append the resulting captures
    var matchingCapturesPerFilterPresetIDMapOfObjs = new Map();
    for(let filterPresetID of allGraphsUniqueFilterPresetIDsArray) {
      //check that the selected filterPresetID exists
      var expandedFilterPresetObj = CapturesMobx.get_database_or_system_expanded_preset_obj_with_preset_items_arrayOfObjs_from_preset_type_and_preset_id("filter", filterPresetID);
      if(expandedFilterPresetObj.existsTF) {
        var matchingCapturesFilterPresetObj = this.create_matching_captures_filter_preset_obj_from_captures_mapOfMaps_and_filters_arrayOfObjs_and_filter_name(o_tbl_captures, expandedFilterPresetObj.expandedPresetItemsArrayOfObjs, expandedFilterPresetObj.name);
        matchingCapturesPerFilterPresetIDMapOfObjs.set(filterPresetID, matchingCapturesFilterPresetObj);
      }
    }

    //loop through each graph to collect, convert, and create data needed for each graph type
    var graphsSelectedPageGraphsDataArrayOfObjs = [];
    for(let graphObj of i_graphsArrayOfObjs) {
      //get the filtered captures from the prestored filterPreset capture lists
      var matchingCapturesFilterPresetObjOrDne = matchingCapturesPerFilterPresetIDMapOfObjs.get(graphObj.filter_preset_id);
      if(matchingCapturesFilterPresetObjOrDne === undefined) {
        var filterPresetName = "";
        if(JSFUNC.select_int_is_filled_out_tf(graphObj.filter_preset_id)) {
          filterPresetName = "--Selected Filter Preset Does Not Exist (ID: " + graphObj.filter_preset_id + ")--";
        }
        else {
          filterPresetName = "--No Capture Filter Preset Selected--";
        }
        matchingCapturesFilterPresetObjOrDne = {filterPresetName:filterPresetName};
      }

      //final resulting graphDataObj to be added to the array for this page of graphs
      var graphDataObj = this.compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(graphObj, c_tabDailySnapshotTrueTrendAnalyzerFalse, matchingCapturesFilterPresetObjOrDne);
      graphsSelectedPageGraphsDataArrayOfObjs.push(graphDataObj);
    }

    return(graphsSelectedPageGraphsDataArrayOfObjs);
  }

  create_matching_captures_filter_preset_obj_from_captures_mapOfMaps_and_filters_arrayOfObjs_and_filter_name(i_capturesMapOfMaps, i_filtersArrayOfObjs, i_filterPresetName) {
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;

    const expandedFiltersArrayOfObjs = CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(i_filtersArrayOfObjs, c_tbl_captures_fields);
    const matchingCapturesMapOfMaps = CapturesMobx.get_filtered_captures_mapOfMaps_from_captures_mapOfMaps_and_expanded_filters_arrayOfObjs(i_capturesMapOfMaps, expandedFiltersArrayOfObjs);

    return({
      filterPresetName: i_filterPresetName,
      expandedFiltersArrayOfObjs: expandedFiltersArrayOfObjs,
      matchingCapturesMapOfMaps: matchingCapturesMapOfMaps
    });
  }

  compute_graph_data_obj_from_graph_obj_and_matching_captures_filter_preset_obj(i_graphObj, i_circleGraphTrueTimeGraphFalse, i_matchingCapturesFilterPresetObjOrUndefined) {
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;

    var graphDateFieldID = i_graphObj.date_field_id; //only used in time graph Trend Analyzer graphs
    var graphUseCategoriesField01 = i_graphObj.use_categories_field_01; //only used in time graph Trend Analyzer graphs
    var graphCategoriesFieldID = i_graphObj.categories_field_id;
    var graphAllCategories01 = i_graphObj.all_categories_01;
    var graphCategoriesOptionIDsComma = i_graphObj.categories_option_ids_comma;
    var graphCategoriesIncludeNotSet01 = i_graphObj.categories_include_not_set_01;
    var graphCategoriesCustomColors01 = i_graphObj.categories_custom_colors_01;
    var graphCategoriesCustomColorColonCommaList = i_graphObj.categories_custom_colors_colon_comma_list;
    var graphNumCapturesM2OrMoneyFieldID = i_graphObj.num_captures_m2_or_money_field_id;
    var graphIgnoreSharedPercentCalcs01 = i_graphObj.ignore_shared_percent_calcs_01;

    const graphUseCategoriesFieldTF = (graphUseCategoriesField01 === 1);
    const graphCategoriesCustomColorsTF = (graphCategoriesCustomColors01 === 1);
    const numCapturesTrueMoneyFieldFalse = (graphNumCapturesM2OrMoneyFieldID === -2);
    const graphIgnoreSharedPercentCalcTF = (graphIgnoreSharedPercentCalcs01 === 1);

    var matchingCapturesFilterPresetObjExistsTF = false;
    var filterPresetName = "--Filter Preset Name Not Provided--";
    if(i_matchingCapturesFilterPresetObjOrUndefined !== undefined) {
      filterPresetName = i_matchingCapturesFilterPresetObjOrUndefined.filterPresetName;
      matchingCapturesFilterPresetObjExistsTF = (JSFUNC.is_array(i_matchingCapturesFilterPresetObjOrUndefined.expandedFiltersArrayOfObjs) && (i_matchingCapturesFilterPresetObjOrUndefined.matchingCapturesMapOfMaps !== undefined));
    }

    var dateFieldName = undefined;
    var dateFieldDbName = undefined;
    var countValueNumCapturesOrMoneyFieldName = undefined;
    var valueFormatString = undefined;
    var categoriesFieldName = undefined;
    var categoriesFieldAllOptionValuesArray = undefined;
    var categoriesFieldAllOptionDisplaysArray = undefined;
    var categoriesFieldAllOptionColorsArray = undefined;
    var categoriesFieldAllOptionHiddenUnlessCheckedTFArray = undefined;
    var categoriesExpandedFiltersArrayOfObjs = undefined;
    var categoriesArrayOfObjs = [];
    var totalNumCapturesOrMoneyFieldValueLabel = undefined;

    //----------------------------------------------------------------------------
    //get the selected capture date field name for trend graphs
    if(!i_circleGraphTrueTimeGraphFalse) {
      if(!JSFUNC.select_int_is_filled_out_tf(graphDateFieldID)) {
        dateFieldName = "--No Capture Date Field Selected--";
      }
      else {
        const expandedCaptureDateFieldMap = c_tbl_captures_fields.get(graphDateFieldID);
        if(expandedCaptureDateFieldMap === undefined) {
          dateFieldName = "--Selected Capture Date Field Does Not Exist (ID: " + graphDateFieldID + ")--";
        }
        else {
          dateFieldDbName = expandedCaptureDateFieldMap.get("db_name");
          const dateFieldTypeObj = expandedCaptureDateFieldMap.get("fieldTypeObj");
          if(!(dateFieldTypeObj.dateTF || dateFieldTypeObj.dateTimeTF)) {
            dateFieldName = "--Selected Capture Date Field is not a 'Date' Field Type--";
          }
          else {
            dateFieldName = expandedCaptureDateFieldMap.get("display_name");
          }
        }
      }
    }

    //----------------------------------------------------------------------------
    //get the selected capture Y-axis value (either # Captures or a selected money capture field)
    var moneyExpandedCaptureFieldMap = undefined;
    if(numCapturesTrueMoneyFieldFalse) {
      countValueNumCapturesOrMoneyFieldName = "# Captures";
      valueFormatString = "number";
    }
    else {
      if(JSFUNC.select_int_is_filled_out_tf(graphNumCapturesM2OrMoneyFieldID)) { //a capture field (valid or invalid) has been selected for this graph
        moneyExpandedCaptureFieldMap = DatabaseMobx.fetch_expanded_capture_field_map_from_field_id(graphNumCapturesM2OrMoneyFieldID);
        countValueNumCapturesOrMoneyFieldName = moneyExpandedCaptureFieldMap.get("display_name");
      }
      else { //the option for graph capture value has been set to 'money capture field' but a field has not yet been selected (fieldID is -1 or 0)
        countValueNumCapturesOrMoneyFieldName = "--No Capture Money Field Selected--";
      }
      valueFormatString = "moneyShort";
    }

    //----------------------------------------------------------------------------
    //get the selected categories capture field name
    if(!JSFUNC.select_int_is_filled_out_tf(graphCategoriesFieldID)) {
      categoriesFieldName = "--No Capture Field Selected--";
    }
    else {
      const categoriesFieldExpandedCaptureFieldMap = c_tbl_captures_fields.get(graphCategoriesFieldID); //get the expanded field map for this capture field from the fieldID
      if(categoriesFieldExpandedCaptureFieldMap === undefined) {
        categoriesFieldName = "--Selected Capture Field Does Not Exist (ID: " + graphCategoriesFieldID + ")--";
      }
      else {
        const fieldDisplayName = categoriesFieldExpandedCaptureFieldMap.get("display_name");
        const fieldTypeObj = categoriesFieldExpandedCaptureFieldMap.get("fieldTypeObj");

        //load the select option value/display/color arrays from the swsDataObj in the fieldTypeObj
        if((fieldTypeObj.selectWithSearchDataObj === undefined) || !JSFUNC.is_array(fieldTypeObj.selectWithSearchDataObj.valueArray) || !JSFUNC.is_array(fieldTypeObj.selectWithSearchDataObj.displayArray)) {
          categoriesFieldName = "--Selected Capture Field '" + fieldDisplayName + "' Has Invalid SWS Data--";
        }
        else {
          categoriesFieldAllOptionValuesArray = JSFUNC.copy_array2(fieldTypeObj.selectWithSearchDataObj.valueArray);
          categoriesFieldAllOptionDisplaysArray = JSFUNC.copy_array2(fieldTypeObj.selectWithSearchDataObj.displayArray);
          categoriesFieldAllOptionColorsArray = JSFUNC.copy_array2(fieldTypeObj.selectWithSearchDataObj.colorArray);
          categoriesFieldAllOptionHiddenUnlessCheckedTFArray = JSFUNC.copy_array2(fieldTypeObj.selectWithSearchDataObj.hiddenUnlessCheckedTFArray);

          //confirm that all 4 of these swsDataObj arrays exist and match lengths (value/display are required, colors/hidden are optional)
          const hasValueArrayTF = JSFUNC.is_array(categoriesFieldAllOptionValuesArray);
          var hasDisplayArrayTF = false;
          var hasColorsArrayTF = false;
          var hasHiddenUnlessCheckedTFArrayTF = false;
          if(hasValueArrayTF) {
            const numInitialCategoryOptions = categoriesFieldAllOptionValuesArray.length;
            hasDisplayArrayTF = (JSFUNC.is_array(categoriesFieldAllOptionDisplaysArray) && (categoriesFieldAllOptionDisplaysArray.length === numInitialCategoryOptions));
            hasColorsArrayTF = (JSFUNC.is_array(categoriesFieldAllOptionColorsArray) && (categoriesFieldAllOptionColorsArray.length === numInitialCategoryOptions));
            hasHiddenUnlessCheckedTFArrayTF = (JSFUNC.is_array(categoriesFieldAllOptionHiddenUnlessCheckedTFArray) && (categoriesFieldAllOptionHiddenUnlessCheckedTFArray.length === numInitialCategoryOptions));
          }

          //get all of the category select optionIDs into an array using a combination of the graphObj fields all_categories_01, categories_option_ids_comma, categories_include_not_set_01
          if(!hasDisplayArrayTF) {
            categoriesFieldName = "--Capture Field '" + fieldDisplayName + "' mismatched underlying data--";
          }
          else {
            var categoriesOptionIDsArray = [];
            if(graphAllCategories01 === 0) { //use on the specified options from categories_option_ids_comma as the categories
              categoriesOptionIDsArray = JSFUNC.convert_comma_list_to_int_array(graphCategoriesOptionIDsComma);
            }
            else { //use all options as the categories
              if(hasHiddenUnlessCheckedTFArrayTF) { //if this cateogry capture field swsDataObj has a hiddenUnlessCheckedTFArray, remove all optionIDs from the array that have hidden as true (like duplicate fields in the BITmaster set_asides for Competition Type)
                for(let o = 0; o < categoriesFieldAllOptionValuesArray.length; o++) {
                  if(!categoriesFieldAllOptionHiddenUnlessCheckedTFArray[o]) {
                    categoriesOptionIDsArray.push(categoriesFieldAllOptionValuesArray[o]);
                  }
                }
              }
              else { //no hiddenUnlessCheckedTFArray
                categoriesOptionIDsArray = JSFUNC.copy_array2(categoriesFieldAllOptionValuesArray);
              }
            }

            //add the not set -1 category if specified
            if(graphCategoriesIncludeNotSet01 === 1) {
              categoriesOptionIDsArray.push(-1);
            }

            //error if there are 0 categories resulting from how the 3 graphObj fields are set
            const numCategories = categoriesOptionIDsArray.length;
            if(numCategories === 0) {
              categoriesFieldName = "--No Categories selected from Capture Field '" + fieldDisplayName + "'--";
            }
            else { //there are no errors with the selected category capture field and the name can be assigned
              categoriesFieldName = fieldDisplayName;

              if(matchingCapturesFilterPresetObjExistsTF) {
                //compute custom colors for each category if set by the custom colors switch
                var graphCategoriesCustomColorsArrayOfObjs = [];
                if(graphCategoriesCustomColorsTF) {
                  graphCategoriesCustomColorsArrayOfObjs = JSFUNC.convert_colon_comma_list_to_ints_arrayOfObjs(graphCategoriesCustomColorColonCommaList, "categoryOptionID", "color", "string");
                }
                
                //create a single filterObj (wrapped in an array to make a preset) for each category option
                categoriesExpandedFiltersArrayOfObjs = [];
                for(let c = 0; c < numCategories; c++) {
                  var categoryOptionID = categoriesOptionIDsArray[c];

                  //match the optionID to find the option name and color from the value/display/color arrays within the selectWithSearchDataObj of the fieldTypeObj
                  var categoryOptionName = undefined;
                  var categoryOptionColor = undefined;
                  var matchIndex = categoriesFieldAllOptionValuesArray.indexOf(categoryOptionID);
                  if(matchIndex >= 0) { //optionID is a valid option in the select list of options, get the display name and color if available
                    categoryOptionName = categoriesFieldAllOptionDisplaysArray[matchIndex];
                    if(hasColorsArrayTF) {
                      categoryOptionColor = categoriesFieldAllOptionColorsArray[matchIndex];
                    }
                    else {
                      categoryOptionColor = JSFUNC.unique_color(c);
                    }
                  }
                  else {
                    categoryOptionName = "--Not Set--";
                    categoryOptionColor = "999999";
                  }

                  //overwrite category color with a custom color if set (keep the category name matched above)
                  if(graphCategoriesCustomColorsTF) {
                    var matchingCustomColorObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(graphCategoriesCustomColorsArrayOfObjs, "categoryOptionID", categoryOptionID);
                    if(matchingCustomColorObjOrUndefined !== undefined) {
                      categoryOptionColor = matchingCustomColorObjOrUndefined.color;
                    }
                    else {
                      categoryOptionColor = "000000";
                    }
                  }

                  //create the single category filter, then merge it into the main filters for partial TCV calculations
                  var categoryFilterObj = undefined;
                  if(categoryOptionID > 0) { //select options used as categories
                    categoryFilterObj = {capture_field_id:graphCategoriesFieldID, operator:"e", value:JSFUNC.num2str(categoryOptionID)};
                  }
                  else { //the not set category
                    const categoriesFieldAllOptionIDsComma = JSFUNC.convert_array_to_comma_list(categoriesFieldAllOptionValuesArray);
                    categoryFilterObj = {capture_field_id:graphCategoriesFieldID, operator:"ne", value:categoriesFieldAllOptionIDsComma}; //create a filterObj for a 'not set' if specified (filter is essentially not equal to every possible option, which catches not set and does not exist entries)
                  }

                  var combinedMainAndCategoryFiltersArrayOfObjs = [];
                  for(let mainFilterObj of i_matchingCapturesFilterPresetObjOrUndefined.expandedFiltersArrayOfObjs) {
                    combinedMainAndCategoryFiltersArrayOfObjs.push(mainFilterObj);
                  }
                  combinedMainAndCategoryFiltersArrayOfObjs.push(categoryFilterObj);

                  //put together the category data obj for this single category
                  categoriesExpandedFiltersArrayOfObjs.push({
                    name: categoryOptionName,
                    color: categoryOptionColor,
                    combinedMainAndCategoryExpandedFilterArrayOfObjs: CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(combinedMainAndCategoryFiltersArrayOfObjs, c_tbl_captures_fields)
                  });
                }
              }
            }
          }
        }
      }
    }

    //----------------------------------------------------------------------------
    //compute the categoriesArrayOfObjs for both types of graphs
    if(matchingCapturesFilterPresetObjExistsTF) {
      var totalCaptureIDsArray = undefined;
      if(i_circleGraphTrueTimeGraphFalse) { //daily snapshot circle/bar graphs
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
        //first loop gets the single filter and computes the total TCV/# captures for this category
        var numItemsPerCategoryArray = [];
        var totalTcvOrNumCapturesPerCategoryArray = [];
        var totalTcvOrNumCapturesAllCategories = 0;
        var captureIDsPerCategoryArrayOfArrays = [];
        totalCaptureIDsArray = [];
        if(JSFUNC.is_array(categoriesExpandedFiltersArrayOfObjs)) {
          for(let categoriesExpandedFilterObj of categoriesExpandedFiltersArrayOfObjs) {
            var categoryNumItems = 0;
            var categoryTotalNumCapturesOrMoneyFieldValue = 0;
            var captureIDsInCategoryArray = [];
            for(let [captureID, captureMap] of i_matchingCapturesFilterPresetObjOrUndefined.matchingCapturesMapOfMaps) {
              //partial tcv or # captures added to total
              var partialMultiplier0to1OrFalse = CapturesMobx.capture_matches_all_filters_partialMultiplier0to1_or_false_from_capture_map_and_expanded_filters_arrayOfObjs(captureMap, categoriesExpandedFilterObj.combinedMainAndCategoryExpandedFilterArrayOfObjs);

              //captureID appended for circle segment hyperlink to captures that make up category
              if(JSFUNC.is_number_not_nan_gte_0(partialMultiplier0to1OrFalse)) { //if split ownership is between 0 and 1, but not false non-matching
                categoryNumItems++;
                captureIDsInCategoryArray.push(captureID);
                totalCaptureIDsArray.push(captureID);

                //admin option in 'System' subtab to force all percent ownership calculations to full value for these performance calculations
                if(graphIgnoreSharedPercentCalcTF) {
                  partialMultiplier0to1OrFalse = 1;
                }

                if(partialMultiplier0to1OrFalse > 0) {
                  var singleCaptureNumCapturesOrMoneyFieldValue = this.compute_graph_single_capture_num_captures_or_money_field_value_from_partial_multiplier(partialMultiplier0to1OrFalse, captureMap, numCapturesTrueMoneyFieldFalse, moneyExpandedCaptureFieldMap);
                  if(JSFUNC.is_number_not_nan(singleCaptureNumCapturesOrMoneyFieldValue)) {
                    categoryTotalNumCapturesOrMoneyFieldValue += singleCaptureNumCapturesOrMoneyFieldValue;
                  }
                }
              }
            }
            numItemsPerCategoryArray.push(categoryNumItems);
            totalTcvOrNumCapturesPerCategoryArray.push(categoryTotalNumCapturesOrMoneyFieldValue);
            if(JSFUNC.is_number_not_nan(categoryTotalNumCapturesOrMoneyFieldValue)) {
              totalTcvOrNumCapturesAllCategories += categoryTotalNumCapturesOrMoneyFieldValue;
            }
            captureIDsPerCategoryArrayOfArrays.push(captureIDsInCategoryArray);
          }

          //2nd loop uses the total value to calculate percents
          for(let i = 0; i < totalTcvOrNumCapturesPerCategoryArray.length; i++) {
            var categoriesExpandedFilterObj = categoriesExpandedFiltersArrayOfObjs[i];
            var categoryNumItems = numItemsPerCategoryArray[i];
            var categoryTotalNumCapturesOrMoneyFieldValue = totalTcvOrNumCapturesPerCategoryArray[i];

            var valueMaskPlainText = this.compute_graph_num_captures_or_money_field_value_mask_plain_text(numCapturesTrueMoneyFieldFalse, categoryTotalNumCapturesOrMoneyFieldValue);

            categoriesArrayOfObjs.push({
              numItems: categoryNumItems,
              valueRaw: categoryTotalNumCapturesOrMoneyFieldValue,
              valueMaskPlainText: valueMaskPlainText,
              color: categoriesExpandedFilterObj.color,
              label: categoriesExpandedFilterObj.name,
              clickReturnValue: captureIDsPerCategoryArrayOfArrays[i]
            });
          }
        }

        //format the total value label for the legend
        totalNumCapturesOrMoneyFieldValueLabel = this.compute_graph_num_captures_or_money_field_value_mask_plain_text(numCapturesTrueMoneyFieldFalse, totalTcvOrNumCapturesAllCategories);
        totalCaptureIDsArray = JSFUNC.unique(totalCaptureIDsArray);
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
      }
      else { //trend analyzer time graphs
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
        //overwrite categoriesFieldName for Single Data Series option
        if(!graphUseCategoriesFieldTF) {
          categoriesFieldName = "All Captures from selected Filter Preset";
        }

        //use the computed categoriesExpandedFiltersArrayOfObjs above or make a fake single one for Single Data Series to use to compute the Trend Analyzer categoriesArrayOfObjs data
        var trendAnalyzerCategoriesExpandedFiltersArrayOfObjs = []; //intiialize as no categories which would display a blank graph with 0 categories
        if(graphUseCategoriesFieldTF) { //multiple categories from a capture field (use categoriesExpandedFiltersArrayOfObjs from above if it was computed)
          if(JSFUNC.is_array(categoriesExpandedFiltersArrayOfObjs)) {
            trendAnalyzerCategoriesExpandedFiltersArrayOfObjs = categoriesExpandedFiltersArrayOfObjs;
          }
        }
        else { //single data series - use all filtered captures from filter preset combined to make a single category (create a fake single categoriesExpandedFiltersArrayOfObjs with 1 category obj in it)
          var trendAnalyzerSingleDataSeriesColor = "000000";
          if(graphCategoriesCustomColorsTF) {
            trendAnalyzerSingleDataSeriesColor = JSFUNC.convert_any_hex_to_hex6(graphCategoriesCustomColorColonCommaList); //single trend analyzer single data series custom color
          }
          else {
            trendAnalyzerSingleDataSeriesColor = JSFUNC.unique_color(0);
          }

          trendAnalyzerCategoriesExpandedFiltersArrayOfObjs = [{
            name: "All Captures from selected Filter Preset",
            color: trendAnalyzerSingleDataSeriesColor,
            combinedMainAndCategoryExpandedFilterArrayOfObjs: i_matchingCapturesFilterPresetObjOrUndefined.expandedFiltersArrayOfObjs
          }];
        }

        //loop over all trend analyzer categories and create graph data categoriesArrayOfObjs
        for(let categoriesExpandedFilterObj of trendAnalyzerCategoriesExpandedFiltersArrayOfObjs) {
          var idDateValueArrayOfObjs = [];
          for(let captureMap of i_matchingCapturesFilterPresetObjOrUndefined.matchingCapturesMapOfMaps.values()) { //loop over filtered captures
            var partialMultiplier0to1OrFalse = CapturesMobx.capture_matches_all_filters_partialMultiplier0to1_or_false_from_capture_map_and_expanded_filters_arrayOfObjs(captureMap, categoriesExpandedFilterObj.combinedMainAndCategoryExpandedFilterArrayOfObjs); //partial tcv or # captures added to total
            if(JSFUNC.is_number_not_nan_gte_0(partialMultiplier0to1OrFalse)) { //include any match percent 0 to 1, but not false non-match return
              //admin option in 'System' subtab to force all percent ownership calculations to full value for these performance calculations
              if(graphIgnoreSharedPercentCalcTF) {
                partialMultiplier0to1OrFalse = 1;
              }
              
              idDateValueArrayOfObjs.push({
                id: captureMap.get("id"),
                date: captureMap.get(dateFieldDbName),
                value: this.compute_graph_single_capture_num_captures_or_money_field_value_from_partial_multiplier(partialMultiplier0to1OrFalse, captureMap, numCapturesTrueMoneyFieldFalse, moneyExpandedCaptureFieldMap)
              });
            }
          }

          categoriesArrayOfObjs.push({
            idDateValueArrayOfObjs: idDateValueArrayOfObjs,
            color: categoriesExpandedFilterObj.color,
            label: categoriesExpandedFilterObj.name
          });
        }
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
      }
    }

    //final resulting graphDataObj to be added to the array for this page of graphs
    return({
      circleGraphTrueTimeGraphFalse: i_circleGraphTrueTimeGraphFalse,
      graphObj: i_graphObj,
      filterPresetName: filterPresetName,
      dateFieldName: dateFieldName,
      countValueNumCapturesOrMoneyFieldName: countValueNumCapturesOrMoneyFieldName,
      valueFormatString: valueFormatString,
      categoriesFieldName: categoriesFieldName,
      categoriesArrayOfObjs: categoriesArrayOfObjs,
      totalNumCapturesOrMoneyFieldValueLabel: totalNumCapturesOrMoneyFieldValueLabel,
      totalCaptureIDsArray: totalCaptureIDsArray
    });
  }

  compute_graph_single_capture_num_captures_or_money_field_value_from_partial_multiplier(i_partialMultiplier0to1, i_captureMap, i_numCapturesTrueMoneyFieldFalse, i_moneyExpandedCaptureFieldMap) {
    //# captures returns the partial multiplier for this capture
    if(i_numCapturesTrueMoneyFieldFalse) {
      return(i_partialMultiplier0to1);
    }

    //selected money field returns partial multiplier times the capture money field value
    if(i_moneyExpandedCaptureFieldMap !== undefined) {
      var fieldTypeObj = i_moneyExpandedCaptureFieldMap.get("fieldTypeObj");
      if(fieldTypeObj !== undefined) {
        if(fieldTypeObj.moneyTF) {
          var captureMoneyFieldValue = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(i_captureMap, i_moneyExpandedCaptureFieldMap);
          return(i_partialMultiplier0to1 * captureMoneyFieldValue);
        }
      }
    }

    //selected capture value money field not valid returns a capture value of 0
    return(0);
  }

  compute_graph_num_captures_or_money_field_value_mask_plain_text(i_numCapturesTrueMoneyFieldFalse, i_numCapturesOrMoneyFieldValue) {
    //# captures (with either 2 decimals or 1)
    if(i_numCapturesTrueMoneyFieldFalse) {
      var numDecimals = ((i_numCapturesOrMoneyFieldValue < 1) ? (2) : (1));
      var numCapturesDecimal = JSFUNC.round_number_to_num_decimals_if_needed(i_numCapturesOrMoneyFieldValue, numDecimals);
      return(JSFUNC.num2str(numCapturesDecimal));
    }

    //money field
    return(JSFUNC.money_short(i_numCapturesOrMoneyFieldValue));
  }

  




  get c_graphsSelectNumGraphsPerRowFieldTypeObj() {
    const numGraphsPerRowArray = JSFUNC.array_fill_incrementing_x_to_y(1, 15);
    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("# Graphs Per Row", numGraphsPerRowArray, false, numGraphsPerRowArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }
  get c_graphsSelectGraphHeightsFieldTypeObj() {
    const graphHeightsArray = JSFUNC.concat_arrays_or_values_into_new_array(JSFUNC.array_fill_incrementing_x_to_y(8, 38, 2), JSFUNC.array_fill_incrementing_x_to_y(40, 100, 5));
    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Graphs Height", graphHeightsArray, false, graphHeightsArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  get c_graphsSelectFilterPresetFieldTypeObj() {
    const c_presetMyAndPublicAndSystemFilterPresetsArrayOfObjs = CapturesMobx.c_presetMyAndPublicAndSystemFilterPresetsArrayOfObjs;
    const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Filter Preset", c_presetMyAndPublicAndSystemFilterPresetsArrayOfObjs, "id", false, "name", swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  get c_selectCategoryCaptureFieldFieldTypeObj() {
    var categoryFieldsArrayOfObjs = [];
    for(let expandedCaptureMap of DatabaseMobx.c_tbl_captures_fields.values()) {
      var fieldTypeObj = expandedCaptureMap.get("fieldTypeObj");
      if(fieldTypeObj.requiresSelectWithSearchDataObjTF) {
        categoryFieldsArrayOfObjs.push({
          fieldID: expandedCaptureMap.get("id"),
          fieldDisplayName: expandedCaptureMap.get("display_name")
        });
      }
    }
    JSFUNC.sort_arrayOfObjs(categoryFieldsArrayOfObjs, "fieldDisplayName", true);

    const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Capture Field for Categories", categoryFieldsArrayOfObjs, "fieldID", false, "fieldDisplayName", swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  get c_graphsSelectAllCategoriesTFFieldTypeObj() {
    const valueArray = [1, 0];
    const displayArray = ["Use all options in selected Field as Categories", "Choose a subset of the Field's options below"];
    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("All Field Options/Choose Subset", valueArray, false, displayArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  get c_graphsEditingGraphSelectMultiCategoriesOptionsFieldTypeObj() {
    const c_graphsEditingGraphDataObj = this.c_graphsEditingGraphDataObj;

    var optionIDsArray = [];
    var valuesAreStringsTF = false;
    var optionNamesArray = [];
    if(c_graphsEditingGraphDataObj !== undefined) {
      const graphObj = c_graphsEditingGraphDataObj.graphObj;
      if(graphObj !== undefined) {
        const categoriesOptionsObj = this.graphs_get_category_capture_field_option_ids_array_and_names_array_obj_from_categories_capture_field_id(graphObj.categories_field_id);
        optionIDsArray = categoriesOptionsObj.optionValuesArray;
        valuesAreStringsTF = categoriesOptionsObj.valuesAreStringsTF;
        optionNamesArray = categoriesOptionsObj.optionDisplaysArray;
      }
    }

    const swsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
    const selectWithSearchDataObj = DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Capture Field Option", optionIDsArray, valuesAreStringsTF, optionNamesArray, swsOptionsObj);
    return(DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj));
  }

  graphs_get_category_capture_field_option_ids_array_and_names_array_obj_from_categories_capture_field_id(i_categoriesCaptureFieldID) {
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;

    var optionValuesArray = [];
    var valuesAreStringsTF = false;
    var optionDisplaysArray = [];

    const expandedCaptureFieldMap = c_tbl_captures_fields.get(i_categoriesCaptureFieldID);
    if(expandedCaptureFieldMap !== undefined) {
      const fieldTypeObj = expandedCaptureFieldMap.get("fieldTypeObj");
      if(fieldTypeObj.selectWithSearchDataObj !== undefined) {
        const selectWithSearchDataObj = fieldTypeObj.selectWithSearchDataObj;
        if(JSFUNC.is_array(selectWithSearchDataObj.valueArray) && JSFUNC.is_array(selectWithSearchDataObj.displayArray)) {
          valuesAreStringsTF = selectWithSearchDataObj.valuesAreStringsTF;
          if(JSFUNC.is_array(selectWithSearchDataObj.hiddenUnlessCheckedTFArray)) { //if swsDataObj contains a hiddenUnlessCheckedTFArray, don't include values where hidden is true
            optionValuesArray = [];
            optionDisplaysArray = [];
            for(let o = 0; o < selectWithSearchDataObj.valueArray.length; o++) {
              if(!selectWithSearchDataObj.hiddenUnlessCheckedTFArray[o]) {
                optionValuesArray.push(selectWithSearchDataObj.valueArray[o]);
                optionDisplaysArray.push(selectWithSearchDataObj.displayArray[o]);
              }
            }
          }
          else { //no hidden array, use all values/displays (copied)
            optionValuesArray = JSFUNC.copy_array2(selectWithSearchDataObj.valueArray);
            optionDisplaysArray = JSFUNC.copy_array2(selectWithSearchDataObj.displayArray);
          }
        }
      }
    }

    return({
      optionValuesArray: optionValuesArray,
      valuesAreStringsTF: valuesAreStringsTF,
      optionDisplaysArray: optionDisplaysArray
    });
  }






  //hot bits
  get c_hotBitsObj() {
    const o_nowDate = CaptureExecMobx.o_nowDate;
    const c_allDivisionIDsArray = DatabaseMobx.c_allDivisionIDsArray;
    const c_fieldMapOfAddedDate = DatabaseMobx.c_fieldMapOfAddedDate;
    const c_fieldMapOfLastChangedDate = DatabaseMobx.c_fieldMapOfLastChangedDate;
    const c_fieldMapOfLastStageDate = DatabaseMobx.c_fieldMapOfLastStageDate;
    const c_fieldMapOfLastProgressDate = DatabaseMobx.c_fieldMapOfLastProgressDate;
    const c_fieldMapOfLastPWinDate = DatabaseMobx.c_fieldMapOfLastPWinDate;
    const c_fieldMapOfLastRFPDate = DatabaseMobx.c_fieldMapOfLastRFPDate;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    const userDivexecFilterDivisionIDsArray = c_combinedUserObj.uDivexecFilterDivisionIDsArray;
    const userDivexecHotBitsCalendarTF = c_combinedUserObj.uDivexecHotBitsCalendarTF;
    const userDivexecHotBitsFixedTF= c_combinedUserObj.uDivexecHotBitsFixedTF;

    const zeroDivisionIDsSelectedTF = (userDivexecFilterDivisionIDsArray.length === 0);
    var allDivisionIDsSelectedTF = false;
    if(!zeroDivisionIDsSelectedTF) {
      allDivisionIDsSelectedTF = JSFUNC.all_of_array1_is_in_array2(c_allDivisionIDsArray, userDivexecFilterDivisionIDsArray);
    }

    const expandedCaptureDateFieldsArrayOfMaps = [c_fieldMapOfAddedDate, c_fieldMapOfLastChangedDate, c_fieldMapOfLastStageDate, c_fieldMapOfLastProgressDate, c_fieldMapOfLastPWinDate, c_fieldMapOfLastRFPDate];
    const fieldLabelsArray = ["Newly Added Captures", "Captures Recently Updated", "Recent Stage Changes", "Shaping Progress Updated", "PWin Updated", "Recently Changed RFP Date"];
    const fieldActionLabelsArray = ["Created", "Edited", "Stage Changed", "Question(s) Answered", "PWin Changed", "RFP Date Changed"];
    const numCaptureDateFields = expandedCaptureDateFieldsArrayOfMaps.length;

    var dateCategoriesArrayOfObjs = [];

    dateCategoriesArrayOfObjs.push({
      name: "today",
      actionName: "Today",
      startDate: o_nowDate,
      endDate: o_nowDate
    });
    if(userDivexecHotBitsCalendarTF) {
      const todayJsDateObj = JSFUNC.convert_mysqldate_to_jsdateobj(o_nowDate);
      const todayDayOfWeek0to6 = JSFUNC.date_w(todayJsDateObj);
      const todayYearInt = JSFUNC.date_yyyy(todayJsDateObj);
      const todayMM2DigitString = JSFUNC.date_mm(todayJsDateObj);
      dateCategoriesArrayOfObjs.push({
        name: "this week",
        actionName: "this Week",
        startDate: JSFUNC.date_add_days(o_nowDate, (0 - todayDayOfWeek0to6)), //sunday's date of this current week (starting from sunday)
        endDate: o_nowDate
      });
      dateCategoriesArrayOfObjs.push({
        name: "this month",
        actionName: "this Month",
        startDate: todayYearInt + "-" + todayMM2DigitString + "-01", //first of this current month
        endDate: o_nowDate
      });
    }
    else if(userDivexecHotBitsFixedTF) {
      dateCategoriesArrayOfObjs.push({
        name: "in past 7 days",
        actionName: "in the past 7 Days",
        startDate: JSFUNC.date_add_days(o_nowDate, -7), //last week
        endDate: JSFUNC.date_add_days(o_nowDate, -1) //yesterday
      });
      dateCategoriesArrayOfObjs.push({
        name: "in past 30 days",
        actionName: "in the past 30 Days",
        startDate: JSFUNC.date_add_days(o_nowDate, -30), //1 month ago
        endDate: JSFUNC.date_add_days(o_nowDate, -8) //1 week minus 1 day ago
      });
    }
    const numDateCategories = dateCategoriesArrayOfObjs.length;

    //loop through all date categories to compute start/end date display masks
    for(let dateCategoryObj of dateCategoriesArrayOfObjs) {
      var startDateMask = DatabaseMobx.get_company_date_format_from_Ymd_date(dateCategoryObj.startDate);
      var endDateMask = DatabaseMobx.get_company_date_format_from_Ymd_date(dateCategoryObj.endDate);
      var capturesSectionHeaderSubLabelBetweenDates = "";
      if(dateCategoryObj.startDate === dateCategoryObj.endDate) { //date category is a single day (like 'today')
        capturesSectionHeaderSubLabelBetweenDates = " of " + startDateMask;
      }
      else { //date category is a span of multiple days
        capturesSectionHeaderSubLabelBetweenDates = " between " + startDateMask + " and " + endDateMask;
      }

      dateCategoryObj.startDateMask = startDateMask;
      dateCategoryObj.endDateMask = endDateMask;
      dateCategoryObj.capturesSectionHeaderSubLabelBetweenDates = capturesSectionHeaderSubLabelBetweenDates;
    }

    //initialize each hot bits date field with initialize date category arrays of captureIDs
    var hotBitsCaptureFieldsArrayOfObjs = [];
    for(let f = 0; f < numCaptureDateFields; f++) {
      var expandedCaptureDateFieldMap = expandedCaptureDateFieldsArrayOfMaps[f];
      var fieldLabel = fieldLabelsArray[f];
      var fieldActionLabel = fieldActionLabelsArray[f];

      var fieldID = expandedCaptureDateFieldMap.get("id");
      var fieldDisplayName = expandedCaptureDateFieldMap.get("display_name");

      var capturesPerDateArrayOfObjs = [];
      for(let d = 0; d < numDateCategories; d++) {
        capturesPerDateArrayOfObjs.push({
          captureIDsArray: []
        });
      }

      hotBitsCaptureFieldsArrayOfObjs.push({
        id: fieldID,
        displayName: fieldDisplayName,
        expandedCaptureFieldMap: expandedCaptureDateFieldMap,
        label: fieldLabel,
        actionLabel: fieldActionLabel,
        capturesPerDateArrayOfObjs: capturesPerDateArrayOfObjs
      });
    }

    //loop through all captures once, determine if it matches division filter, capture date field, and date category
    if(!zeroDivisionIDsSelectedTF) { //if no divisions are selected, no captures match
      for(let captureMap of DatabaseMobx.o_tbl_captures.values()) {
        var captureID = captureMap.get("id");

        //determine if this capture is within the division filter (which applies to all capture date fields and date categories)
        var captureIsInFilterDivisionIDsTF = true; //all captures match if every division is selected
        if(!allDivisionIDsSelectedTF) {
          var captureDivisionIDsArray = DatabaseMobx.division_owner_division_ids_array_from_capture_map(captureMap);
          captureIsInFilterDivisionIDsTF = JSFUNC.any_of_array1_is_in_array2(userDivexecFilterDivisionIDsArray, captureDivisionIDsArray);
        }

        if(captureIsInFilterDivisionIDsTF) {
          //loop through each capture date field
          for(let hotBitsCaptureFieldObj of hotBitsCaptureFieldsArrayOfObjs) {
            var captureDateValueYmd = DatabaseMobx.capture_value_raw_or_undefined_from_capture_map_and_expanded_capture_field_map(captureMap, hotBitsCaptureFieldObj.expandedCaptureFieldMap);
            //loop through each date category to determine if the capture date falls within the category date start/end range
            for(let d = 0; d < numDateCategories; d++) {
              var dateCategoryObj = dateCategoriesArrayOfObjs[d];
              if((captureDateValueYmd >= dateCategoryObj.startDate) && (captureDateValueYmd <= dateCategoryObj.endDate)) {
                hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[d].captureIDsArray.push(captureID);
              }
            }
          }
        }
      }
    }

    //after all captureIDs are sorted into category arrays, fetch the search result captures for those IDs
    const columnsSearchResults0Divexec1 = 1;
    for(let hotBitsCaptureFieldObj of hotBitsCaptureFieldsArrayOfObjs) {
      for(let capturesPerDateObj of hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs) {
        var numCaptures = capturesPerDateObj.captureIDsArray.length;
        capturesPerDateObj.numCaptures = numCaptures;
        capturesPerDateObj.atLeast1CaptureTF = (numCaptures > 0);
        capturesPerDateObj.hotBitsSearchFieldsCstTableObj = CapturesMobx.create_search_fields_cst_table_obj_from_capture_ids_array(capturesPerDateObj.captureIDsArray, columnsSearchResults0Divexec1);
      }
    }

    return({
      dateCategoriesArrayOfObjs: dateCategoriesArrayOfObjs,
      hotBitsCaptureFieldsArrayOfObjs: hotBitsCaptureFieldsArrayOfObjs
    });
  }






  //critical thresholds graphs
  get c_criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs() {
    const o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned = this.o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    const filtersArrayOfObjs = [
      {capture_field_id:DatabaseMobx.c_fieldMapOfCaptureType.get("id"), operator:"e", value:o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned},
      {capture_field_id:DatabaseMobx.c_fieldMapOfDivisionOwners.get("id"), operator:"e", value:c_combinedUserObj.divexec_filter_division_ids_comma}
    ];

    const criticalThresholdsExpandedFiltersArrayOfObjs = CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(filtersArrayOfObjs, c_tbl_captures_fields);

    var criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs = [];
    for(let captureMap of o_tbl_captures.values()) {
      var partialMultiplier0to1OrFalse = CapturesMobx.capture_matches_all_filters_partialMultiplier0to1_or_false_from_capture_map_and_expanded_filters_arrayOfObjs(captureMap, criticalThresholdsExpandedFiltersArrayOfObjs);
      if(JSFUNC.is_number_not_nan_gt_0(partialMultiplier0to1OrFalse)) {
        criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs.push({
          captureMap: captureMap,
          partialMultiplier0to1: partialMultiplier0to1OrFalse
        });
      }
    }
    return(criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs);
  }

  get c_criticalProgressThresholdScatterPlotDataArrayOfObjs() {
    const critthreshMoneyFieldID = UserMobx.c_combinedUserObj.divexec_critthresh_money_field_id;

    const critthreshMoneyExpandedFieldMapOrUndefined = DatabaseMobx.c_tbl_captures_fields.get(critthreshMoneyFieldID);

    const stageFieldDisplayName = DatabaseMobx.c_fieldMapOfStage.get("display_name");
    const progressFieldDisplayName = DatabaseMobx.c_fieldMapOfShapingTotalProgress.get("display_name");
    const rfpDateFieldDisplayName = DatabaseMobx.c_fieldMapOfRFPDate.get("display_name");

    var criticalProgressThresholdScatterPlotDataArrayOfObjs = [];

    const stageTypeOrdersArrayOfArrays = [[4] ,[5], [6], [7,8]]; //cancelled/no bid on bottom, then lost, then wins on top of the scatterplot pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7
    for(let stageTypeOrdersArray of stageTypeOrdersArrayOfArrays) {
      for(let stageObj of DatabaseMobx.c_adminSortedExpandedStagesArrayOfObjs) {
        if(JSFUNC.in_array(stageObj.pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7, stageTypeOrdersArray)) {
          var xyPointsArrayOfObjs = [];
          for(let catureMapAndTcvMultiplierObj of this.c_criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs) {
            var captureMap = catureMapAndTcvMultiplierObj.captureMap;
            if(captureMap.get("stage_id") === stageObj.id) {
              var captureName = DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap);
              var progressValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfShapingTotalProgress);
              var rfpDateValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfRFPDate);

              var critthreshMoneyValueRaw = 0;
              var title = "Capture: " + captureName + "\n" + stageFieldDisplayName + ": " + stageObj.name;
              if(critthreshMoneyExpandedFieldMapOrUndefined !== undefined) {
                var critthreshMoneyValueMaskSortIfoCanEditObj = DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMap, critthreshMoneyExpandedFieldMapOrUndefined);
                critthreshMoneyValueRaw = critthreshMoneyValueMaskSortIfoCanEditObj.valueRaw;
                title += "\n" + critthreshMoneyExpandedFieldMapOrUndefined.get("display_name") + ": " + critthreshMoneyValueMaskSortIfoCanEditObj.valueMaskPlainText;
              }
              title += "\n" + progressFieldDisplayName + ": " + progressValueMaskPlainText;
              title += "\n" + rfpDateFieldDisplayName + ": " + rfpDateValueMaskPlainText;

              xyPointsArrayOfObjs.push({
                x: captureMap.get("shaping_total_progress"),
                y: critthreshMoneyValueRaw,
                clickReturnValue: captureMap.get("id"),
                title: title
              });
            }
          }

          criticalProgressThresholdScatterPlotDataArrayOfObjs.push({
            xyPointsArrayOfObjs: xyPointsArrayOfObjs,
            label: stageObj.name,
            color: stageObj.color
          });
        }
      }
    }

    return(criticalProgressThresholdScatterPlotDataArrayOfObjs);
  }

  get c_criticalPwinThresholdScatterPlotDataArrayOfObjs() {
    const critthreshMoneyFieldID = UserMobx.c_combinedUserObj.divexec_critthresh_money_field_id;

    const critthreshMoneyExpandedFieldMapOrUndefined = DatabaseMobx.c_tbl_captures_fields.get(critthreshMoneyFieldID);

    const stageFieldDisplayName = DatabaseMobx.c_fieldMapOfStage.get("display_name");
    const pwinFieldDisplayName = DatabaseMobx.c_fieldMapOfPwin.get("display_name");
    const rfpDateFieldDisplayName = DatabaseMobx.c_fieldMapOfRFPDate.get("display_name");

    var criticalPwinThresholdScatterPlotDataArrayOfObjs = [];

    const stageTypeOrdersArrayOfArrays = [[4] ,[5], [6], [7,8]]; //cancelled/no bid on bottom, then lost, then wins on top of the scatterplot pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7
    for(let stageTypeOrdersArray of stageTypeOrdersArrayOfArrays) {
      for(let stageObj of DatabaseMobx.c_adminSortedExpandedStagesArrayOfObjs) {
        if(JSFUNC.in_array(stageObj.pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7, stageTypeOrdersArray)) {
          var xyPointsArrayOfObjs = [];
          for(let catureMapAndTcvMultiplierObj of this.c_criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs) {
            var captureMap = catureMapAndTcvMultiplierObj.captureMap;
            var partialMultiplier0to1 = catureMapAndTcvMultiplierObj.partialMultiplier0to1;
            if(captureMap.get("stage_id") === stageObj.id) {
              var captureName = DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap);
              var pwinValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfPwin);
              var rfpDateValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfRFPDate);

              var critthreshMoneyValueRaw = 0;
              var title = "Capture: " + captureName + "\n" + stageFieldDisplayName + ": " + stageObj.name;
              if(critthreshMoneyExpandedFieldMapOrUndefined !== undefined) {
                var critthreshMoneyValueMaskSortIfoCanEditObj = DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMap, critthreshMoneyExpandedFieldMapOrUndefined);
                critthreshMoneyValueRaw = critthreshMoneyValueMaskSortIfoCanEditObj.valueRaw;
                title += "\n" + critthreshMoneyExpandedFieldMapOrUndefined.get("display_name") + ": " + critthreshMoneyValueMaskSortIfoCanEditObj.valueMaskPlainText;
              }
              title += "\n" + pwinFieldDisplayName + ": " + pwinValueMaskPlainText;
              title += "\n" + rfpDateFieldDisplayName + ": " + rfpDateValueMaskPlainText;

              xyPointsArrayOfObjs.push({
                x: captureMap.get("pwin"),
                y: critthreshMoneyValueRaw,
                clickReturnValue: captureMap.get("id"),
                title: title
              });
            }
          }

          criticalPwinThresholdScatterPlotDataArrayOfObjs.push({
            xyPointsArrayOfObjs: xyPointsArrayOfObjs,
            label: stageObj.name,
            color: stageObj.color
          });
        }
      }
    }

    return(criticalPwinThresholdScatterPlotDataArrayOfObjs);
  }

  get c_pwinVsProgressScatterPlotDataArrayOfObjs() {
    const critthreshMoneyFieldID = UserMobx.c_combinedUserObj.divexec_critthresh_money_field_id;
    const critthreshMoneyExpandedFieldMapOrUndefined = DatabaseMobx.c_tbl_captures_fields.get(critthreshMoneyFieldID);

    const stageFieldDisplayName = DatabaseMobx.c_fieldMapOfStage.get("display_name");
    const pwinFieldDisplayName = DatabaseMobx.c_fieldMapOfPwin.get("display_name");
    const progressFieldDisplayName = DatabaseMobx.c_fieldMapOfShapingTotalProgress.get("display_name");
    const rfpDateFieldDisplayName = DatabaseMobx.c_fieldMapOfRFPDate.get("display_name");

    var pwinVsProgressScatterPlotDataArrayOfObjs = [];

    const stageTypeOrdersArrayOfArrays = [[4] ,[5], [6], [7,8]]; //cancelled/no bid on bottom, then lost, then wins on top of the scatterplot pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7
    for(let stageTypeOrdersArray of stageTypeOrdersArrayOfArrays) {
      for(let stageObj of DatabaseMobx.c_adminSortedExpandedStagesArrayOfObjs) {
        if(JSFUNC.in_array(stageObj.pa1_a2_as3_csw4_csl5_cnsnb6_cnsgc7, stageTypeOrdersArray)) {
          var xyPointsArrayOfObjs = [];
          for(let catureMapAndTcvMultiplierObj of this.c_criticalThresholdsFilteredCaptureMapsAndTcvMultipliersArrayOfObjs) {
            var captureMap = catureMapAndTcvMultiplierObj.captureMap;
            var partialMultiplier0to1 = catureMapAndTcvMultiplierObj.partialMultiplier0to1;
            if(captureMap.get("stage_id") === stageObj.id) {
              var captureName = DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap);
              var pwinValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfPwin);
              var progressValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfShapingTotalProgress);
              var rfpDateValueMaskPlainText = DatabaseMobx.value_mask_plaintext_from_capture_map_and_expanded_capture_field_map(captureMap, DatabaseMobx.c_fieldMapOfRFPDate);

              var critthreshMoneyValueRaw = 0;
              var title = "Capture: " + captureName + "\n" + stageFieldDisplayName + ": " + stageObj.name;
              if(critthreshMoneyExpandedFieldMapOrUndefined !== undefined) {
                var critthreshMoneyValueMaskSortIfoCanEditObj = DatabaseMobx.value_mask_sort_ifo_canedit_obj_from_capture_map_and_expanded_capture_field_map(captureMap, critthreshMoneyExpandedFieldMapOrUndefined);
                title += "\n" + critthreshMoneyExpandedFieldMapOrUndefined.get("display_name") + ": " + critthreshMoneyValueMaskSortIfoCanEditObj.valueMaskPlainText;
              }
              title += "\n" + pwinFieldDisplayName + ": " + pwinValueMaskPlainText + "\n" + progressFieldDisplayName + ": " + progressValueMaskPlainText;
              title += "\n" + rfpDateFieldDisplayName + ": " + rfpDateValueMaskPlainText;

              xyPointsArrayOfObjs.push({
                x: captureMap.get("shaping_total_progress"),
                y: captureMap.get("pwin"),
                clickReturnValue: captureMap.get("id"),
                title: title
              });
            }
          }

          pwinVsProgressScatterPlotDataArrayOfObjs.push({
            xyPointsArrayOfObjs: xyPointsArrayOfObjs,
            label: stageObj.name,
            color: stageObj.color
          });
        }
      }
    }

    return(pwinVsProgressScatterPlotDataArrayOfObjs);
  }







  //stage flow
  get c_stageFlowCaptureIDsWithinSelectedFilterCaptureTypeArray() {
    const o_stageFlowSelectedFilterStageTypeString = this.o_stageFlowSelectedFilterStageTypeString;
    const o_stageFlowSelectedFilterCaptureTypeIDOrUndefined = this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;
    const c_tbl_captures_fields = DatabaseMobx.c_tbl_captures_fields;
    const c_fieldMapOfDivisionOwners = DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_fieldMapOfCaptureType = DatabaseMobx.c_fieldMapOfCaptureType;
    const c_fieldMapOfStage = DatabaseMobx.c_fieldMapOfStage;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    var filtersArrayOfObjs = [
      {capture_field_id:c_fieldMapOfCaptureType.get("id"), operator:"e", value:o_stageFlowSelectedFilterCaptureTypeIDOrUndefined},
      {capture_field_id:c_fieldMapOfDivisionOwners.get("id"), operator:"e", value:c_combinedUserObj.divexec_filter_division_ids_comma}
    ];

    //determine which stageIDs are in the selected stage type button
    if(JSFUNC.in_array(o_stageFlowSelectedFilterStageTypeString, ["closed", "active"])) {
      var selectedStageIDsComma = "";
      if(o_stageFlowSelectedFilterStageTypeString === "closed") { selectedStageIDsComma = DatabaseMobx.c_closedStageIDsArray; }
      else if(o_stageFlowSelectedFilterStageTypeString === "active") { selectedStageIDsComma = DatabaseMobx.c_activeStageIDsArray; }

      filtersArrayOfObjs.push({capture_field_id:c_fieldMapOfStage.get("id"), operator:"e", value:selectedStageIDsComma});
    }

    const expandedFiltersArrayOfObjs = CapturesMobx.create_expanded_filters_arrayOfObjs_from_filters_arrayOfObjs_and_expanded_captures_fields_mapOfMaps(filtersArrayOfObjs, c_tbl_captures_fields);

    var stageFlowCaptureIDsWithinSelectedFilterCaptureTypeArray = [];
    for(let [captureID, captureMap] of o_tbl_captures) {
      var partialMultiplier0to1OrFalse = CapturesMobx.capture_matches_all_filters_partialMultiplier0to1_or_false_from_capture_map_and_expanded_filters_arrayOfObjs(captureMap, expandedFiltersArrayOfObjs);
      if(JSFUNC.is_number_not_nan_gte_0(partialMultiplier0to1OrFalse)) {
        stageFlowCaptureIDsWithinSelectedFilterCaptureTypeArray.push(captureID);
      }
    }
    return(stageFlowCaptureIDsWithinSelectedFilterCaptureTypeArray);
  }

  get c_stageFlowStageIDsPerCaptureIDMapOfArrays() {
    //loop through all raw stage changelog data and organize it by captureID
    var stageFlowStageIDsPerCaptureIDMapOfArrays = new Map();

    //ensure a captureTypeID is selected on the stage flow page
    if(this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined !== undefined) {
      //ensure that the thin stage changelog is loaded before creating this map, otherwise return an empty map
      if(JSFUNC.is_array(this.o_stageFlowThinTblCLogStagesArrayOfObjs)) {
        for(let thinLogStageObj of this.o_stageFlowThinTblCLogStagesArrayOfObjs) {
          //test if this stageID is > 0 (usually this happens in import when new captures with no stage specified have a value of -1)
          if(thinLogStageObj.si > 0) {
            //test whether this captureID is within the divexec filter
            if(JSFUNC.in_array(thinLogStageObj.ci, this.c_stageFlowCaptureIDsWithinSelectedFilterCaptureTypeArray)) {
              //find out the capture type of this capture and only include this log record if the capture matches the selected captureTypeID
              var captureMap = DatabaseMobx.o_tbl_captures.get(thinLogStageObj.ci);
              if(captureMap !== undefined) {
                if(captureMap.get("capture_type_id") === this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined) {
                  //see if there's an existing record in the map for this captureID and append it or create a new captureID record in the Map
                  var stageIDsArray = stageFlowStageIDsPerCaptureIDMapOfArrays.get(thinLogStageObj.ci);
                  if(stageIDsArray !== undefined) {
                    stageIDsArray.push(thinLogStageObj.si); //append this log stageID to this captureID record
                  }
                  else { //create a new captureID record in the map with this stageID as its first stage entry
                    stageFlowStageIDsPerCaptureIDMapOfArrays.set(thinLogStageObj.ci, [thinLogStageObj.si]);
                  }
                }
              }
            }
          }
        }

        //loop through the completed Map, for each capture get the current real stageID, if that does not match the last changelog stageID entry, append the real stageID to make it the last entry
        for(let [captureID, stageIDsArray] of stageFlowStageIDsPerCaptureIDMapOfArrays) {
          if(JSFUNC.is_array(stageIDsArray)) {
            var numStageIDs = stageIDsArray.length;
            if(numStageIDs > 0) {
              var captureMap = DatabaseMobx.o_tbl_captures.get(captureID);
              if(captureMap !== undefined) {
                var realStageID = captureMap.get("stage_id");
                var lastLogStageID = stageIDsArray[numStageIDs - 1];
                if(realStageID !== lastLogStageID) {
                  stageIDsArray.push(realStageID);
                }
              }
            }
          }
        }
      }
    }

    return(stageFlowStageIDsPerCaptureIDMapOfArrays);
  }

  get c_stageFlowDataPerStageArrayOfObjs() {
    //undefined is a flag that the data for the stage flow graph is being fetched and loaded from the database
    if(!JSFUNC.is_array(this.o_stageFlowThinTblCLogStagesArrayOfObjs)) {
      return(undefined);
    }

    //error message for 0 available capture types
    if(DatabaseMobx.c_captureTypesArrayOfObjs.length === 0) {
      return("The Stage Flow graph cannot be drawn - there is not a valid " + DatabaseMobx.c_fieldMapOfCaptureType.get("display_name") + " created in the system to select for the stages");
    }

    //error message if the selected capture type does not exist
    const captureTypeMap = DatabaseMobx.o_tbl_a_capture_types.get(this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined);
    if(captureTypeMap === undefined) {
      return("The Stage Flow graph cannot be drawn - the selected " + DatabaseMobx.c_fieldMapOfCaptureType.get("display_name") + " (ID: " + this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined + ") is not valid");
    }

    //set up array of active/closed stageIDs for the selected capture type, if there are 0 active stages or 0 closed stages, an error message is returned instead of an arrayOfObjs
    const captureTypeStageIDsArray = DatabaseMobx.get_all_stage_ids_array_from_capture_type_id(this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined);
    var captureTypeActiveStageIDsArray = [];
    var captureTypeClosedStageIDsArray = [];
    for(let stageID of captureTypeStageIDsArray) {
      if(JSFUNC.in_array(stageID, DatabaseMobx.c_activeStageIDsArray)) {
        captureTypeActiveStageIDsArray.push(stageID);
      }
      else if(JSFUNC.in_array(stageID, DatabaseMobx.c_closedStageIDsArray)) {
        captureTypeClosedStageIDsArray.push(stageID);
      }
    }
    const numCaptureTypeActiveStageIDs = captureTypeActiveStageIDsArray.length;
    const numCaptureTypeClosedStageIDs = captureTypeClosedStageIDsArray.length;

    if(numCaptureTypeActiveStageIDs === 0) {
      return("The Stage Flow graph cannot be drawn - there are no Active Stages in the selected Capture Type");
    }

    if(numCaptureTypeClosedStageIDs === 0) {
      return("The Stage Flow graph cannot be drawn - there are no Closed Stages in the selected Capture Type");
    }

    //if there are 0 stage log entries for this capture type, display an error message
    if(this.c_stageFlowStageIDsPerCaptureIDMapOfArrays.size === 0) {
      return("The Stage Flow graph cannot be drawn - there are no Stage Changelog entries matching the selected Capture Type to plot");
    }

    //build the output for the graph for each active stage and one at the end for all closed stages together (the first active stage is always 100%)
    var stageFlowActiveStagesArrayOfObjs = [];
    for(let activeStageID of captureTypeActiveStageIDsArray) {
      var stageFlowActiveStageObj = this.stage_flow_initialize_graph_stage_obj(activeStageID, captureTypeClosedStageIDsArray);
      stageFlowActiveStagesArrayOfObjs.push(stageFlowActiveStageObj);
    }

    //created the combined closed stages obj that represents the last portion of the stage flow graph
    var stageFlowAllClosedStagesObj = this.stage_flow_initialize_graph_stage_obj(-99, captureTypeClosedStageIDsArray); //this part of the graph is all closed stages as specified in the closed stages arrayOfObjs within this obj, so this active stageObj can be undefined and the transited counts will be 0

    //loop through all organized stage changelog data per capture and add counts into each part of the active closed data for the graph
    for(let [captureID, stageIDsArray] of this.c_stageFlowStageIDsPerCaptureIDMapOfArrays) {
      if(JSFUNC.is_array(stageIDsArray)) {
        var numStageLogs = stageIDsArray.length;
        if(numStageLogs >= 1) {
          var currentStageID = stageIDsArray[numStageLogs - 1]; //last changelog entry is the current stage for this captureID
          if(JSFUNC.in_array(currentStageID, DatabaseMobx.c_closedWonStageIDsArray) || JSFUNC.in_array(currentStageID, DatabaseMobx.c_closedLostStageIDsArray)) { //won/lost capture
            //for a won/lost capture, every active stage gets a transit count
            for(let stageFlowActiveStageObj of stageFlowActiveStagesArrayOfObjs) {
              stageFlowActiveStageObj.transitedFromPrevStageCounts++;
              stageFlowActiveStageObj.transitedFromPrevStageCaptureIDsArray.push(captureID);
            }

            //then the final closed stage gets a count
            for(let stageFlowClosedStageObj of stageFlowAllClosedStagesObj.countsForClosedStagesArrayOfObjs) {
              if(stageFlowClosedStageObj.stageObj.id === currentStageID) {
                stageFlowClosedStageObj.transitedFromPrevStageCounts++;
                stageFlowClosedStageObj.transitedFromPrevStageCaptureIDsArray.push(captureID);
              }
            }
          }
          else if(JSFUNC.in_array(currentStageID, DatabaseMobx.c_activeStageIDsArray)) { //active capture
            //find the stage index within the capture type of this stageID
            var currentActiveStageIndex = captureTypeActiveStageIDsArray.indexOf(currentStageID);
            if(currentActiveStageIndex >= 0) { //found the matching stageID
              //for an active capture, every stage prior to this one (in order of the stages from the capture type) is given a transit count
              for(let s = 0; s < currentActiveStageIndex; s++) {
                stageFlowActiveStagesArrayOfObjs[s].transitedFromPrevStageCounts++;
                stageFlowActiveStagesArrayOfObjs[s].transitedFromPrevStageCaptureIDsArray.push(captureID);
              }

              //then, for the current active stage, increment the current active count
              stageFlowActiveStagesArrayOfObjs[currentActiveStageIndex].currentlyActiveInPrevStageCounts++;
              stageFlowActiveStagesArrayOfObjs[currentActiveStageIndex].currentlyActiveInPrevStageCaptureIDsArray.push(captureID);
            }
          }
          else { //no bid/cancelled capture
            //must find the most recent stage (prior to the current nb/c stage) that is active for this to count (otherwise can't trace where it came from, like if the history was only "11" (nb) or was only "12,11" (won, then nb))
            var mostRecentActiveStageIndex = undefined;
            var logIndex = (numStageLogs - 2);
            while((mostRecentActiveStageIndex === undefined) && (logIndex >= 0)) { //loop in reverse order starting with the 2nd entry from the end
              var stageID = stageIDsArray[logIndex]; //testing this log stageID
              var activeStageIndex = captureTypeActiveStageIDsArray.indexOf(stageID); //try to find the index of this stageID among the capture type active stageIDs
              if(activeStageIndex >= 0) { //this is a valid capture type active stageID
                mostRecentActiveStageIndex = activeStageIndex;
              }
              logIndex--;
            }

            if(mostRecentActiveStageIndex !== undefined) {
              //every stage from the beginning up to and including the most recent active stage have their transit count incremented
              for(let s = 0; s <= mostRecentActiveStageIndex; s++) {
                stageFlowActiveStagesArrayOfObjs[s].transitedFromPrevStageCounts++;
                stageFlowActiveStagesArrayOfObjs[s].transitedFromPrevStageCaptureIDsArray.push(captureID);
              }

              //then the closed nb/c stage from the active stage after the most recent active stage gets a count
              if(mostRecentActiveStageIndex < (numCaptureTypeActiveStageIDs - 1)) { //if this is not the last active stage, increment the closed stage counter within that active
                var nextActiveStageIndexAfterMostRecent = (mostRecentActiveStageIndex + 1);
                for(let countsForClosedStageObj of stageFlowActiveStagesArrayOfObjs[nextActiveStageIndexAfterMostRecent].countsForClosedStagesArrayOfObjs) {
                  if(countsForClosedStageObj.stageObj.id === currentStageID) {
                    countsForClosedStageObj.transitedFromPrevStageCounts++;
                    countsForClosedStageObj.transitedFromPrevStageCaptureIDsArray.push(captureID);
                  }
                }
              }
              else { //the most recent active stage was the last active stage, increment the counter within the last closed stage obj
                for(let stageFlowClosedStageObj of stageFlowAllClosedStagesObj.countsForClosedStagesArrayOfObjs) {
                  if(stageFlowClosedStageObj.stageObj.id === currentStageID) {
                    stageFlowClosedStageObj.transitedFromPrevStageCounts++;
                    stageFlowClosedStageObj.transitedFromPrevStageCaptureIDsArray.push(captureID);
                  }
                }
              }
            }
          }
        }
      }
    }

    //build the final stage flow data arrayOfObjs by combining the active stage objs with the single 'all closed stages' obj
    var stageFlowDataPerStageArrayOfObjs = [];
    for(let stageFlowActiveStageObj of stageFlowActiveStagesArrayOfObjs) {
      stageFlowDataPerStageArrayOfObjs.push(stageFlowActiveStageObj);
    }
    stageFlowDataPerStageArrayOfObjs.push(stageFlowAllClosedStagesObj);

    //compute the total number of counts that each part of the graph will be computed against using the first section (first active stage)
    var stageFlowFirstActiveStageObj = stageFlowDataPerStageArrayOfObjs[0];
    var firstActiveStageTotalCounts = (stageFlowFirstActiveStageObj.transitedFromPrevStageCounts + stageFlowFirstActiveStageObj.currentlyActiveInPrevStageCounts);

    //get the name of this customer's stage field to use in titles
    const stageFieldDisplayName = DatabaseMobx.c_fieldMapOfStage.get("display_name");

    //loop through each stage flow column (each active and single 'all closed') to compute percents and titles of each block
    for(let s = 0; s < stageFlowDataPerStageArrayOfObjs.length; s++) {
      var stageFlowStageObj = stageFlowDataPerStageArrayOfObjs[s];

      var stageObj = stageFlowStageObj.stageObj;
      var isLastColumnTF = (stageObj.id === -99); //the "All Closed Stages" column on thr far right of the graph
      var transitedCounts = stageFlowStageObj.transitedFromPrevStageCounts;
      var currentlyActiveCounts = stageFlowStageObj.currentlyActiveInPrevStageCounts;

      //keep track of how much vertical space is remaining at the bottom of each column to draw a blank area
      var remainingSpacePerc = 100;

      //draw transited through blocks first at top
      stageFlowStageObj.graphTransitedPerc = ((transitedCounts / firstActiveStageTotalCounts) * 100);
      stageFlowStageObj.graphTransitedStartPerc = 0; //transited perc starts at top (0% on svg y-axis)
      stageFlowStageObj.graphTransitedEndPerc = stageFlowStageObj.graphTransitedPerc;
      stageFlowStageObj.graphTransitedColor = "f2f2e0";
      stageFlowStageObj.graphTransitedTitle = transitedCounts + " " + JSFUNC.plural(transitedCounts, "Capture has", "Captures have") + " advanced through and beyond the '" + stageObj.name + "' " + stageFieldDisplayName;

      remainingSpacePerc -= stageFlowStageObj.graphTransitedPerc;

      //then draw any closed stages (half width unless in last -99 column)
      var numClosedStages = stageFlowStageObj.countsForClosedStagesArrayOfObjs.length;
      for(let c = 0; c < numClosedStages; c++) {
        var stageFlowClosedStageObj = stageFlowStageObj.countsForClosedStagesArrayOfObjs[c];
        var closedStageObj = stageFlowClosedStageObj.stageObj;
        var closedCounts = stageFlowClosedStageObj.transitedFromPrevStageCounts;

        stageFlowClosedStageObj.graphClosedPerc = ((closedCounts / firstActiveStageTotalCounts) * 100);
        stageFlowClosedStageObj.graphClosedStartPerc = ((c === 0) ? (stageFlowStageObj.graphTransitedEndPerc) : (stageFlowStageObj.countsForClosedStagesArrayOfObjs[c-1].graphClosedEndPerc)); //use end value from previous graph segment for this one's start
        stageFlowClosedStageObj.graphClosedEndPerc = (stageFlowClosedStageObj.graphClosedStartPerc + stageFlowClosedStageObj.graphClosedPerc);
        stageFlowClosedStageObj.graphClosedColor = closedStageObj.color;
        if(isLastColumnTF) {
          stageFlowClosedStageObj.graphClosedTitle = closedCounts + " " + JSFUNC.plural(closedCounts, "Capture is", "Captures are") + " currently Closed in the '" + closedStageObj.name + "' " + stageFieldDisplayName;
        }
        else {
          if(s > 0) {
            var previousActiveStageFlowStageObj = stageFlowDataPerStageArrayOfObjs[s-1];
            stageFlowClosedStageObj.graphClosedTitle = closedCounts + " " + JSFUNC.plural(closedCounts, "Capture", "Captures") + " passed from the '" + previousActiveStageFlowStageObj.stageObj.name + "' " + stageFieldDisplayName + " directly into the Closed '" + closedStageObj.name + "' " + stageFieldDisplayName;
          }
          else {
            stageFlowClosedStageObj.graphClosedTitle = undefined;
          }
        }

        remainingSpacePerc -= stageFlowClosedStageObj.graphClosedPerc;
      }

      //last, draw any currently active stages at the bottom (quarter width)
      stageFlowStageObj.graphActivePerc = ((currentlyActiveCounts / firstActiveStageTotalCounts) * 100);
      stageFlowStageObj.graphActiveStartPerc = stageFlowStageObj.countsForClosedStagesArrayOfObjs[numClosedStages-1].graphClosedEndPerc;
      stageFlowStageObj.graphActiveEndPerc = (stageFlowStageObj.graphActiveStartPerc + stageFlowStageObj.graphActivePerc);
      stageFlowStageObj.graphActiveColor = stageObj.color;
      stageFlowStageObj.graphActiveTitle = currentlyActiveCounts + " " + JSFUNC.plural(currentlyActiveCounts, "Capture is", "Captures are") + " currently Active in the '" + stageObj.name + "' " + stageFieldDisplayName;

      remainingSpacePerc -= stageFlowStageObj.graphActivePerc;

      stageFlowStageObj.remainingSpacePerc = remainingSpacePerc;
    }

    return(stageFlowDataPerStageArrayOfObjs);
  }

  stage_flow_initialize_graph_stage_obj(i_activeStageID, i_captureTypeClosedStageIDsArray) {
    //initialize counts for all closed stages (holds data on transitioning to no bid/cancelled closed stages from active stages, or to all closed stages for the last part of the graph)
    var countsForClosedStagesArrayOfObjs = [];
    for(let closedStageID of i_captureTypeClosedStageIDsArray) {
      var closedStageMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_stages_pool", closedStageID);
      countsForClosedStagesArrayOfObjs.push({
        stageObj: JSFUNC.obj_from_map(closedStageMap),
        transitedFromPrevStageCounts: 0,
        transitedFromPrevStageCaptureIDsArray: []
      });
    }

    var activeStageMap = DatabaseMobx.tbl_row_map_from_id("tbl_a_stages_pool", i_activeStageID);
    return({
      stageObj: JSFUNC.obj_from_map(activeStageMap),
      transitedFromPrevStageCounts: 0,
      transitedFromPrevStageCaptureIDsArray: [],
      currentlyActiveInPrevStageCounts: 0,
      currentlyActiveInPrevStageCaptureIDsArray: [],
      countsForClosedStagesArrayOfObjs: countsForClosedStagesArrayOfObjs
    });
  }




  //gate review approvals
  get c_gateReviewApprovalsPendingRequestsArrayOfObjs() {
    //determines every Gate Review request (tbl_c_log_stages action_cs0_grreq1_grapp2_grrej3_grcan4 of 1) across all captures that is still awaiting a decision
    //and that the logged in user is one of the designated approval divexecs for (from the Capture Type Stage admin setup)
    const o_gateReviewApprovalsLogStagesArrayOfObjs = this.o_gateReviewApprovalsLogStagesArrayOfObjs;
    const o_tbl_captures = DatabaseMobx.o_tbl_captures;
    const o_userID = UserMobx.o_userID;
    const c_fieldMapOfStage = DatabaseMobx.c_fieldMapOfStage;
    const c_genericDateFieldTypeObj = DatabaseMobx.c_genericDateFieldTypeObj;

    if(!JSFUNC.is_array(o_gateReviewApprovalsLogStagesArrayOfObjs)) { //gate review action rows are not loaded from the database yet
      return([]);
    }

    const stageFieldTypeObj = c_fieldMapOfStage.get("fieldTypeObj");

    //the rows come back sorted oldest first by id, so the last row written per captureID/stageID pair is the current state of that Gate Review
    var latestGateReviewActionLogObjPerCaptureIDStageIDMap = new Map();
    for(let gateReviewLogObj of o_gateReviewApprovalsLogStagesArrayOfObjs) {
      latestGateReviewActionLogObjPerCaptureIDStageIDMap.set(gateReviewLogObj.capture_id + "|" + gateReviewLogObj.stage_id, gateReviewLogObj);
    }

    var pendingRequestsArrayOfObjs = [];
    for(let latestGateReviewLogObj of latestGateReviewActionLogObjPerCaptureIDStageIDMap.values()) {
      if(latestGateReviewLogObj.action_cs0_grreq1_grapp2_grrej3_grcan4 === 1) { //the latest Gate Review action on this capture/stage is a request still awaiting an approval or rejection
        var captureID = latestGateReviewLogObj.capture_id;
        var stageID = latestGateReviewLogObj.stage_id;
        var captureMap = o_tbl_captures.get(captureID);
        if(captureMap !== undefined) { //this capture is visible to the logged in user
          //look up the Gate Review admin setup on this stage within this capture's capture type
          var expandedCaptureTypeStagesArrayOfObjs = DatabaseMobx.get_filtered_expanded_capture_type_stages_arrayOfObjs_sorted_by_stage_type_and_sort_from_capture_type_id(captureMap.get("capture_type_id"));
          var expandedCaptureTypeStageObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(expandedCaptureTypeStagesArrayOfObjs, "stage_id", stageID);
          if(expandedCaptureTypeStageObjOrUndefined !== undefined) {
            if(expandedCaptureTypeStageObjOrUndefined.gateReviewToEnterStageIsSetTF && JSFUNC.in_array(o_userID, expandedCaptureTypeStageObjOrUndefined.gateReviewToEnterStageApprovalDivexecUserIDsArray)) { //the logged in user is one of the designated approval divexecs for this Gate Review
              var gateReviewName = expandedCaptureTypeStageObjOrUndefined.gate_review_to_enter_stage_name;
              if(!JSFUNC.string_is_filled_out_tf(gateReviewName)) {
                gateReviewName = "Gate Review";
              }

              var requestedDateLocalYmd = JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(latestGateReviewLogObj.datetime_utc);

              pendingRequestsArrayOfObjs.push({
                logID: latestGateReviewLogObj.id,
                captureID: captureID,
                captureName: DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap),
                stageID: stageID,
                stageName: DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(stageID, stageFieldTypeObj),
                gateReviewName: gateReviewName,
                approvalDivexecUserIDsArray: expandedCaptureTypeStageObjOrUndefined.gateReviewToEnterStageApprovalDivexecUserIDsArray,
                requestedByUserName: DatabaseMobx.user_name_mask_plaintext_from_user_id_and_alt_user_name_if_not_filled_out(latestGateReviewLogObj.user_id, latestGateReviewLogObj.user),
                requestedDateLocalYmd: requestedDateLocalYmd,
                requestedDateMaskPlainText: DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(requestedDateLocalYmd, c_genericDateFieldTypeObj),
                requestComment: latestGateReviewLogObj.gate_review_action_comment
              });
            }
          }
        }
      }
    }

    //oldest requests first so that the longest waiting Gate Review requests are at the top of the list
    JSFUNC.sort_arrayOfObjs(pendingRequestsArrayOfObjs, "logID", true);

    return(pendingRequestsArrayOfObjs);
  }




  //excel report writer
  get c_excelReportTemplatesWithinFoldersObj() {
    return(DatabaseMobx.generate_templates_within_folders_obj_from_admin_templates_ffs_tbl_name("tbl_a_excel_report_templates_filefoldersystem", "Excel Reports"));
  }




  //========================================================================================
  //actions
  //performance
  a_performance_set_selected_user_or_division_id(i_userTrueDivisionFalse, i_userOrDivisionID) {
    this.o_performanceSelectedUserTrueDivisionFalse = i_userTrueDivisionFalse;
    this.o_performanceSelectedUserOrDivisionID = i_userOrDivisionID;
    this.a_performance_set_mobile_screen("graphs");
  }

  a_performance_set_selected_custom_performance_option_id(i_optionID) {
    this.o_performanceSelectedCustomPerformanceOptionID = i_optionID;
    if(i_optionID !== undefined) {
      this.a_performance_set_mobile_screen("graphs");
    }
  }

  a_performance_set_mobile_screen(i_screen) {
    this.o_performanceMobileScreen = i_screen;
  }

  a_performance_set_goals_graph_options_expanded_tf(i_newValueTF) {
    this.o_performanceGoalsGraphOptionsExpandedTF = i_newValueTF;
  }

  a_performance_set_selected_fyr_to_view_edit(i_fyr) {
    this.o_performanceSelectedFyrToViewEdit = i_fyr;
    this.a_performance_set_view_fyr_selected_captures_to_view_obj_or_undefined(undefined); //if choosing a different FYR to view/edit, reset any captures that were being viewed within the floating box
  }

  a_performance_set_view_fyr_selected_captures_to_view_obj_or_undefined(i_objOrUndefined) {
    this.o_performanceViewFyrSelectedCapturesToViewObjOrUndefined = i_objOrUndefined;
  }

  a_performance_update_or_insert_fyr_quota(i_fyrInt, i_tblDQuotaColumnDbNameToUpdate, i_updated12monthQuotaCommaString) {
    const o_performanceSelectedUserTrueDivisionFalse = this.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.o_performanceSelectedUserOrDivisionID;
    const c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined = this.c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined;
    const c_tbl_d_quota = DatabaseMobx.c_tbl_d_quota;
    const c_combinedUserObj = UserMobx.c_combinedUserObj;

    var updatingSalesPerformanceSubmittedGoalTF = false;
    var updatingSalesPerformanceWonGoalTF = false;
    var updatingWaterfallProjectionsWonGoalTF = false;
    if(i_tblDQuotaColumnDbNameToUpdate === "sales_performance_submitted_goal_12months_comma") { updatingSalesPerformanceSubmittedGoalTF = true; }
    else if(i_tblDQuotaColumnDbNameToUpdate === "sales_performance_won_goal_12months_comma") { updatingSalesPerformanceWonGoalTF = true; }
    else if(i_tblDQuotaColumnDbNameToUpdate === "waterfall_projections_won_goal_12_months_comma") { updatingWaterfallProjectionsWonGoalTF = true; }

    if(updatingSalesPerformanceSubmittedGoalTF || updatingSalesPerformanceWonGoalTF || updatingWaterfallProjectionsWonGoalTF) {
      var quotaUser0Division1 = -1;
      var quotaSelectedUserOrDivisionID = -1;
      var quotaMoneyFieldID = -1;
      var quotaCustomPerformanceCaptureFieldID = -1;
      if(updatingSalesPerformanceSubmittedGoalTF || updatingSalesPerformanceWonGoalTF) { //performance (submitted/won) selected from green divisions/users tree
        if(UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF) {
          quotaUser0Division1 = -1;
          quotaSelectedUserOrDivisionID = this.o_performanceSelectedCustomPerformanceOptionID;
          quotaCustomPerformanceCaptureFieldID = ((this.o_performanceSelectedCustomPerformanceOptionID === -1) ? (-1) : (c_combinedUserObj.divexec_performance_custom_performance_selected_capture_field_id));
        }
        else {
          quotaUser0Division1 = ((o_performanceSelectedUserTrueDivisionFalse) ? (0) : (1));
          quotaSelectedUserOrDivisionID = o_performanceSelectedUserOrDivisionID;
        }
        if(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined !== undefined) {
          quotaMoneyFieldID = c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined.get("id");
        }
      }
      else if(updatingWaterfallProjectionsWonGoalTF) { //projections selected from 'Goals Division' select
        quotaUser0Division1 = 1; //can only select a division to edit goals for
        quotaSelectedUserOrDivisionID = c_combinedUserObj.divexec_finproj_goals_division_id;
        quotaMoneyFieldID = c_combinedUserObj.divexec_finproj_money_field_id;
      }

      const customPerformanceQuotaIdentityIsValidTF = ((quotaUser0Division1 === -1) && (((quotaSelectedUserOrDivisionID === -1) && (quotaCustomPerformanceCaptureFieldID === -1)) || (JSFUNC.select_int_is_filled_out_tf(quotaSelectedUserOrDivisionID) && JSFUNC.select_int_is_filled_out_tf(quotaCustomPerformanceCaptureFieldID))));
      const userOrDivisionQuotaIdentityIsValidTF = (JSFUNC.in_array(quotaUser0Division1, [0, 1]) && JSFUNC.select_int_is_filled_out_tf(quotaSelectedUserOrDivisionID));
      if((customPerformanceQuotaIdentityIsValidTF || userOrDivisionQuotaIdentityIsValidTF) && JSFUNC.select_int_is_filled_out_tf(quotaMoneyFieldID)) {
        const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_performance_update_or_insert_fyr_quota", ["i_fyrInt", "i_tblDQuotaColumnDbNameToUpdate", "i_updated12monthQuotaCommaString"], [i_fyrInt, i_tblDQuotaColumnDbNameToUpdate, i_updated12monthQuotaCommaString]);
        const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

        var existingQuotaFieldNamesArray = ["user0_division1", "userdiv_id", "money_field_id", "fyr"];
        var existingQuotaValuesArray = [quotaUser0Division1, quotaSelectedUserOrDivisionID, quotaMoneyFieldID, i_fyrInt];
        if(quotaUser0Division1 === -1) {
          existingQuotaFieldNamesArray.push("custom_performance_capture_field_id");
          existingQuotaValuesArray.push(quotaCustomPerformanceCaptureFieldID);
        }
        const existingQuotaMapOrUndefined = JSFUNC.get_first_map_matching_field_value(c_tbl_d_quota, existingQuotaFieldNamesArray, existingQuotaValuesArray);
        if(existingQuotaMapOrUndefined !== undefined) {
          C_CallPhpTblUID.add_update("tbl_d_quota", existingQuotaMapOrUndefined.get("id"), i_tblDQuotaColumnDbNameToUpdate, i_updated12monthQuotaCommaString, "s");
        }
        else { //if no record for this fyr exists yet, create a new entry
          const newSalesPerformanceSubmittedGoal12MonthsComma = ((updatingSalesPerformanceSubmittedGoalTF) ? (i_updated12monthQuotaCommaString) : (""));
          const newSalesPerformanceWonGoal12MonthsComma = ((updatingSalesPerformanceWonGoalTF) ? (i_updated12monthQuotaCommaString) : (""));
          const newWaterfallProjectionseWonGoal12MonthsComma = ((updatingWaterfallProjectionsWonGoalTF) ? (i_updated12monthQuotaCommaString) : (""));
          const fieldNamesArray = ["user0_division1", "custom_performance_capture_field_id", "userdiv_id", "money_field_id", "fyr", "sales_performance_submitted_goal_12months_comma", "sales_performance_won_goal_12months_comma", "waterfall_projections_won_goal_12_months_comma"];
          const valuesArray = [quotaUser0Division1, quotaCustomPerformanceCaptureFieldID, quotaSelectedUserOrDivisionID, quotaMoneyFieldID, i_fyrInt, newSalesPerformanceSubmittedGoal12MonthsComma, newSalesPerformanceWonGoal12MonthsComma, newWaterfallProjectionseWonGoal12MonthsComma];
          const idsbArray = ["i", "i", "i", "i", "i", "s", "s", "s"];
          C_CallPhpTblUID.add_insert("tbl_d_quota", fieldNamesArray, valuesArray, idsbArray);
        }

        C_CallPhpTblUID.execute();
      }
    }
  }

  a_performance_generate_all_quotas_csv_arrayOfArrays() {
    const c_performanceDivisionsWithUsersArrayOfObjs = this.c_performanceDivisionsWithUsersArrayOfObjs;
    const c_tbl_d_quota = DatabaseMobx.c_tbl_d_quota;
    const c_selectCaptureRevenueCardMoneyFieldFieldTypeObj = DatabaseMobx.c_selectCaptureRevenueCardMoneyFieldFieldTypeObj;

    const quotaTypesArrayOfObjs = [
      {fieldDbName:"sales_performance_submitted_goal_12months_comma", displayName:"Submitted"},
      {fieldDbName:"sales_performance_won_goal_12months_comma", displayName:"Won"},
      {fieldDbName:"waterfall_projections_won_goal_12_months_comma", displayName:"Waterfall"}
    ];

    //initialize table of goals
    var allVisibleDivisionAndUserGoalsArrayOfArrays = [];

    //column headers in row 1
    var row1HeaderStringsArray = ["Performance Goal Type", "Performance Goal Name", "Money Field Name", "FYR", "Submitted/Won Goal Type", "Annual Goal $"];
    for(let m = 1; m <= 12; m++) {
      row1HeaderStringsArray.push("FYR Month " + m + " Goal $");
    }
    allVisibleDivisionAndUserGoalsArrayOfArrays.push(row1HeaderStringsArray);
    
    var allQuotasArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(c_tbl_d_quota); //example row: user0_division1:1, userdiv_id:1, money_field_id:19, fyr:2024, sales_performance_submitted_goal_12months_comma:"", sales_performance_won_goal_12months_comma:"", waterfall_projections_won_goal_12_months_comma:"3,2,2,3,2,2,3,2,2,3,2,2"
    if(allQuotasArrayOfObjs.length > 0) { //no need to loop through and find matching goals if there are 0 goals in the databse tbl
      JSFUNC.sort_arrayOfObjs(allQuotasArrayOfObjs, ["money_field_id", "fyr"], [true, false]);

      //loop over each visible division to this divexec
      for(let performanceDivisionObj of c_performanceDivisionsWithUsersArrayOfObjs) {
        //find all money/fyr/wonsub quota rows for this divisionID
        for(let quotaObj of allQuotasArrayOfObjs) {
          if((quotaObj.user0_division1 === 1) && (quotaObj.userdiv_id === performanceDivisionObj.id)) { //division with matching divisionID
            for(let quotaTypeObj of quotaTypesArrayOfObjs) {
              if(quotaObj[quotaTypeObj.fieldDbName] !== "") { //if a quota 12MonthsComma is "", it is not recorded
                var moneyFieldNamePlainText = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(quotaObj.money_field_id, c_selectCaptureRevenueCardMoneyFieldFieldTypeObj);
                var divisionSubmittedQuotaYqmObj = JSFUNC.convert_monthly12_comma_into_yearly_quarterly_monthly_obj_as_whole_dollars(quotaObj[quotaTypeObj.fieldDbName]);
                var csvDataRowArray = ["Division", performanceDivisionObj.name, moneyFieldNamePlainText, quotaObj.fyr, quotaTypeObj.displayName, JSFUNC.array_sum(divisionSubmittedQuotaYqmObj.monthly12Array)];
                for(let m = 0; m < 12; m++) {
                  csvDataRowArray.push(divisionSubmittedQuotaYqmObj.monthly12Array[m]);
                }
                allVisibleDivisionAndUserGoalsArrayOfArrays.push(csvDataRowArray);
              }
            }
          }
        }

        //loop over each user within this division
        for(let performanceUserObj of performanceDivisionObj.usersArrayOfObjs) {
          //find all money/fyr/wonsub quota rows for this divisionID
          for(let quotaObj of allQuotasArrayOfObjs) {
            if((quotaObj.user0_division1 === 0) && (quotaObj.userdiv_id === performanceUserObj.id)) { //user with matching userID
              for(let quotaTypeObj of quotaTypesArrayOfObjs) {
                if(quotaObj[quotaTypeObj.fieldDbName] !== "") { //if a quota 12MonthsComma is "", it is not recorded
                  var moneyFieldNamePlainText = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(quotaObj.money_field_id, c_selectCaptureRevenueCardMoneyFieldFieldTypeObj);
                  var userSubmittedQuotaYqmObj = JSFUNC.convert_monthly12_comma_into_yearly_quarterly_monthly_obj_as_whole_dollars(quotaObj[quotaTypeObj.fieldDbName]);
                  var csvDataRowArray = ["User", performanceUserObj.name, moneyFieldNamePlainText, quotaObj.fyr, quotaTypeObj.displayName, JSFUNC.array_sum(divisionSubmittedQuotaYqmObj.monthly12Array)];
                  for(let m = 0; m < 12; m++) {
                    csvDataRowArray.push(userSubmittedQuotaYqmObj.monthly12Array[m]);
                  }
                  allVisibleDivisionAndUserGoalsArrayOfArrays.push(csvDataRowArray);
                }
              }
            }
          }
        }
      }

      //custom performance goals are not tied to the division tree, so include every valid custom option quota
      for(let quotaObj of allQuotasArrayOfObjs) {
        if(quotaObj.user0_division1 === -1) {
          var customPerformanceName = undefined;
          if((quotaObj.custom_performance_capture_field_id === -1) && (quotaObj.userdiv_id === -1)) {
            customPerformanceName = "All Values";
          }
          else {
            const customPerformanceFieldMap = DatabaseMobx.c_tbl_captures_fields.get(quotaObj.custom_performance_capture_field_id);
            if((customPerformanceFieldMap !== undefined) && customPerformanceFieldMap.get("fieldRequiresSwsDataObjTF")) {
              const customOptionName = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(quotaObj.userdiv_id, customPerformanceFieldMap.get("fieldTypeObj"));
              customPerformanceName = customPerformanceFieldMap.get("display_name") + ": " + customOptionName;
            }
          }
          if(customPerformanceName !== undefined) {
            for(let quotaTypeObj of quotaTypesArrayOfObjs) {
              if(quotaObj[quotaTypeObj.fieldDbName] !== "") {
                const moneyFieldNamePlainText = DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(quotaObj.money_field_id, c_selectCaptureRevenueCardMoneyFieldFieldTypeObj);
                const customPerformanceQuotaYqmObj = JSFUNC.convert_monthly12_comma_into_yearly_quarterly_monthly_obj_as_whole_dollars(quotaObj[quotaTypeObj.fieldDbName]);
                var csvDataRowArray = ["Custom Performance", customPerformanceName, moneyFieldNamePlainText, quotaObj.fyr, quotaTypeObj.displayName, JSFUNC.array_sum(customPerformanceQuotaYqmObj.monthly12Array)];
                for(let m = 0; m < 12; m++) {
                  csvDataRowArray.push(customPerformanceQuotaYqmObj.monthly12Array[m]);
                }
                allVisibleDivisionAndUserGoalsArrayOfArrays.push(csvDataRowArray);
              }
            }
          }
        }
      }
    }

    return(allVisibleDivisionAndUserGoalsArrayOfArrays);
  }








  //financial projections
  a_finproj_set_selected_subtab(i_selectedSubTabDbNameString) {
    this.o_finProjSelectedSubTabDbName = i_selectedSubTabDbNameString;
  }

  a_finproj_set_graph_options_expanded_tf(i_newValueTF) {
    this.o_finProjGraphOptionsExpandedTF = i_newValueTF;
  }

  a_finproj_set_graph_editing_goal_fyr(i_newValueInt) {
    this.o_finProjGraphEditingGoalFyr = i_newValueInt;
  }
  
  a_finproj_set_max_num_captures(i_maxNumCaptures) {
    this.o_finProjMaxNumCaptures = i_maxNumCaptures;
  }






  //graphs
  a_graphs_set_selected_page_id(i_pageID) {
    if(this.c_tabDailySnapshotTrueTrendAnalyzerFalse) {
      this.o_dailySnapshotSelectedPageID = i_pageID;
    }
    else {
      this.o_trendAnalyzerSelectedPageID = i_pageID;
    }
  }

  a_graphs_initialize_selected_page_id_to_first_option() {
    var newSelectedPageID = -1;
    if(this.c_graphsSelectedTabAllPagesArrayOfObjs.length > 0) {
      newSelectedPageID = this.c_graphsSelectedTabAllPagesArrayOfObjs[0].id; //id of first sorted graph page button
    }
    this.a_graphs_set_selected_page_id(newSelectedPageID);
  }

  a_graphs_create_new_page(i_newPageName) {
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabPagesTblName = this.c_graphsSelectedTabPagesTblName;
    const c_graphsSelectedTabAllPagesArrayOfObjs = this.c_graphsSelectedTabAllPagesArrayOfObjs;
    const o_userID = UserMobx.o_userID;

    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_create_new_page", ["i_newPageName"], [i_newPageName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    
    const newPageSort = (c_graphsSelectedTabAllPagesArrayOfObjs.length + 1);

    var fieldNamesArray = [];
    var valuesArray = [];
    var idsbArray = [];
    if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
      fieldNamesArray = this.graphs_daily_snapshot_page_field_names_array();
      valuesArray = [o_userID, newPageSort, o_userID, 0, -1, i_newPageName, 2, 26];
      idsbArray = this.graphs_daily_snapshot_page_idsb_array();
    }
    else {
      fieldNamesArray = this.graphs_trend_analyzer_page_field_names_array();
      valuesArray = [o_userID, newPageSort, o_userID, 0, -1, i_newPageName, 2, 26, "8004-01-04", "9001-01-04"]; //-4 years start to +1 year end
      idsbArray = this.graphs_trend_analyzer_page_idsb_array();
    }
    C_CallPhpTblUID.add_insert(c_graphsSelectedTabPagesTblName, fieldNamesArray, valuesArray, idsbArray);

    const functionOnSuccess = (i_parseResponse) => {
      const newlyInsertedPageID = i_parseResponse.outputObj.i0;
      this.a_graphs_set_selected_page_id(newlyInsertedPageID);
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();
  }

  a_graphs_delete_page_and_graphs_from_page_id(i_deletedPageID) {
    const c_graphsSelectedTabPagesTblName = this.c_graphsSelectedTabPagesTblName;
    const c_graphsSelectedTabGraphsTblName = this.c_graphsSelectedTabGraphsTblName;
    const o_userID = UserMobx.o_userID;

    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_delete_page_and_graphs_from_page_id", ["i_deletedPageID"], [i_deletedPageID]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //delete this page
    C_CallPhpTblUID.add_delete(c_graphsSelectedTabPagesTblName, i_deletedPageID, "sort", "user_id", o_userID); //resort tbl after delete filtered by this users userID

    //delete all graphs that were on this page
    const selectedTabGraphsTblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(c_graphsSelectedTabGraphsTblName);
    const graphIDsToDeleteArray = JSFUNC.get_column_vector_from_mapOfMaps_matching_field_value(selectedTabGraphsTblRefMapOfMaps, "page_id", i_deletedPageID, "id");
    C_CallPhpTblUID.add_delete(c_graphsSelectedTabGraphsTblName, graphIDsToDeleteArray); //no need to resort as every graph on the page is deleted

    //delete any pages that are replicas using this page as a reference (replica pages do not have graphs attached to their ids, no need to delete graphs from replica pages)
    const selectedTabPagesTblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(c_graphsSelectedTabPagesTblName);
    for(let pageMap of selectedTabPagesTblRefMapOfMaps.values()) {
      if(pageMap.get("replica_of_page_id") === i_deletedPageID) {
        var resortSortColumnName = "sort";
        var resortFilterFieldNameOrFieldNamesArray = "user_id";
        var resortFilterValueOrValuesArray = pageMap.get("user_id");
        C_CallPhpTblUID.add_delete(c_graphsSelectedTabPagesTblName, pageMap.get("id"), resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);
      }
    }

    //reinitialize to select the first of all available pages
    const functionOnFinish = () => {
      this.a_graphs_initialize_selected_page_id_to_first_option();
    }
    C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

    C_CallPhpTblUID.execute();
  }

  a_graphs_add_public_page_as_replica_or_system_page_as_new_page(i_pageID, i_newPageName="") {
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabPagesTblName = this.c_graphsSelectedTabPagesTblName;
    const c_graphsSelectedTabGraphsTblName = this.c_graphsSelectedTabGraphsTblName;
    const c_graphsSelectedTabAllPagesArrayOfObjs = this.c_graphsSelectedTabAllPagesArrayOfObjs;
    const c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj = this.c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj;
    const o_userID = UserMobx.o_userID;

    const pageIsValidPublicTF = JSFUNC.select_int_is_filled_out_tf(i_pageID);
    const pageIsValidSystemTF = JSFUNC.in_array(i_pageID, ["dsP1", "dsP2", "taP1"]);

    if(pageIsValidPublicTF || pageIsValidSystemTF) {
      const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_add_public_page_as_replica_or_system_page_as_new_page", ["i_pageID"], [i_pageID]);
      const C_CallPhpTblUIDInsertPage = new JSPHP.ClassCallPhpTblUID(jsDescription);

      var fieldNamesArray = [];
      var idsbArray = [];
      if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
        fieldNamesArray = this.graphs_daily_snapshot_page_field_names_array();
        idsbArray = this.graphs_daily_snapshot_page_idsb_array();
      }
      else {
        fieldNamesArray = this.graphs_trend_analyzer_page_field_names_array();
        idsbArray = this.graphs_trend_analyzer_page_idsb_array();
      }

      const newPageSort = (c_graphsSelectedTabAllPagesArrayOfObjs.length + 1);

      //pageIDs are positive rowIDs for public pages, and strings like "dsP1" and "taP1" for system
      var valuesArray = [];
      if(pageIsValidPublicTF) {
        if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
          valuesArray = [o_userID, newPageSort, -1, -1, i_pageID, "", -1, -1];
        }
        else {
          valuesArray = [o_userID, newPageSort, -1, -1, i_pageID, "", -1, -1, JSFUNC.blank_date(), JSFUNC.blank_date()];
        }
      }
      else if(pageIsValidSystemTF) {
        if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
          valuesArray = [o_userID, newPageSort, o_userID, -1, i_pageID, i_newPageName, 2, 26];
        }
        else {
          valuesArray = [o_userID, newPageSort, o_userID, -1, i_pageID, i_newPageName, 2, 26, "8004-01-04", "9001-01-04"]; //"user_id", "sort", "created_by_user_id", "public_01", "replica_of_page_id", "name", "num_graphs_per_row", "graph_height_em", "start_date", "end_date"
        }
      }
      C_CallPhpTblUIDInsertPage.add_insert(c_graphsSelectedTabPagesTblName, fieldNamesArray, valuesArray, idsbArray);

      const functionOnSuccessInsertPage = (i_parseResponse) => {
        const newlyInsertedPageID = i_parseResponse.outputObj.i0;
        if(pageIsValidPublicTF) { //new public page, doesn't need to insert graphs, they are read from the replicated page when rendered
          this.a_graphs_set_selected_page_id(newlyInsertedPageID);
        }
        else if(pageIsValidSystemTF) { //system graphs need to be inserted at this point using the newlyInsertedPageID
          const C_CallPhpTblUIDInsertGraphs = new JSPHP.ClassCallPhpTblUID(jsDescription);

          const graphFieldNamesArray = ((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.graphs_daily_snapshot_graphs_field_names_array()) : (this.graphs_trend_analyzer_graphs_field_names_array()));
          const graphIdsbArray = ((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.graphs_daily_snapshot_graphs_idsb_array()) : (this.graphs_trend_analyzer_graphs_idsb_array()));

          var systemGraphsDataOnSystemPageObj = {userGraphsDataArrayOfObjs:[]}; //"id", "userNameMaskPlainText", "userNameSort", "userGraphsDataArrayOfObjs"
          if(i_pageID === "dsP1") { systemGraphsDataOnSystemPageObj = c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj.dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs[0]; }
          else if(i_pageID === "dsP2") { systemGraphsDataOnSystemPageObj = c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj.dailySnapshotAllSystemGraphsDataPerSystemPageArrayOfObjs[1]; }
          else if(i_pageID === "taP1") { systemGraphsDataOnSystemPageObj = c_graphsAllSystemGraphsDataPerSystemPageDailyAndTrendObj.trendAnalyzerAllSystemGraphsDataPerSystemPageArrayOfObjs[0]; }

          //loop over each system graph on this system page
          var graphSort = 1;
          for(let systemGraphDataObj of systemGraphsDataOnSystemPageObj.userGraphsDataArrayOfObjs) {
            //copy all system graph values into the valuesArray
            var graphValuesArray = [];
            for(let f = 0; f < graphFieldNamesArray.length; f++) {
              graphValuesArray.push(systemGraphDataObj.graphObj[graphFieldNamesArray[f]]);
            }

            //overwrite a few values for this user and page (first 5 graph fields for both daily and trend are "page_id", "sort", "created_by_user_id", "public_01", "replica_of_graph_id")
            graphValuesArray[0] = newlyInsertedPageID;
            graphValuesArray[1] = graphSort;
            graphValuesArray[2] = o_userID;
            graphValuesArray[3] = 0;
            graphValuesArray[4] = -1;
            C_CallPhpTblUIDInsertGraphs.add_insert(c_graphsSelectedTabGraphsTblName, graphFieldNamesArray, graphValuesArray, graphIdsbArray);

            graphSort++;
          }

          const functionOnfinishInsertGraphs = () => {
              this.a_graphs_set_selected_page_id(newlyInsertedPageID);
          }
          C_CallPhpTblUIDInsertGraphs.add_function("onFinish", functionOnfinishInsertGraphs);

          C_CallPhpTblUIDInsertGraphs.execute();
        }
      }
      C_CallPhpTblUIDInsertPage.add_function("onSuccess", functionOnSuccessInsertPage);

      C_CallPhpTblUIDInsertPage.execute();
    }
  }

  a_graphs_copy_page(i_pageObj, i_newPageName) {
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabPagesTblName = this.c_graphsSelectedTabPagesTblName;
    const c_graphsSelectedTabGraphsTblName = this.c_graphsSelectedTabGraphsTblName;
    const o_userID = UserMobx.o_userID;

    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_copy_page", ["i_pageObj", "i_newPageName"], [i_pageObj, i_newPageName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //insert the new copied page record
    var fieldNamesArray = [];
    var idsbArray = [];
    if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
      fieldNamesArray = this.graphs_daily_snapshot_page_field_names_array();
      idsbArray = this.graphs_daily_snapshot_page_idsb_array();
    }
    else {
      fieldNamesArray = this.graphs_trend_analyzer_page_field_names_array();
      idsbArray = this.graphs_trend_analyzer_page_idsb_array();
    }

    //if the page being copied is a replica of a different public page, try to load that page so that this copy is editable by this user and is no longer a replica
    var pageIDOrReferencedPageID = i_pageObj.id;
    var referencedPageMap = undefined; //undefined for non-replica page
    if(i_pageObj.replica_of_page_id > 0) { //this page is a replica
      const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(c_graphsSelectedTabPagesTblName);
      referencedPageMap = JSFUNC.get_first_map_matching_field_value(tblRefMapOfMaps, "id", i_pageObj.replica_of_page_id);
      if(referencedPageMap !== undefined) {
        pageIDOrReferencedPageID = referencedPageMap.get("id");
      }
    }

    //get all values to copy from i_graphDataObj looping over all page tbl fields
    var valuesArray = [];
    for(let fieldName of fieldNamesArray) {
      var copyValue = i_pageObj[fieldName];
      if(fieldName === "name") {
        copyValue = i_newPageName; //use the new page name
      }
      else if(fieldName === "sort") {
        copyValue = i_pageObj.sort; //make the new page sort the previous sort, which resorts to be 1 space after the original
      }
      else if(fieldName === "user_id") {
        copyValue = o_userID; //change that this page is on your divexec tab
      }
      else if(fieldName === "created_by_user_id") {
        copyValue = o_userID; //change creator of this page to this user
      }
      else if(fieldName === "public_01") {
        copyValue = 0; //set this copied page to private
      }
      else if(fieldName === "replica_of_page_id") {
        copyValue = -1; //set this as a new page, not a replica
      }
      else {
        if(referencedPageMap !== undefined) { //this is a replica page referencing a public page that exists
          copyValue = referencedPageMap.get(fieldName);
        }
      }
      valuesArray.push(copyValue);
    }

    const resortSortColumnName = "sort";
    const resortFilterFieldNameOrFieldNamesArray = ["user_id"];
    const resortFilterValueOrValuesArray = [i_pageObj.user_id];
    C_CallPhpTblUID.add_insert(c_graphsSelectedTabPagesTblName, fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

    //copy all graph records that were on that page
    const functionOnSuccess = (i_parseResponse) => {
      const newlyInsertedPageID = i_parseResponse.outputObj.i0;

      const C_CallPhpTblUIDCopiedPageGraphs = new JSPHP.ClassCallPhpTblUID(jsDescription);

      const graphFieldNamesArray = ((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.graphs_daily_snapshot_graphs_field_names_array()) : (this.graphs_trend_analyzer_graphs_field_names_array()));
      const graphIdsbArray = ((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? (this.graphs_daily_snapshot_graphs_idsb_array()) : (this.graphs_trend_analyzer_graphs_idsb_array()));
      const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(c_graphsSelectedTabGraphsTblName);
      for(let graphMap of tblRefMapOfMaps.values()) {
        if(graphMap.get("page_id") === pageIDOrReferencedPageID) {
          //determine if the graph to copy onto this page is itself a replica or a real graph
          var graphMapOrReferencedGraphMap = undefined;

          var graphReplicaOfGraphID = graphMap.get("replica_of_graph_id");
          if(graphReplicaOfGraphID > 0) { //this graph is a replica, the real graph row needs to be copied instead
            graphMapOrReferencedGraphMap = tblRefMapOfMaps.get(graphReplicaOfGraphID); //undefned if the reference row graph does not exist
          }
          else { //this graph is a real graph, copy it exactly (changing the pageID and the created by user fields)
            graphMapOrReferencedGraphMap = graphMap;
          }

          if(graphMapOrReferencedGraphMap !== undefined) {
            var graphValuesArray = [];
            for(let graphFieldName of graphFieldNamesArray) {
              var copiedGraphValue = graphMapOrReferencedGraphMap.get(graphFieldName);
              if(graphFieldName === "page_id") {
                copiedGraphValue = newlyInsertedPageID;
              }
              else if(graphFieldName === "created_by_user_id") {
                copiedGraphValue = o_userID;
              }
              else if(graphFieldName === "public_01") {
                copiedGraphValue = 0;
              }
              graphValuesArray.push(copiedGraphValue);
            }

            //insert this new graph row into the graphs tbl for this newly copied page
            C_CallPhpTblUIDCopiedPageGraphs.add_insert(c_graphsSelectedTabGraphsTblName, graphFieldNamesArray, graphValuesArray, graphIdsbArray);
          }
        }
      }

      C_CallPhpTblUIDCopiedPageGraphs.execute();

      this.a_graphs_set_selected_page_id(newlyInsertedPageID);
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();
  }

  a_graphs_create_new_graph() {
    const c_graphsSelectedPageID = this.c_graphsSelectedPageID;
    const c_graphsSelectedTabAllGraphsArrayOfObjs = this.c_graphsSelectedTabAllGraphsArrayOfObjs;
    const o_userID = UserMobx.o_userID;

    if(JSFUNC.is_number_not_nan_gt_0(c_graphsSelectedPageID)) {
      this.a_graphs_set_creating_new_graph_tf(true);

      const newGraphSort = (c_graphsSelectedTabAllGraphsArrayOfObjs.length + 1);

      var fieldNamesArray = undefined;
      var valuesArray = undefined;
      var idsbArray = undefined;
      if(this.c_tabDailySnapshotTrueTrendAnalyzerFalse) {
        fieldNamesArray = this.graphs_daily_snapshot_graphs_field_names_array();
        valuesArray = this.graphs_daily_snapshot_graphs_create_new_values_array(c_graphsSelectedPageID, newGraphSort, o_userID);
        idsbArray = this.graphs_daily_snapshot_graphs_idsb_array();
      }
      else {
        fieldNamesArray = this.graphs_trend_analyzer_graphs_field_names_array();
        valuesArray = this.graphs_trend_analyzer_graphs_create_new_values_array(c_graphsSelectedPageID, newGraphSort, o_userID);
        idsbArray = this.graphs_trend_analyzer_graphs_idsb_array();
      }

      const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_create_new_graph", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      C_CallPhpTblUID.add_insert(this.c_graphsSelectedTabGraphsTblName, fieldNamesArray, valuesArray, idsbArray);

      const functionOnSuccess = (i_parseResponse) => {
        const newlyInsertedGraphID = i_parseResponse.outputObj.i0;
        this.a_graphs_set_editing_graph_id(newlyInsertedGraphID);
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

      const functionOnFinish = () => {
        this.a_graphs_set_creating_new_graph_tf(false);
      }
      C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

      C_CallPhpTblUID.execute();
    }
  }

  a_graphs_add_public_graph_as_replica_or_system_graph_as_new(i_publicSystemFlag, i_selectedPublicGraphDataObj) {
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabGraphsTblName = this.c_graphsSelectedTabGraphsTblName;
    const c_graphsSelectedTabAllGraphsArrayOfObjs = this.c_graphsSelectedTabAllGraphsArrayOfObjs;
    const c_graphsSelectedPageID = this.c_graphsSelectedPageID;
    const o_userID = UserMobx.o_userID;

    if(JSFUNC.is_number_not_nan_gt_0(c_graphsSelectedPageID)) { //make sure a valid page is currently selected so the new graph can be added to that page
      this.a_graphs_set_creating_new_graph_tf(true);

      const newGraphSort = (c_graphsSelectedTabAllGraphsArrayOfObjs.length + 1);

      var fieldNamesArray = undefined;
      var valuesArray = undefined;
      var idsbArray = undefined;

      //get field names and idsb for daily or trend graphs
      if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
        fieldNamesArray = this.graphs_daily_snapshot_graphs_field_names_array();
        idsbArray = this.graphs_daily_snapshot_graphs_idsb_array();
      }
      else {
        fieldNamesArray = this.graphs_trend_analyzer_graphs_field_names_array();
        idsbArray = this.graphs_trend_analyzer_graphs_idsb_array();
      }

      //set the values array based on public/system graph selection
      if(i_publicSystemFlag === "public") { //public graph is a 'replica' of the graph, with most field values being -1
        const publicGraphOriginalRowID = i_selectedPublicGraphDataObj.graphObj.id;
        if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
          valuesArray = this.graphs_daily_snapshot_graphs_replica_of_public_graph_values_array(c_graphsSelectedPageID, newGraphSort, publicGraphOriginalRowID);
        }
        else {
          valuesArray = this.graphs_trend_analyzer_graphs_replica_of_public_graph_values_array(c_graphsSelectedPageID, newGraphSort, publicGraphOriginalRowID);
        }
      }
      else if(i_publicSystemFlag === "system") { //system is a new graph created as a copy of the system graph
        valuesArray = [];
        for(let f = 0; f < fieldNamesArray.length; f++) {
          var fieldDbName = fieldNamesArray[f];

          //fill in the first 5 fields of both daily/trend graphs "page_id", "sort", "created_by_user_id", "public_01", "replica_of_graph_id",
          var systemValue = "";
          if(fieldDbName === "page_id") { systemValue = c_graphsSelectedPageID; }
          else if(fieldDbName === "sort") { systemValue = newGraphSort; }
          else if(fieldDbName === "created_by_user_id") { systemValue = o_userID; }
          else if(fieldDbName === "public_01") { systemValue = 0; }
          else if(fieldDbName === "replica_of_graph_id") { systemValue = -1; }
          else { systemValue = i_selectedPublicGraphDataObj.graphObj[fieldDbName]; } //otherwise pull the copied value from the input graphDataObj

          valuesArray.push(systemValue);
        }
      }

      const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_add_public_graph_as_replica_or_system_graph_as_new", ["i_selectedPublicGraphDataObj"], [i_selectedPublicGraphDataObj]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      C_CallPhpTblUID.add_insert(c_graphsSelectedTabGraphsTblName, fieldNamesArray, valuesArray, idsbArray);

      const functionOnFinish = () => {
        this.a_graphs_set_creating_new_graph_tf(false);
      }
      C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

      C_CallPhpTblUID.execute();
    }
  }


  a_graphs_set_creating_new_graph_tf(i_newValueTF) {
    this.o_graphsCreatingNewGraphTF = i_newValueTF;
  }

  a_graphs_set_creating_page_or_graph_selected_public_system_tab_db_name(i_newValueString) {
    this.o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName = i_newValueString;
  }
  
  a_graphs_set_editing_graph_id(i_editingGraphID) {
    this.o_graphsEditingGraphID = i_editingGraphID;
  }

  a_graphs_update_page_field(i_pageID, i_fieldDbName, i_newValue, i_fieldIdsb) {
    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_update_page_field", ["i_pageID", "i_fieldDbName", "i_newValue", "i_fieldIdsb"], [i_pageID, i_fieldDbName, i_newValue, i_fieldIdsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(this.c_graphsSelectedTabPagesTblName, i_pageID, i_fieldDbName, i_newValue, i_fieldIdsb);
    C_CallPhpTblUID.execute();
  }

  a_graphs_update_graph_field(i_editingGraphID, i_fieldDbName, i_newValue, i_fieldIdsb) {
    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_update_graph_field", ["i_editingGraphID", "i_fieldDbName", "i_newValue", "i_fieldIdsb"], [i_editingGraphID, i_fieldDbName, i_newValue, i_fieldIdsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(this.c_graphsSelectedTabGraphsTblName, i_editingGraphID, i_fieldDbName, i_newValue, i_fieldIdsb);
    C_CallPhpTblUID.execute();
  }

  a_graphs_copy_graph(i_graphDataObj, i_newCopiedGraphTitle) {
    var graphsTblName = undefined;
    var fieldNamesArray = undefined;
    var idsbArray = undefined;
    if(i_graphDataObj.circleGraphTrueTimeGraphFalse) {
      graphsTblName = "tbl_d_daily_snapshot_graphs";
      fieldNamesArray = this.graphs_daily_snapshot_graphs_field_names_array();
      idsbArray = this.graphs_daily_snapshot_graphs_idsb_array();
    }
    else {
      graphsTblName = "tbl_d_trend_analyzer_graphs";
      fieldNamesArray = this.graphs_trend_analyzer_graphs_field_names_array();
      idsbArray = this.graphs_trend_analyzer_graphs_idsb_array();
    }

    //if the graph being copied is a replica of a different public graph, try to load that graph so that this copy is editable by this user and is no longer a replica
    var referencedGraphMap = undefined; //undefined for non-replica graphs
    if(i_graphDataObj.graphObj.replica_of_graph_id > 0) { //this graph is a replica
      if(i_graphDataObj.circleGraphTrueTimeGraphFalse) {
        referencedGraphMap = DatabaseMobx.o_tbl_d_daily_snapshot_graphs.get(i_graphDataObj.graphObj.replica_of_graph_id);
      }
      else {
        referencedGraphMap = DatabaseMobx.o_tbl_d_trend_analyzer_graphs.get(i_graphDataObj.graphObj.replica_of_graph_id);
      }
    }

    //get all values to copy from i_graphDataObj looping over all graph tbl fields
    var valuesArray = [];
    for(let fieldName of fieldNamesArray) {
      var copyValue = i_graphDataObj.graphObj[fieldName];
      if(fieldName === "graph_title") {
        copyValue = i_newCopiedGraphTitle; //use the new graph title
      }
      else if(fieldName === "sort") {
        copyValue = i_graphDataObj.graphObj.sort; //make the new graph sort the previous sort, which resorts to be 1 space after the original
      }
      else if(fieldName === "page_id") {
        copyValue = i_graphDataObj.graphObj.page_id; //use the same pageID
      }
      else if(fieldName === "created_by_user_id") {
        copyValue = UserMobx.o_userID; //change creator of this graph to this user
      }
      else if(fieldName === "public_01") {
        copyValue = 0; //set this copied graph to private
      }
      else if(fieldName === "replica_of_graph_id") {
        copyValue = -1; //set this as a new graph, not a replica
      }
      else {
        if(referencedGraphMap !== undefined) { //this is a replica graph referencing a public graph that exists
          copyValue = referencedGraphMap.get(fieldName);
        }
      }
      valuesArray.push(copyValue);
    }

    const resortSortColumnName = "sort";
    const resortFilterFieldNameOrFieldNamesArray = "page_id";
    const resortFilterValueOrValuesArray = i_graphDataObj.graphObj.page_id;

    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_copy_graph", ["i_graphDataObj", "i_newCopiedGraphTitle"], [i_graphDataObj, i_newCopiedGraphTitle]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_insert(graphsTblName, fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);
    C_CallPhpTblUID.execute();
  }

  a_graphs_delete_graph(i_graphDataObj) {
    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_delete_graph", ["i_graphDataObj"], [i_graphDataObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //delete this graph
    const graphsTblName = this.c_graphsSelectedTabGraphsTblName;
    const graphRowID = i_graphDataObj.graphObj.id;
    var resortSortColumnName = "sort";
    var resortFilterFieldNameOrFieldNamesArray = "page_id";
    var resortFilterValueOrValuesArray = i_graphDataObj.graphObj.page_id;
    C_CallPhpTblUID.add_delete(graphsTblName, graphRowID, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

    //delete any graphs that are replicas using this graph as a reference
    const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(graphsTblName);
    for(let graphMap of tblRefMapOfMaps.values()) {
      if(graphMap.get("replica_of_graph_id") === graphRowID) {
        var resortSortColumnName = "sort";
        var resortFilterFieldNameOrFieldNamesArray = "page_id";
        var resortFilterValueOrValuesArray = graphMap.get("page_id");
        C_CallPhpTblUID.add_delete(graphsTblName, graphMap.get("id"), resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);
      }
    }

    C_CallPhpTblUID.execute();
  }

  a_graphs_move_graph_to_end_of_different_page_resort_original_page(i_draggedGraphID, i_droppedOnPageObj) {
    //find the dragged graph's original pageID
    const graphsTblName = this.c_graphsSelectedTabGraphsTblName;
    const tblRefMapOfMaps = DatabaseMobx.tbl_ref_from_tbl_name(graphsTblName);
    const draggedGraphMap = tblRefMapOfMaps.get(i_draggedGraphID);
    if(draggedGraphMap !== undefined) {
      const draggedGraphPageID = draggedGraphMap.get("page_id");

      //compute the new sort position of this graph on it's new page
      var newGraphSortNum = 1;
      for(let graphMap of tblRefMapOfMaps.values()) {
        if(graphMap.get("page_id") === i_droppedOnPageObj.id) {
          newGraphSortNum++;
        }
      }

      //change the page and sort of this graph row, resort the graphs from the original page
      const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_graphs_move_graph_to_end_of_different_page_resort_original_page", ["i_draggedGraphID", "i_droppedOnPageObj"], [i_draggedGraphID, i_droppedOnPageObj]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_update(graphsTblName, i_draggedGraphID, ["page_id", "sort"], [i_droppedOnPageObj.id, newGraphSortNum], ["i", "i"]);

      C_CallPhpTblUID.add_resort(graphsTblName, "sort", ["page_id"], [draggedGraphPageID]);

      C_CallPhpTblUID.execute();
    }
  }

  graphs_daily_snapshot_page_field_names_array() {
    return(["user_id", "sort", "created_by_user_id", "public_01", "replica_of_page_id", "name", "num_graphs_per_row", "graph_height_em"]);
  }

  graphs_daily_snapshot_page_idsb_array() {
    return(["i", "i", "i", "i", "i", "s", "i", "i"]);
  }

  graphs_trend_analyzer_page_field_names_array() {
    return(["user_id", "sort", "created_by_user_id", "public_01", "replica_of_page_id", "name", "num_graphs_per_row", "graph_height_em", "start_date", "end_date"]);
  }

  graphs_trend_analyzer_page_idsb_array() {
    return(["i", "i", "i", "i", "i", "s", "i", "i", "s", "s"]);
  }

  graphs_daily_snapshot_graphs_field_names_array() {
    return([
      "page_id", "sort", "created_by_user_id", "public_01", "replica_of_graph_id",
      "filter_preset_id", "categories_field_id", "all_categories_01", "categories_option_ids_comma", "categories_include_not_set_01",
      "categories_custom_colors_01", "categories_custom_colors_colon_comma_list", "graph_type_p0_vb1_hb2_f3", "legend_01", "legend_hide_zero_categories_01", 
      "num_captures_m2_or_money_field_id", "ignore_shared_percent_calcs_01", "y_axis_log_01", "graph_title"
    ]);
  }
  graphs_daily_snapshot_graphs_create_new_values_array(i_graphsSelectedPageID, i_newGraphSort, i_userID) {
    return([
      i_graphsSelectedPageID, i_newGraphSort, i_userID, 0, -1,
      -1, -1, 1, "", 1,
      0, "", 0, 1, 0, 
      -2, 0, 0, ""
    ]);
  }
  graphs_daily_snapshot_graphs_replica_of_public_graph_values_array(i_graphsSelectedPageID, i_newGraphSort, i_publicGraphOriginalRowID) {
    return([
      i_graphsSelectedPageID, i_newGraphSort, -1, -1, i_publicGraphOriginalRowID,
      -1, -1, -1, "", -1,
      -1, "", -1, -1, -1, 
      -2, -1, -1, ""
    ]);
  }
  graphs_daily_snapshot_graphs_idsb_array() {
    return([
      "i", "i", "i", "i", "i",
      "i", "i", "i", "s", "i",
      "i", "s", "i", "i", "i", 
      "i", "i", "i", "s"
    ]);
  }
  graphs_daily_snapshot_create_new_graph_obj() {
    const dailySnapshotFieldNamesArray = this.graphs_daily_snapshot_graphs_field_names_array();
    const dailySnapshotNewValuesArray = this.graphs_daily_snapshot_graphs_create_new_values_array(-1, -1, -1);
    var dailySnapshotCreateNewGraphObj = {};
    for(let f = 0; f < dailySnapshotFieldNamesArray.length; f++) {
      dailySnapshotCreateNewGraphObj[dailySnapshotFieldNamesArray[f]] = dailySnapshotNewValuesArray[f];
    }
    return(dailySnapshotCreateNewGraphObj);
  }

  graphs_trend_analyzer_graphs_field_names_array() {
    return([
      "page_id", "sort", "created_by_user_id", "public_01", "replica_of_graph_id",
      "filter_preset_id", "date_field_id", "use_categories_field_01", "categories_field_id", "all_categories_01",
      "categories_option_ids_comma", "categories_include_not_set_01", "categories_custom_colors_01", "categories_custom_colors_colon_comma_list", "line0_bar1", 
      "legend_01", "legend_hide_zero_categories_01", "num_captures_m2_or_money_field_id", "ignore_shared_percent_calcs_01", "time_bins", 
      "y_axis_log_01", "graph_title"
    ]);
  }
  graphs_trend_analyzer_graphs_create_new_values_array(i_graphsSelectedPageID, i_newGraphSort, i_userID) {
    return([
      i_graphsSelectedPageID, i_newGraphSort, i_userID, 0, -1,
      -1, -1, 0, -1, 1,
      "", 1, 0, "", 0, 
      1, 0, -2, 0, "yearly", 
      0, ""
    ]);
  }
  graphs_trend_analyzer_graphs_replica_of_public_graph_values_array(i_graphsSelectedPageID, i_newGraphSort, i_publicGraphOriginalRowID) {
    return([
      i_graphsSelectedPageID, i_newGraphSort, -1, -1, i_publicGraphOriginalRowID,
      -1, -1, -1, -1, -1,
      "", -1, -1, "", -1, 
      -1, -1, -2, -1, "", 
      -1, ""
    ]);
  }
  graphs_trend_analyzer_graphs_idsb_array() {
    return([
      "i", "i", "i", "i", "i",
      "i", "i", "i", "i", "i",
      "s", "i", "i", "s", "i", 
      "i", "i", "i", "i", "s", 
      "i", "s"
    ]);
  }
  graphs_trend_analyzer_create_new_graph_obj() {
    const trendAnalyzerFieldNamesArray = this.graphs_trend_analyzer_graphs_field_names_array();
    const trendAnalyzerNewValuesArray = this.graphs_trend_analyzer_graphs_create_new_values_array(-1, -1, -1);
    var trendAnalyzerCreateNewGraphObj = {};
    for(let f = 0; f < trendAnalyzerFieldNamesArray.length; f++) {
      trendAnalyzerCreateNewGraphObj[trendAnalyzerFieldNamesArray[f]] = trendAnalyzerNewValuesArray[f];
    }
    return(trendAnalyzerCreateNewGraphObj);
  }






  //hot bits
  a_hot_bits_set_selected_capture_field_id(i_captureFieldID) {
    this.o_hotBitsSelectedCaptureFieldIDOrUndefned = i_captureFieldID;
  }






  //critical thresholds
  a_critical_thresholds_set_selected_filter_capture_type_id(i_captureTypeID) {
    this.o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned = i_captureTypeID;
  }

  a_critical_thresholds_set_selected_graph_string(i_graphString) {
    this.o_criticalThresholdsSelectedGraphString = i_graphString;
  }





  //stage flow
  a_stage_flow_load_thin_log_stages() {
    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_stage_flow_load_thin_log_stages", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("loadStageFlowThinTblCLogStages", jsDescription);
    C_CallPhpScript.add_return_vars("thinTblCLogStagesArrayOfObjs");

    const functionOnSuccess = (i_parseResponse) => {
      this.a_stage_flow_set_thin_tbl_c_log_stages_arrayOfObjs(i_parseResponse.thinTblCLogStagesArrayOfObjs);
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    if(CaptureExecMobx.c_computedUrlAndProductObj.isLocalhost3000SystemTF) {
      //The localhost path skips PHP, so provide the development changelog as its fake response.
      var thinTblCLogStagesArrayOfObjs = [];
      for(let logStageMap of DatabaseMobx.o_tbl_c_log_stages.values()) {
        if(logStageMap.get("action_cs0_grreq1_grapp2_grrej3_grcan4") === 0) {
          thinTblCLogStagesArrayOfObjs.push({
            ci:logStageMap.get("capture_id"),
            si:logStageMap.get("stage_id")
          });
        }
      }
      C_CallPhpScript.execute({thinTblCLogStagesArrayOfObjs:thinTblCLogStagesArrayOfObjs});
    }
    else {
      C_CallPhpScript.execute();
    }
  }

  a_stage_flow_set_thin_tbl_c_log_stages_arrayOfObjs(i_thinTblCLogStagesArrayOfObjs) {
    this.o_stageFlowThinTblCLogStagesArrayOfObjs = i_thinTblCLogStagesArrayOfObjs;
  }

  a_stage_flow_set_selected_filter_capture_type_id(i_captureTypeID) {
    this.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined = i_captureTypeID;
  }

  a_stage_flow_set_selected_filter_stage_type_string(i_stageTypeString) {
    this.o_stageFlowSelectedFilterStageTypeString = i_stageTypeString;
  }


  //gate review approvals
  a_gate_review_approvals_load_log_stages() {
    this.a_gate_review_approvals_set_is_loading_tf(true);

    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_gate_review_approvals_load_log_stages", [], []);
    const C_CallPhpScript = new JSPHP.ClassCallPhpScript("loadAllGateReviewActionsTblCLogStages", jsDescription);
    C_CallPhpScript.add_return_vars("gateReviewLogStagesArrayOfObjs");

    const functionOnSuccess = (i_parseResponse) => {
      this.a_gate_review_approvals_set_log_stages_arrayOfObjs(i_parseResponse.gateReviewLogStagesArrayOfObjs);
      this.a_gate_review_approvals_set_is_loading_tf(false);
    }
    C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

    const functionOnError = () => {
      this.a_gate_review_approvals_set_is_loading_tf(false);
    }
    C_CallPhpScript.add_function("onError", functionOnError);

    C_CallPhpScript.execute();
  }

  a_gate_review_approvals_set_log_stages_arrayOfObjs(i_gateReviewLogStagesArrayOfObjs) {
    this.o_gateReviewApprovalsLogStagesArrayOfObjs = i_gateReviewLogStagesArrayOfObjs;
  }

  a_gate_review_approvals_set_is_loading_tf(i_newValueTF) {
    this.o_gateReviewApprovalsIsLoadingTF = i_newValueTF;
  }

  a_gate_review_approvals_set_action_pending_obj(i_objOrUndefined) {
    this.o_gateReviewApprovalsActionPendingObjOrUndefined = i_objOrUndefined;
  }

  a_gate_review_approvals_approve_or_reject(i_pendingRequestObj, i_action2App3Rej, i_gateReviewActionComment, i_functionAdvanceCaptureIntoStageOnApproval) {
    //i_functionAdvanceCaptureIntoStageOnApproval(i_captureID, i_stageID) is injected from DivexecReact to call OpenCaptureMobx without creating a circular import between DivexecMobx and OpenCaptureMobx
    const o_gateReviewApprovalsLogStagesArrayOfObjs = this.o_gateReviewApprovalsLogStagesArrayOfObjs;

    const captureID = i_pendingRequestObj.captureID;
    const stageID = i_pendingRequestObj.stageID;

    const jsDescription = JSFUNC.js_description_from_action("DivexecMobx", "a_gate_review_approvals_approve_or_reject", ["captureID", "stageID", "i_action2App3Rej", "i_gateReviewActionComment"], [captureID, stageID, i_action2App3Rej, i_gateReviewActionComment]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_changelog_stages(captureID, stageID, i_action2App3Rej, i_gateReviewActionComment);

    //every user who has already taken a Gate Review action on this capture/stage is notified of this decision (which includes the user who made the request)
    var priorGateReviewActionUserIDsArray = [];
    if(JSFUNC.is_array(o_gateReviewApprovalsLogStagesArrayOfObjs)) {
      for(let gateReviewLogObj of o_gateReviewApprovalsLogStagesArrayOfObjs) {
        if((gateReviewLogObj.capture_id === captureID) && (gateReviewLogObj.stage_id === stageID)) {
          if(!JSFUNC.in_array(gateReviewLogObj.user_id, priorGateReviewActionUserIDsArray)) {
            priorGateReviewActionUserIDsArray.push(gateReviewLogObj.user_id);
          }
        }
      }
    }

    //notify every user affected by this Gate Review decision (designated approval divexecs, capture managers, and anyone who previously acted on this Gate Review)
    C_CallPhpTblUID.add_gate_review_action_notifications(captureID, stageID, i_action2App3Rej, i_gateReviewActionComment, i_pendingRequestObj.gateReviewName, i_pendingRequestObj.approvalDivexecUserIDsArray, priorGateReviewActionUserIDsArray);

    const functionOnSuccess = () => {
      this.a_gate_review_approvals_load_log_stages(); //reload the gate review action rows so that this decision is removed from the pending approvals list
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.execute();

    //an approved Gate Review automatically moves the capture into the stage that the Gate Review was set on
    if((i_action2App3Rej === 2) && JSFUNC.is_function(i_functionAdvanceCaptureIntoStageOnApproval)) {
      i_functionAdvanceCaptureIntoStageOnApproval(captureID, stageID);
    }

    this.a_gate_review_approvals_set_action_pending_obj(undefined);
  }


}
export default new DivexecMobx();
